import * as n from "react";
import { Component as vr, useState as A, useRef as B, useEffect as U, useLayoutEffect as $e, isValidElement as un, cloneElement as _a, forwardRef as io, useContext as Ln, createContext as jn, useMemo as ke, useCallback as re, Fragment as uo, Children as aa, createRef as mo } from "react";
import { createPortal as pa } from "react-dom";
import { c as fo, a as _o, t as kr, b as po, f as yo } from "./format-CVedM0M8.js";
const bo = "_page_1l6cf_5", Eo = "_inner_1l6cf_25", ho = "_pageScroll_1l6cf_38", go = "_innerScroll_1l6cf_39", En = {
  page: bo,
  inner: Eo,
  pageScroll: ho,
  innerScroll: go
}, c0 = { width: 1920, height: 1080 }, i0 = { width: 1280, height: 720 }, vo = 64, u0 = { collapsed: 64, pinned: 240 }, m0 = { width: 1856, height: 1016 }, d0 = { width: 1216, height: 656 }, f0 = { width: 1040, height: 656 }, An = 1024, wr = An;
function ko(e) {
  const t = e != null ? e : An;
  return !Number.isFinite(t) || t <= 0 ? An : Math.min(t, wr);
}
const Da = /* @__PURE__ */ new Set();
function wo(e, t) {
  typeof location == "undefined" || !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname) || Da.has(e) || (Da.add(e), console.warn(`[AXErpPage] minWidth ${e} → ${t} (표준 상한 ${wr}). 넓은 표는 minWidth 가 아니라 그리드 스트립에 맡긴다 — docs/ERP_화면_표준_사이즈.md`));
}
function No({
  gnbHeight: e = vo,
  minWidth: t = An,
  scroll: a = "grid",
  className: r = "",
  style: o,
  children: s
}) {
  const l = a === "page", c = ko(t);
  return c !== t && wo(t, c), /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [En.page, l && En.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ n.createElement("div", { className: [En.inner, l && En.innerScroll].filter(Boolean).join(" "), style: { minWidth: c } }, s)
  );
}
const $o = "_body_1wgsn_4", xo = {
  body: $o
};
function _0({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [xo.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const Do = "_orbitPortalRoot_177qv_2", Ao = {
  orbitPortalRoot: Do
};
class Vt extends vr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || Ao.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return pa(this.props.children, this.getPortalRoot());
  }
}
const Co = "_anchor_7h2m7_2", So = "_tip_7h2m7_5", Aa = {
  anchor: Co,
  tip: So
};
let Mo = 0;
function It({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: o,
  describe: s = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = A(!1), [u, f] = A({ top: 0, left: 0 }), _ = B(null), p = B(null), y = B(null), d = B("");
  d.current || (d.current = `axe-tip-${++Mo}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, N = (h) => {
    b(), h <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), h);
  }, $ = () => {
    b(), m(!1);
  };
  U(() => b, []), $e(() => {
    if (!i) return;
    const h = () => {
      const w = _.current, E = p.current;
      if (!w || !E) return;
      const D = w.getBoundingClientRect(), C = E.offsetHeight, T = E.offsetWidth;
      let M = a === "top" ? D.top - C - 6 : D.bottom + 6;
      a === "bottom" && M + C > window.innerHeight - 4 && D.top - C - 6 > 4 && (M = D.top - C - 6), a === "top" && M < 4 && D.bottom + 6 + C < window.innerHeight - 4 && (M = D.bottom + 6);
      const I = Math.max(4, Math.min(D.left + D.width / 2 - T / 2, window.innerWidth - T - 4));
      f((q) => q.top === M && q.left === I ? q : { top: M, left: I });
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("scroll", h, !0), () => {
      window.removeEventListener("resize", h), window.removeEventListener("scroll", h, !0);
    };
  }, [i, a, e]), U(() => {
    if (!i) return;
    const h = (w) => {
      w.key !== "Escape" || w.isComposing || (w.preventDefault(), w.stopPropagation(), $());
    };
    return document.addEventListener("keydown", h, !0), () => document.removeEventListener("keydown", h, !0);
  }, [i]);
  const g = e != null && e !== !1 && e !== "";
  if (!g && !c) return t;
  const x = g && un(t) ? _a(t, i && s ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: _,
      className: [Aa.anchor, l].filter(Boolean).join(" "),
      tabIndex: o ? 0 : void 0,
      onMouseEnter: () => {
        g && N(r);
      },
      onMouseLeave: $,
      onFocus: () => {
        g && N(0);
      },
      onBlur: $
    },
    x,
    g && i && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: p,
        id: d.current,
        role: "tooltip",
        className: Aa.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: $
      },
      e
    ))
  );
}
const To = "_bar_gkpv7_1", qo = "_menu_gkpv7_17", Bo = "_title_gkpv7_27", Lo = "_info_gkpv7_29", jo = "_badge_gkpv7_37", Io = "_badge_muted_gkpv7_38", Ro = "_badge_ok_gkpv7_39", Po = "_badge_warn_gkpv7_40", Oo = "_meta_gkpv7_42", zo = "_actions_gkpv7_26", Xo = "_notice_gkpv7_59", Fo = "_notice_info_gkpv7_65", Wo = "_notice_ok_gkpv7_66", Ho = "_notice_err_gkpv7_67", Ge = {
  bar: To,
  menu: qo,
  title: Bo,
  info: Lo,
  badge: jo,
  badge_muted: Io,
  badge_ok: Ro,
  badge_warn: Po,
  meta: Oo,
  actions: zo,
  notice: Xo,
  notice_info: Fo,
  notice_ok: Wo,
  notice_err: Ho
};
function Ko({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: o,
  notice: s,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(It, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), o && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, o), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, s && s.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const Uo = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Go = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Yo({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Go[e]);
}
function mn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Uo[e]
  );
}
const Vo = "_btn_q02rt_1", Qo = "_sm_q02rt_18", Jo = "_primary_q02rt_21", Zo = "_dark_q02rt_23", es = "_danger_q02rt_25", ts = "_soon_q02rt_29", ns = "_soonTag_q02rt_30", as = "_blocked_q02rt_39", rs = "_kbd_q02rt_51", os = "_iconBtn_q02rt_54", ss = "_link_q02rt_70", it = {
  btn: Vo,
  sm: Qo,
  primary: Jo,
  dark: Zo,
  danger: es,
  soon: ts,
  soonTag: ns,
  blocked: as,
  kbd: rs,
  iconBtn: os,
  link: ss
}, et = io(function(t, a) {
  const {
    variant: r = "default",
    size: o = "md",
    icon: s,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: m,
    className: u = "",
    type: f = "button",
    onClick: _,
    title: p,
    disabled: y,
    ...d
  } = t, b = c || i || "", N = b !== "", $ = "blockedReason" in t, g = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: f,
      className: [it.btn, it[r], o === "sm" ? it.sm : "", c ? it.soon : N ? it.blocked : "", u].filter(Boolean).join(" "),
      "aria-disabled": N ? !0 : void 0,
      disabled: N ? void 0 : y,
      title: N ? void 0 : p,
      onClick: N ? (x) => x.preventDefault() : _,
      ...d
    },
    s && /* @__PURE__ */ n.createElement(mn, { name: s, size: o === "sm" ? 12 : 14 }),
    m,
    l && /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: it.soonTag }, "준비 중")
  );
  return N || $ ? /* @__PURE__ */ n.createElement(It, { content: b, keepWrapper: $ }, g) : g;
});
function ra({ label: e, children: t, className: a = "", type: r = "button", ...o }) {
  return /* @__PURE__ */ n.createElement(It, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [it.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...o
    },
    t
  ));
}
function ya({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [it.link, t].filter(Boolean).join(" "), ...r }, e);
}
const ls = "_wrap_10shm_1", cs = "_btn_10shm_2", is = "_on_10shm_6", us = "_caret_10shm_8", ms = "_pop_10shm_9", ds = "_sec_10shm_14", fs = "_item_10shm_17", _s = "_danger_10shm_24", _t = {
  wrap: ls,
  btn: cs,
  on: is,
  caret: us,
  pop: ms,
  sec: ds,
  item: fs,
  danger: _s
}, ps = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), p0 = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function ys({ label: e, entries: t, disabled: a, title: r }) {
  const [o, s] = A(!1), l = B(null), c = B(null), i = B(null), m = () => {
    var f, _;
    return Array.from((_ = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  U(() => {
    var f;
    o && ((f = m()[0]) == null || f.focus());
  }, [o]), U(() => {
    if (!o) return;
    const f = (p) => {
      l.current && !l.current.contains(p.target) && s(!1);
    }, _ = (p) => {
      var y;
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), s(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", _, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", _, !0);
    };
  }, [o]);
  const u = (f) => {
    const _ = m();
    if (_.length === 0) return;
    const p = _.indexOf(document.activeElement);
    let y = -1;
    if (f.key === "ArrowDown") y = (p + 1) % _.length;
    else if (f.key === "ArrowUp") y = (p <= 0 ? _.length : p) - 1;
    else if (f.key === "Home") y = 0;
    else if (f.key === "End") y = _.length - 1;
    else if (f.key === "Tab") {
      s(!1);
      return;
    } else return;
    f.preventDefault(), _[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: _t.wrap, ref: l }, /* @__PURE__ */ n.createElement(It, { content: o ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [_t.btn, o ? _t.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": o,
      onClick: () => s((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !o && (f.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: _t.caret, "aria-hidden": "true" }, "▾")
  )), o && /* @__PURE__ */ n.createElement("div", { ref: i, className: _t.pop, role: "menu", onKeyDown: u }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: _t.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [_t.item, f.danger ? _t.danger : ""].join(" "),
      onClick: () => {
        var _;
        s(!1), (_ = c.current) == null || _.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
const bs = "_pop_12uut_2", Es = "_auto_12uut_12", hs = "_head_12uut_13", gs = "_title_12uut_18", vs = "_close_12uut_19", ks = "_body_12uut_21", ws = "_flush_12uut_22", Ns = "_foot_12uut_23", pt = {
  pop: bs,
  auto: Es,
  head: hs,
  title: gs,
  close: vs,
  body: ks,
  flush: ws,
  foot: Ns
}, hn = 8;
function y0({
  x: e,
  y: t,
  title: a,
  ariaLabel: r,
  onClose: o,
  children: s,
  footer: l,
  closeLabel: c = "닫기",
  width: i,
  closeOnScroll: m = !1,
  flush: u = !1,
  initialFocus: f,
  className: _
}) {
  const p = B(null), [y, d] = A({ left: e, top: t }), b = B(o);
  b.current = o;
  const N = () => {
    const g = p.current;
    if (!g) return;
    const x = g.offsetWidth, h = g.offsetHeight, w = Math.max(hn, Math.min(e, window.innerWidth - x - hn)), E = t + h > window.innerHeight - hn ? Math.max(hn, t - h - 32) : t;
    d((D) => D.left === w && D.top === E ? D : { left: w, top: E });
  };
  $e(N, [e, t]), U(() => {
    const g = p.current;
    if (!g || typeof ResizeObserver == "undefined") return;
    const x = new ResizeObserver(N);
    return x.observe(g), () => x.disconnect();
  }, [e, t]), U(() => {
    const g = (E) => {
      p.current && !p.current.contains(E.target) && b.current(!1);
    }, x = (E) => {
      E.key === "Escape" && (E.stopPropagation(), b.current(!0));
    }, h = (E) => {
      var D;
      (!(E.target instanceof Node) || !((D = p.current) != null && D.contains(E.target))) && b.current(!1);
    }, w = window.setTimeout(() => document.addEventListener("mousedown", g), 0);
    return document.addEventListener("keydown", x, !0), m && window.addEventListener("scroll", h, !0), () => {
      window.clearTimeout(w), document.removeEventListener("mousedown", g), document.removeEventListener("keydown", x, !0), window.removeEventListener("scroll", h, !0);
    };
  }, [m]), U(() => {
    var g, x;
    f && ((x = (g = p.current) == null ? void 0 : g.querySelector(f)) == null || x.focus());
  }, [f]);
  const $ = /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: p,
      className: `${pt.pop}${i ? "" : ` ${pt.auto}`}${_ ? ` ${_}` : ""}`,
      style: { left: y.left, top: y.top, ...i ? { width: i } : null },
      role: "dialog",
      "aria-label": r
    },
    /* @__PURE__ */ n.createElement("div", { className: pt.head }, /* @__PURE__ */ n.createElement("span", { className: pt.title }, a), /* @__PURE__ */ n.createElement("button", { type: "button", className: pt.close, onClick: () => b.current(!0), "aria-label": c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: `${pt.body}${u ? ` ${pt.flush}` : ""}` }, s),
    l != null && /* @__PURE__ */ n.createElement("div", { className: pt.foot }, l)
  );
  return typeof document == "undefined" ? $ : pa($, document.body);
}
const $s = "_panel_pg53c_2", xs = "_head_pg53c_3", Ds = "_kicker_pg53c_4", As = "_actions_pg53c_5", Cs = "_link_pg53c_6", Ss = "_menuHits_pg53c_8", Ms = "_turns_pg53c_11", Ts = "_turn_pg53c_11", qs = "_q_pg53c_13", Bs = "_a_pg53c_5", Ls = "_aText_pg53c_15", js = "_step_pg53c_16", Is = "_caret_pg53c_17", Rs = "_err_pg53c_19", Me = {
  panel: $s,
  head: xs,
  kicker: Ds,
  actions: As,
  link: Cs,
  menuHits: Ss,
  turns: Ms,
  turn: Ts,
  q: qs,
  a: Bs,
  aText: Ls,
  step: js,
  caret: Is,
  err: Rs
};
function b0({ turns: e, busy: t, menuHits: a, onNavigate: r, onReset: o, onClose: s, labels: l }) {
  const c = B(null), i = e.length ? e[e.length - 1].answer.length : 0;
  return U(() => {
    var m;
    (m = c.current) == null || m.scrollIntoView({ block: "nearest" });
  }, [e.length, i]), /* @__PURE__ */ n.createElement("section", { className: Me.panel, "aria-live": "polite" }, /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.kicker }, l.kicker), /* @__PURE__ */ n.createElement("span", { className: Me.actions }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: o, disabled: t }, l.reset), /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: s, "aria-label": l.closePanel }, l.close))), a.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Me.menuHits }, /* @__PURE__ */ n.createElement("span", null, l.relatedMenus), a.map((m) => /* @__PURE__ */ n.createElement("button", { type: "button", key: m.path, onClick: () => r(m.path) }, m.label, " ↗"))), /* @__PURE__ */ n.createElement("div", { className: Me.turns }, e.map((m) => {
    var u;
    return /* @__PURE__ */ n.createElement("article", { key: m.id, className: Me.turn }, /* @__PURE__ */ n.createElement("div", { className: Me.q }, m.question), /* @__PURE__ */ n.createElement("div", { className: Me.a }, m.answer && /* @__PURE__ */ n.createElement("div", { className: Me.aText }, m.answer), m.streaming && /* @__PURE__ */ n.createElement("div", { className: Me.step }, (u = m.step) != null ? u : m.answer ? "" : l.waiting, /* @__PURE__ */ n.createElement("span", { className: Me.caret })), m.error && /* @__PURE__ */ n.createElement("div", { className: Me.err }, m.error)));
  }), /* @__PURE__ */ n.createElement("div", { ref: c })));
}
function E0(e, t, a = !0) {
  const r = B(t);
  r.current = t, U(() => {
    if (!a) return;
    const o = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (s.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [e, a]);
}
function Ps() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Os = "_bar_1g564_2", zs = "_sticky_1g564_12", Xs = "_start_1g564_19", Fs = "_end_1g564_20", Ws = "_status_1g564_22", Hs = "_dirty_1g564_23", Ks = "_kbd_1g564_25", xt = {
  bar: Os,
  sticky: zs,
  start: Xs,
  end: Fs,
  status: Ws,
  dirty: Hs,
  kbd: Ks
};
function h0({ start: e, children: t, status: a, dirty: r, inline: o, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", xt.bar, o ? "" : xt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: xt.start }, e), /* @__PURE__ */ n.createElement("span", { className: xt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [xt.status, r ? xt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, s && /* @__PURE__ */ n.createElement("kbd", { className: xt.kbd }, Ps())));
}
const Us = "_root_j67qt_2", Gs = "_closed_j67qt_3", Ys = "_tab_j67qt_6", Vs = "_collapse_j67qt_7", Qs = "_body_j67qt_16", Js = "_card_j67qt_32", Zs = "_head_j67qt_37", el = "_cardOpen_j67qt_44", tl = "_headBtn_j67qt_47", nl = "_icon_j67qt_56", al = "_badge_j67qt_57", rl = "_trailing_j67qt_58", ol = "_chev_j67qt_59", sl = "_panelWrap_j67qt_63", ll = "_panelOpen_j67qt_67", cl = "_panelBody_j67qt_68", il = "_panelInner_j67qt_69", ul = "_panelSettled_j67qt_70", ge = {
  root: Us,
  closed: Gs,
  tab: Ys,
  collapse: Vs,
  body: Qs,
  card: Js,
  head: Zs,
  cardOpen: el,
  headBtn: tl,
  icon: nl,
  badge: al,
  trailing: rl,
  chev: ol,
  panelWrap: sl,
  panelOpen: ll,
  panelBody: cl,
  panelInner: il,
  panelSettled: ul
}, ml = 1280, dl = 8, Nr = "axe-side-bar:";
function fl(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(Nr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function _l(e, t) {
  if (e)
    try {
      window.localStorage.setItem(Nr + e, t ? "1" : "0");
    } catch {
    }
}
function g0({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = ml,
  storageKey: o,
  className: s = "",
  children: l
}) {
  var _;
  const c = B(fl(o)), [i, m] = A((_ = c.current) != null ? _ : t), u = B(c.current !== null);
  if (U(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      u.current || m(!p.matches && t);
    };
    return y(), p.addEventListener ? p.addEventListener("change", y) : p.addListener(y), () => {
      p.removeEventListener ? p.removeEventListener("change", y) : p.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    u.current = !0, _l(o, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ge.root, i ? "" : ge.closed, s].filter(Boolean).join(" "),
      style: { width: i ? a : dl }
    },
    /* @__PURE__ */ n.createElement("div", { className: ge.tab }, /* @__PURE__ */ n.createElement(It, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ge.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Yo, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ge.body }, l)
  );
}
const $r = jn(null);
function v0({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, o] = A(t);
  return a ? /* @__PURE__ */ n.createElement($r.Provider, { value: { openId: r, setOpenId: o } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const xr = "axe-side-panel:";
function pl(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(xr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function yl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(xr + e, t ? "1" : "0");
    } catch {
    }
}
function k0({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: o,
  trailing: s,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var h;
  const u = Ln($r), f = !!u && c != null, _ = B(pl(l)), [p, y] = A((h = _.current) != null ? h : a), d = f ? u.openId === c : p, [b, N] = A(d), [$, g] = A(d);
  if (!t) return null;
  d && !b && N(!0);
  const x = () => {
    const w = !d;
    yl(l, w), N(!0), g(!1), f ? u.setOpenId(w ? c : null) : y(w);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ge.card, d ? ge.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ge.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ge.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), o && /* @__PURE__ */ n.createElement("span", { className: ge.badge }, o), s && /* @__PURE__ */ n.createElement("span", { className: ge.trailing, onClick: (w) => w.stopPropagation() }, s), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ge.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ge.panelWrap, d ? ge.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (w) => {
        w.target === w.currentTarget && w.propertyName === "grid-template-rows" && g(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ge.panelBody, d && $ ? ge.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ge.panelInner }, m))
  ));
}
const bl = "_guide_qnh7l_1", El = "_title_qnh7l_5", hl = "_desc_qnh7l_6", gl = "_act_qnh7l_7", vl = "_why_qnh7l_13", kl = "_steps_qnh7l_14", wl = "_no_qnh7l_20", Nl = "_cur_qnh7l_24", $l = "_link_qnh7l_26", at = {
  guide: bl,
  title: El,
  desc: hl,
  act: gl,
  why: vl,
  steps: kl,
  no: wl,
  cur: Nl,
  link: $l
};
function w0({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: at.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: at.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: at.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: at.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: at.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: at.steps }, r.map((o, s) => /* @__PURE__ */ n.createElement("li", { key: o.label, className: o.current ? at.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: at.no }, s + 1), o.onClick && !o.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: at.link, onClick: o.onClick }, o.label) : /* @__PURE__ */ n.createElement("span", null, o.label), o.hint && /* @__PURE__ */ n.createElement("small", null, o.hint)))));
}
const xl = "_list_1w2rs_1", Dl = "_row_1w2rs_2", Al = "_label_1w2rs_6", Cl = "_value_1w2rs_7", Sl = "_emphasis_1w2rs_8", Ml = "_changed_1w2rs_10", zt = {
  list: xl,
  row: Dl,
  label: Al,
  value: Cl,
  emphasis: Sl,
  changed: Ml
};
function N0({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [zt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [zt.row, a.emphasis ? zt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: zt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [zt.value, a.changed ? zt.changed : ""].join(" ") }, a.value))));
}
const Tl = "_underline_xl221_2", ql = "_active_xl221_24", Bl = "_segmented_xl221_33", Wn = {
  underline: Tl,
  active: ql,
  segmented: Bl
};
function Dr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: o = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Wn.segmented : Wn.underline, o].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Wn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Ll = "_bar_1adxf_1", jl = "_actions_1adxf_17", Il = "_field_1adxf_24", Rl = "_fieldLabel_1adxf_25", Pl = "_readout_1adxf_33", Ol = "_search_1adxf_44", zl = "_detail_1adxf_58", Xl = "_pill_1adxf_71", Fl = "_hint_1adxf_82", Ve = {
  bar: Ll,
  actions: jl,
  field: Il,
  fieldLabel: Rl,
  readout: Pl,
  search: Ol,
  detail: zl,
  pill: Xl,
  hint: Fl
}, Wl = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Hl(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Wl.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function $0({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: o,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  onReset: i,
  resetLabel: m = "초기화",
  resetDisabled: u,
  trailing: f,
  enterSearch: _ = !0
}) {
  const p = (y) => {
    !_ || !t || r || !Hl(y) || (y.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: Ve.bar, onKeyDown: p }, e, /* @__PURE__ */ n.createElement("span", { className: Ve.actions }, f, i && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: i, disabled: u }, m), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(It, { content: o, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Kl({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: Ve.field }, /* @__PURE__ */ n.createElement("span", { className: Ve.fieldLabel }, e), t);
}
function x0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.readout }, e);
}
function D0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.pill, role: "status" }, e);
}
function A0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.hint }, e);
}
function Ul(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function C0({ rows: e, value: t, onChange: a, disabled: r, label: o = "기수" }) {
  return /* @__PURE__ */ n.createElement(Kl, { label: o }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": o,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ n.createElement("option", { key: s.gisu, value: s.gisu }, Ul(s)))
  ));
}
class Ar {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const o of r) {
            const s = o.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, o);
          }
        } catch (o) {
          console.error(o);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function ba(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function Ea(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function Cr(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Gl(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function Sr(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Yl(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => Sr(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let o = [], s = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(o), o = [], s = [], a.push(c);
      return;
    }
    for (; s.length && s[s.length - 1].level >= l.level; ) s.pop();
    const i = { i: c, kids: [] };
    (s.length ? s[s.length - 1].node.kids : o).push(i), s.push({ level: l.level, node: i });
  }), r(o), a;
}
function Vl(e, t) {
  const a = new Set(t), r = e.filter((s) => a.has(s)), o = new Set(r);
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    if (o.has(l)) continue;
    const c = s + 1 < t.length ? r.indexOf(t[s + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), o.add(l);
  }
  return r;
}
function Ql(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), o = [], s = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = o.length;
    for (; m < u; ) {
      const f = m + u >> 1;
      r[o[f]] < c ? m = f + 1 : u = f;
    }
    m > 0 && (s[i] = o[m - 1]), o[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = o.length ? o[o.length - 1] : -1; c >= 0; c = s[c]) l.add(e[c]);
  return l;
}
const Jl = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', Zl = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function ec(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((s, l) => {
      s <= 1 ? a.delete(l) : a.set(l, s - 1);
    });
    let o = 0;
    for (const s of Array.from(r.cells)) {
      for (; a.has(o); ) o += 1;
      const l = s.colSpan || 1;
      if (t.set(s, o), s.rowSpan > 1) for (let c = o; c < o + l; c += 1) a.set(c, s.rowSpan);
      o += l;
    }
  }
  return t;
}
function tc(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = ec(Array.from(t.rows)), r = [];
  return a.forEach((o, s) => {
    var c, i;
    if (s.tagName !== "TH" || (s.colSpan || 1) !== 1 || s.dataset.sortable === "false" || s.hasAttribute("aria-sort") && s.dataset.axeSort === void 0 || s.querySelector(Jl)) return;
    const l = ((c = s.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: s, col: o, key: (i = s.dataset.sortKey) != null ? i : String(o), label: l });
  }), r;
}
function Ca(e, t) {
  var r;
  let a = 0;
  for (const o of Array.from(e.cells)) {
    const s = o.colSpan || 1;
    if (t < a + s) {
      const l = o.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = o.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Gl(c ? c.value : (r = o.textContent) != null ? r : "");
    }
    a += s;
  }
  return null;
}
function nc(e) {
  if (e.matches(Zl) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function ac() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function rc(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((o) => Array.from(o.cells).some((s) => s.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const Mr = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function oc(e, t, a) {
  if (Mr(t, a)) return;
  const r = Ql(t, a);
  let o = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    r.has(l) || e.insertBefore(l, o), o = l;
  }
}
function sc(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? Ca(c.rows[0], a) : null }));
    return l.sort((c, i) => Sr(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const o = e, s = o.map((l) => {
    const c = nc(l);
    return { level: c, value: c === null ? null : Ca(l, a) };
  });
  return Yl(s, r).map((l) => o[l]);
}
function lc(e, t, a) {
  const r = rc(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const o = r.items, s = t ? `${t.col}:${t.dir}` : "";
  if (s === a.sig && Mr(o, a.shown)) return;
  a.base = a.sig ? Vl(a.base, o) : o;
  let l = t ? sc(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && s === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  oc(r.parent, l, o), a.shown = l, a.sig = s;
}
const cc = "input, select, textarea, button";
function ic(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const o = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), s = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    o !== "" && !r.querySelector(cc) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: o, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || s) && (r.getAttribute("title") !== o && r.setAttribute("title", o), r.dataset.axeTitle !== o && (r.dataset.axeTitle = o))) : s && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const Tr = jn(null), uc = "_card_1j6er_2", mc = "_grow_1j6er_24", dc = "_head_1j6er_26", fc = "_title_1j6er_35", _c = "_trailing_1j6er_36", pc = "_scroll_1j6er_6", yc = "_foot_1j6er_54", bc = "_strip_1j6er_56", Ec = "_pager_1j6er_58", hc = "_spacer_1j6er_60", gc = "_table_1j6er_62", vc = "_fixed_1j6er_63", kc = "_fz_1j6er_81", wc = "_fzEdge_1j6er_93", Nc = "_frozen_1j6er_100", $c = "_sr_1j6er_162", xc = "_statusCell_1j6er_43", Dc = "_status_1j6er_43", Ac = "_st_error_1j6er_244", Cc = "_stIcon_1j6er_245", Sc = "_spin_1j6er_251", Mc = "_axeSpin_1j6er_1", Tc = "_busy_1j6er_261", qc = "_statusRow_1j6er_263", Bc = "_busyBar_1j6er_264", Lc = "_axeBusy_1j6er_1", ce = {
  card: uc,
  grow: mc,
  head: dc,
  title: fc,
  trailing: _c,
  scroll: pc,
  foot: yc,
  strip: bc,
  pager: Ec,
  spacer: hc,
  table: gc,
  fixed: vc,
  fz: kc,
  fzEdge: wc,
  frozen: Nc,
  sr: $c,
  statusCell: xc,
  status: Dc,
  st_error: Ac,
  stIcon: Cc,
  spin: Sc,
  axeSpin: Mc,
  busy: Tc,
  statusRow: qc,
  busyBar: Bc,
  axeBusy: Lc
}, jc = 120;
function Ic(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * jc : void 0;
}
function Sa({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ut = /* @__PURE__ */ new Set();
function ha() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function Rc(e) {
  if (!ha() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var o;
    return (o = r.textContent) == null ? void 0 : o.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ut.has(a) || (Ut.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Pc(e) {
  if (!ha()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var o, s;
    r.scrollWidth > r.clientWidth + 1 && t.push((s = (o = r.textContent) == null ? void 0 : o.trim()) != null ? s : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ut.has(a) || (Ut.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Oc(e) {
  if (!ha() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ut.has(t)) return;
  Ut.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function Ma(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const o of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let s = 0;
    for (const l of Array.from(o.cells)) {
      for (; r.has(s); ) s += 1;
      const c = l.colSpan || 1, i = t > 0 && s + c <= t;
      if (l.classList.toggle(ce.fz, i), l.classList.toggle(ce.fzEdge, i && s + c === t), l.style.left = i ? `${a[s]}px` : "", l.rowSpan > 1) for (let m = s; m < s + c; m += 1) r.set(m, l.rowSpan);
      s += c;
    }
  }
}
function zc({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: o,
  grow: s,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: f = !0,
  sort: _,
  onSort: p,
  manualSort: y,
  className: d = "",
  children: b
}) {
  const N = l || e !== void 0 && e.length > 0, $ = N ? Ic(e) : void 0, { stick: g, offsets: x } = ke(() => {
    const R = Math.max(Math.trunc(c), 0), X = [];
    if (R === 0 || !e) return { stick: 0, offsets: X };
    let G = 0, z = 0;
    for (let H = 0; H < R; H += 1) {
      const ie = e[H];
      if (typeof ie != "number") break;
      X.push(G), G += ie, z += 1;
    }
    return { stick: z, offsets: X };
  }, [e, c]), h = [ce.table, N ? ce.fixed : "", g > 0 ? ce.frozen : ""].filter(Boolean).join(" "), w = B(null), E = B(null), D = B(null), C = B(null), T = B(0), M = B(0), I = ke(() => ({
    scrollRef: w,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (M.current += 1, () => {
      M.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [q, F] = A(null), Y = _ !== void 0 ? _ : q, [W, j] = A(""), ne = B(ac()), te = () => {
    const R = w.current, X = D.current, G = C.current;
    if (!R || !X || !G) return;
    const z = R.scrollWidth;
    G.style.width = z + "px", X.style.display = z > R.clientWidth + 1 ? "" : "none";
    const H = R.offsetWidth - R.clientWidth;
    X.style.paddingRight = H + "px", E.current && (E.current.style.paddingRight = H + "px"), Pc(R), Oc(ic(R.querySelector("table")));
  };
  U(() => {
    const R = w.current;
    if (!R) return;
    const X = new Ar(R, te);
    return Rc(R.querySelector("table")), () => X.detach();
  }, []), $e(() => {
    var R, X, G, z, H;
    (g > 0 || T.current > 0) && (Ma((X = (R = w.current) == null ? void 0 : R.querySelector("table")) != null ? X : null, g, x), Ma((z = (G = E.current) == null ? void 0 : G.querySelector("table")) != null ? z : null, g, x)), T.current = g, (H = w.current) == null || H.querySelectorAll("thead th:not([scope])").forEach((ie) => ie.setAttribute("scope", "col")), v(), te();
  });
  function v() {
    var z;
    const R = (z = w.current) == null ? void 0 : z.querySelector("table");
    if (!R) return;
    const X = f ? tc(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((H) => {
      X.some((ie) => ie.th === H) || (H.removeAttribute("data-axe-sort"), H.removeAttribute("aria-sort"), H.removeAttribute("tabindex"));
    }), X.forEach(({ th: H, key: ie }) => {
      H.dataset.axeSort !== ie && (H.dataset.axeSort = ie);
      const Pe = Ea(Y, ie);
      H.getAttribute("aria-sort") !== Pe && H.setAttribute("aria-sort", Pe), H.hasAttribute("tabindex") || H.setAttribute("tabindex", "0");
    });
    const G = Y && X.find((H) => H.key === Y.key);
    lc(R, Y && G && !y && M.current === 0 ? { col: G.col, dir: Y.dir } : null, ne.current);
  }
  const O = (R) => {
    var H;
    const X = R.dataset.axeSort;
    if (X === void 0) return;
    const G = ba(Y, X), z = ((H = R.textContent) != null ? H : "").replace(/\s+/g, " ").trim();
    j(Cr(G, () => z)), _ === void 0 && F(G), p == null || p(G);
  }, V = (R) => {
    var z, H;
    const X = R, G = (z = X.closest) == null ? void 0 : z.call(X, "thead th[data-axe-sort]");
    return !G || !((H = w.current) != null && H.contains(G)) || X !== G && X.closest('input, select, textarea, button, a[href], [role="button"]') ? null : G;
  }, Q = (R) => {
    const X = V(R.target);
    X && O(X);
  }, se = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const X = V(R.target);
    !X || R.target !== X || (R.preventDefault(), O(X));
  }, L = (R) => {
    const X = R.target.scrollLeft;
    w.current && (w.current.scrollLeft = X), E.current && (E.current.scrollLeft = X);
  }, Z = (R) => {
    const X = R.target.scrollLeft;
    E.current && (E.current.scrollLeft = X), D.current && (D.current.scrollLeft = X);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ce.card, s ? ce.grow : "", i ? ce.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ce.busyBar, "aria-hidden": "true" }), (r !== void 0 || o !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ce.head }, /* @__PURE__ */ n.createElement("span", { className: ce.title }, r), o && /* @__PURE__ */ n.createElement("span", { className: ce.trailing }, o)), /* @__PURE__ */ n.createElement("div", { className: ce.scroll, ref: w, onScroll: Z }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: h,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: $ ? { minWidth: $ } : void 0,
      onClick: f ? Q : void 0,
      onKeyDown: f ? se : void 0
    },
    /* @__PURE__ */ n.createElement(Sa, { cols: e }),
    /* @__PURE__ */ n.createElement(Tr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ce.foot, ref: E }, /* @__PURE__ */ n.createElement("table", { className: h, style: $ ? { minWidth: $ } : void 0 }, /* @__PURE__ */ n.createElement(Sa, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ce.strip, ref: D, onScroll: L }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ce.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ce.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ce.sr, role: "status", "aria-live": "polite" }, W));
}
const Xc = 600;
function Ta(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: o } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const s = e.viewport > 0 ? e.viewport : Xc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - o) / a))), i = Math.ceil(s / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Fc(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Wc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const qa = /* @__PURE__ */ new Set();
function Ba({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function S0({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: o = 6,
  colSpan: s,
  headerRows: l = 1,
  className: c
}) {
  var h;
  const i = Ln(Tr), m = B(null), [u, f] = A(() => Ta({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: o
  })), _ = e.length, [p, y] = A(null), d = p && p.of === t ? p.px : t;
  $e(() => i ? i.registerVirtual() : void 0, [i]), $e(() => {
    var E;
    const w = (E = m.current) == null ? void 0 : E.closest("table");
    if (w)
      return w.setAttribute("aria-rowcount", String(_ + l)), () => w.removeAttribute("aria-rowcount");
  }, [_, l]), U(() => {
    const w = i == null ? void 0 : i.scrollRef.current, E = m.current;
    if (!w || !E) return;
    const D = () => {
      const T = E.getBoundingClientRect().top - w.getBoundingClientRect().top + w.scrollTop, M = Ta({ count: _, rowHeight: d, scrollTop: w.scrollTop, viewport: w.clientHeight, bodyTop: T, overscan: o });
      f((I) => Wc(I, M) ? I : M);
    };
    D(), w.addEventListener("scroll", D, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(D) : null;
    return C ? C.observe(w) : window.addEventListener("resize", D), () => {
      w.removeEventListener("scroll", D), C ? C.disconnect() : window.removeEventListener("resize", D);
    };
  }, [i, _, d, o]), $e(() => {
    var D, C, T;
    const w = (D = m.current) == null ? void 0 : D.querySelector("tr:not([data-virtual-spacer])"), E = (C = w == null ? void 0 : w.getBoundingClientRect().height) != null ? C : 0;
    !(E > 0) || Math.abs(E - d) <= 0.25 || (y({ of: t, px: E }), typeof process != "undefined" && ((T = process.env) == null ? void 0 : T.NODE_ENV) !== "production" && Math.abs(E - t) > 2 && !qa.has(t) && (qa.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(E)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, _]);
  const b = Math.min(u.end, _), N = Math.min(u.start, b), $ = Fc(_, d, { start: N, end: b }), g = (h = s != null ? s : i == null ? void 0 : i.colCount) != null ? h : 1, x = [];
  for (let w = N; w < b; w += 1) {
    const E = a(e[w], w), D = r ? r(e[w], w) : w;
    x.push(un(E) ? _a(E, { key: D, "aria-rowindex": w + 1 + l }) : E);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(Ba, { height: $.top, colSpan: g }), x, /* @__PURE__ */ n.createElement(Ba, { height: $.bottom, colSpan: g }));
}
const Hc = 7.09, Kc = 3.88, Uc = 4.46, Gc = 16, Yc = 2;
function Vc(e, t = {}) {
  var s;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), o = a * Hc + r * Kc + (t.negative ? Uc : 0) + Gc + Yc;
  return Math.max(Math.ceil(o), (s = t.min) != null ? s : 0);
}
function M0(e, t = {}) {
  var o, s;
  let a = 0, r = (o = t.negative) != null ? o : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : Vc(a, { ...t, negative: r });
}
function T0(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), o = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (o - r) / 3, minus: s - o };
}
const Dt = 12, Qc = 1.06, Jc = 16, Zc = 4;
function ei(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? Dt : e === " " ? Dt * 0.3 : /[0-9]/.test(e) ? Dt * 0.56 : /[A-Z]/.test(e) ? Dt * 0.68 : /[a-z]/.test(e) ? Dt * 0.56 : /[.,:;'|!]/.test(e) ? Dt * 0.3 : Dt * 0.6;
}
function ti(e, t = !1) {
  let a = 0;
  for (const r of e) a += ei(r);
  return t ? a * Qc : a;
}
function q0(e, t = {}) {
  var s, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = ti(i, t.bold);
    m > a && (a = m);
  }
  const r = (s = t.min) != null ? s : 64;
  if (a === 0) return r;
  const o = Math.ceil(a + Jc + ((l = t.extra) != null ? l : 0) + Zc);
  return Math.min(Math.max(o, r), (c = t.max) != null ? c : 1 / 0);
}
function qr({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: o = fo(),
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && m) f = "loading";
  else if (r == null) {
    if (s === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const _ = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ce.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ce.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? u : f === "loading" ? l : f === "idle" ? s : o)), p = /* @__PURE__ */ n.createElement("div", { className: [ce.status, ce[`st_${f}`]].join(" "), role: "status" }, _);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, p) : /* @__PURE__ */ n.createElement("tr", { className: [ce.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ce.statusCell }, p));
}
function B0({ colSpan: e, text: t, className: a }) {
  return /* @__PURE__ */ n.createElement(qr, { colSpan: e, count: 0, empty: t, className: a });
}
function ni(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const ai = "_cell_n9rrj_1", ri = "_toggle_n9rrj_2", oi = "_spacer_n9rrj_8", si = "_label_n9rrj_9", li = "_dim_n9rrj_10", Zt = {
  cell: ai,
  toggle: ri,
  spacer: oi,
  label: si,
  dim: li
};
function L0(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [o, s] = A(() => /* @__PURE__ */ new Set()), [l, c] = A(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = ke(() => {
    const p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const N = a(b), $ = N == null || !d.has(String(N)) ? null : String(N);
      p.set(String(t(b)), $), $ && y.add($);
    }
    return { parents: p, kids: y };
  }, [e, t, a]), u = re((p) => r ? !o.has(p) : l.has(p), [r, o, l]), f = ke(() => e.filter((p) => {
    var b, N;
    let y = (b = i.get(String(t(p)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; y && !d.has(y); ) {
      if (!u(y)) return !1;
      d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
    return !0;
  }), [e, i, t, u]), _ = re((p, y) => {
    const d = (b, N) => {
      const $ = new Set(b);
      return N ? $.add(p) : $.delete(p), $;
    };
    r ? s((b) => d(b, !y)) : c((b) => d(b, y));
  }, [r]);
  return {
    visible: f,
    hasChildren: (p) => m.has(String(t(p))),
    isOpen: (p) => u(String(t(p))),
    toggle: (p) => {
      const y = String(t(p));
      _(y, !u(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      s(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = o, y = l;
      return s(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        s(p), c(y);
      };
    },
    reveal: (p) => {
      var b, N;
      let y = (b = i.get(String(p))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; y && !d.has(y); )
        _(y, !0), d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
  };
}
function j0({ depth: e, hasChildren: t, open: a, onToggle: r, dim: o, toggleOutOfTabOrder: s, title: l, csvPath: c, children: i }) {
  const m = (f) => {
    f.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Zt.cell, o ? Zt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Zt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Zt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Zt.label, title: u }, i)
  );
}
function ci(e, t, a, r = !1) {
  const o = e[t.r];
  if (!o || t.i < 0 || t.i >= o.length) return null;
  const s = o[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < o.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: o.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: ii(e[m], s) };
      return null;
    }
    default:
      return null;
  }
}
function ii(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function I0(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, o = B(null), [s, l] = A(null);
  U(() => {
    e.current !== s && l(e.current);
  }), U(() => {
    if (!s) return;
    const i = () => Array.from(s.querySelectorAll(a)), m = () => {
      const y = i();
      if (!y.length) {
        o.current = null;
        return;
      }
      (!o.current || !y.includes(o.current)) && (o.current = r && y.find((d) => d.matches(r)) || y[0]), y.forEach((d) => {
        const b = d === o.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = i(), d = [], b = [], N = /* @__PURE__ */ new Map(), $ = [];
      return y.forEach((g) => {
        var T;
        const x = g.tagName === "TR", h = x ? null : g.closest("td, th"), w = h && s.contains(h) ? h.parentElement : null, E = x ? g : (T = w != null ? w : g.parentElement) != null ? T : s;
        let D = d.indexOf(E);
        D < 0 && (D = d.length, d.push(E), b.push([]), $.push([]));
        let C;
        if (x)
          C = 0;
        else if (h && w) {
          C = 0;
          for (const M of Array.from(w.cells)) {
            if (M === h) break;
            C += Math.max(1, M.colSpan || 1);
          }
        } else
          C = b[D].length;
        N.set(g, { r: D, i: b[D].length }), b[D].push(C), $[D].push(g);
      }), { rows: b, where: N, byPos: $ };
    }, f = (y) => {
      var w;
      const d = y.target;
      if (!d || !d.matches(a) || !s.contains(d) || y.altKey || y.metaKey || d.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: N, byPos: $ } = u(), g = N.get(d);
      if (!g) return;
      const x = ci(b, g, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const h = (w = $[x.r]) == null ? void 0 : w[x.i];
      h && (o.current = h, m(), h.focus());
    }, _ = (y) => {
      const d = y.target;
      !d || !d.matches(a) || d === o.current || (o.current = d, m());
    };
    m(), s.addEventListener("keydown", f), s.addEventListener("focusin", _);
    const p = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return p == null || p.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", f), s.removeEventListener("focusin", _), p == null || p.disconnect();
    };
  }, [s, a, r]);
}
const ui = "_btn_1rzx6_1", mi = "_mark_1rzx6_7", di = "_sr_1rzx6_9", dn = {
  btn: ui,
  mark: mi,
  sr: di
};
function R0({ sortKey: e, sort: t, onSort: a, children: r, className: o = "", colSpan: s, style: l, title: c }) {
  const i = Ea(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: s, style: l, title: c, className: o }, /* @__PURE__ */ n.createElement("button", { type: "button", className: dn.btn, onClick: () => a(ba(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: dn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function P0({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: dn.sr, role: "status", "aria-live": "polite" }, Cr(e, t));
}
function O0({ sortKey: e, sort: t, onSort: a, children: r, ariaLabel: o, twoState: s = !1 }) {
  const l = Ea(t, e), c = () => s ? t && t.key === e ? { key: e, dir: t.dir === "asc" ? "desc" : "asc" } : { key: e, dir: "asc" } : ba(t, e);
  return /* @__PURE__ */ n.createElement("button", { type: "button", className: dn.btn, "aria-label": o, "data-on": l !== "none" ? "true" : void 0, onClick: () => a(c()) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: dn.mark, "aria-hidden": "true" }, l === "ascending" ? "▲" : l === "descending" ? "▼" : "↕"));
}
const fi = "_card_14vt3_1", _i = "_accent_14vt3_8", pi = "_grow_14vt3_9", yi = "_head_14vt3_11", bi = "_body_14vt3_20", Ei = "_title_14vt3_28", hi = "_trailing_14vt3_29", gi = "_summary_14vt3_32", vi = "_sumHead_14vt3_33", ki = "_sumTotal_14vt3_42", wi = "_tone_warn_14vt3_43", Ni = "_tone_ok_14vt3_44", $i = "_sumList_14vt3_46", xi = "_sumEm_14vt3_55", Di = "_sumFoot_14vt3_57", Ai = "_sumNote_14vt3_66", Ne = {
  card: fi,
  accent: _i,
  grow: pi,
  head: yi,
  body: bi,
  title: Ei,
  trailing: hi,
  summary: gi,
  sumHead: vi,
  sumTotal: ki,
  tone_warn: wi,
  tone_ok: Ni,
  sumList: $i,
  sumEm: xi,
  sumFoot: Di,
  sumNote: Ai
};
function Br({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: o,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [Ne.card, a ? Ne.accent : "", r ? Ne.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: Ne.trailing }, t)),
    o ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", Ne.body].join(" ") }, l)
  );
}
function z0({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: o,
  note: s,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [Ne.card, Ne.accent, Ne.summary, Ne[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: Ne.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: Ne.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: Ne.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? Ne.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: Ne.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, o)), s && /* @__PURE__ */ n.createElement("div", { className: Ne.sumNote }, s));
}
let Ci = 0;
function Qt(e = "axe") {
  const t = B(null);
  return t.current || (t.current = `${e}-${++Ci}`), t.current;
}
const Si = "_sr_1y2mv_2", Mi = "_skip_1y2mv_8", Ti = "_crit_1y2mv_16", qi = "_c_danger_1y2mv_21", Bi = "_c_warn_1y2mv_22", Li = "_critI_1y2mv_23", ji = "_critBody_1y2mv_24", Ii = "_critX_1y2mv_25", Ri = "_ch_1y2mv_32", Pi = "_chBtn_1y2mv_33", Oi = "_chBox_1y2mv_43", Qe = {
  sr: Si,
  skip: Mi,
  crit: Ti,
  c_danger: qi,
  c_warn: Bi,
  critI: Li,
  critBody: ji,
  critX: Ii,
  ch: Ri,
  chBtn: Pi,
  chBox: Oi
};
function Lr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Qe.sr, id: a }, t);
}
function X0({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, o) => {
    const s = document.getElementById(o);
    s && (r.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Qe.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (o) => a(o, r.targetId) }, r.label)));
}
function F0({ title: e, children: t, tone: a = "danger", onClose: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Qe.crit, Qe[`c_${a}`], o].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Qe.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Qe.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Qe.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function W0({ label: e, children: t, className: a = "" }) {
  const [r, o] = A(!1), s = Qt("axe-ch"), l = B(null), c = B(null);
  return U(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && o(!1);
    }, m = (u) => {
      var f;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), o(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Qe.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Qe.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": s,
      onClick: () => o((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: s, role: "region", "aria-label": e, className: Qe.chBox }, t));
}
function oa(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const o = (t != null ? t : "").trim();
  return !o || a === "code" ? r : a === "name" ? o : `${r}. ${o}`;
}
function zi(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = oa(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Xi(e, t, a, r) {
  const o = (e != null ? e : "").trim();
  if (!o) return null;
  if (t && t.name && t.code === o) return t.name;
  if (a && a.code === o && a.name) return a.name;
  const s = r == null ? void 0 : r.find((l) => l.code === o);
  return s && s.name ? s.name : null;
}
const Fi = "_root_g2b1p_1", Wi = "_rootNone_g2b1p_5", Hi = "_field_g2b1p_12", Ki = "_codeInput_g2b1p_13", Ui = "_nameHint_g2b1p_16", Gi = "_pickBtn_g2b1p_25", Yi = "_suggest_g2b1p_42", Vi = "_suggestList_g2b1p_48", Qi = "_suggestRow_g2b1p_49", Ji = "_suggestOn_g2b1p_50", Zi = "_suggestEmpty_g2b1p_55", eu = "_suggestMore_g2b1p_55", tu = "_popup_g2b1p_59", nu = "_popupHead_g2b1p_73", au = "_searchRow_g2b1p_83", ru = "_list_g2b1p_87", ou = "_current_g2b1p_96", su = "_empty_g2b1p_100", lu = "_summaryBtn_g2b1p_108", cu = "_ov_g2b1p_129", iu = "_modal_g2b1p_140", uu = "_modalWide_g2b1p_140", mu = "_head_g2b1p_152", du = "_sub_g2b1p_160", fu = "_x_g2b1p_162", _u = "_body_g2b1p_179", pu = "_chips_g2b1p_187", yu = "_chip_g2b1p_187", bu = "_chipOn_g2b1p_201", Eu = "_search_g2b1p_83", hu = "_tbl_g2b1p_220", gu = "_row_g2b1p_250", vu = "_rowCursor_g2b1p_252", ku = "_rowPicked_g2b1p_253", wu = "_rowCurrent_g2b1p_254", Nu = "_curTag_g2b1p_255", $u = "_busy_g2b1p_256", xu = "_count_g2b1p_257", Du = "_chk_g2b1p_259", Au = "_tdLeft_g2b1p_260", Cu = "_tdCenter_g2b1p_261", Su = "_emptyCell_g2b1p_263", Mu = "_stop_g2b1p_265", Tu = "_more_g2b1p_276", qu = "_pager_g2b1p_288", Bu = "_note_g2b1p_301", Lu = "_foot_g2b1p_304", ju = "_ghost_g2b1p_313", Iu = "_primary_g2b1p_325", K = {
  root: Fi,
  rootNone: Wi,
  field: Hi,
  codeInput: Ki,
  nameHint: Ui,
  pickBtn: Gi,
  suggest: Yi,
  suggestList: Vi,
  suggestRow: Qi,
  suggestOn: Ji,
  suggestEmpty: Zi,
  suggestMore: eu,
  popup: tu,
  popupHead: nu,
  searchRow: au,
  list: ru,
  current: ou,
  empty: su,
  summaryBtn: lu,
  ov: cu,
  modal: iu,
  modalWide: uu,
  head: mu,
  sub: du,
  x: fu,
  body: _u,
  chips: pu,
  chip: yu,
  chipOn: bu,
  search: Eu,
  tbl: hu,
  row: gu,
  rowCursor: vu,
  rowPicked: ku,
  rowCurrent: wu,
  curTag: Nu,
  busy: $u,
  count: xu,
  chk: Du,
  tdLeft: Au,
  tdCenter: Cu,
  emptyCell: Su,
  stop: Mu,
  more: Tu,
  pager: qu,
  note: Bu,
  foot: Lu,
  ghost: ju,
  primary: Iu
};
function Ru({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: o,
  pos: s,
  onPick: l,
  onClose: c
}) {
  const [i, m] = A(""), u = ke(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (_) => {
        var p;
        return _.code.toLowerCase().includes(f) || _.name.toLowerCase().includes(f) || ((p = _.sub) != null ? p : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return U(() => {
    const f = (p) => {
      const y = p.target;
      r.current && !r.current.contains(y) && o.current && !o.current.contains(y) && c();
    }, _ = (p) => {
      p.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", _);
    };
  }, [r, o, c]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: K.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: K.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: K.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => m(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && u.length && l(u[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: K.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? K.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: K.empty }, "검색 결과가 없습니다"))
  ));
}
const jr = 250, gn = 7;
function La(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Pu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const o = r.trim().toLowerCase();
      return o ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(o) || s.nm.toLowerCase().includes(o) || String((l = s.sub) != null ? l : "").toLowerCase().includes(o);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Ou({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: o,
  current: s,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const m = ke(() => Pu(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [f, _] = A(""), [p, y] = A((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = A(0), [N, $] = A([]), [g, x] = A(!1), [h, w] = A(!1), [E, D] = A(null), [C, T] = A(0), [M, I] = A(/* @__PURE__ */ new Map()), q = B(u);
  q.current = u, U(() => {
    var Z;
    _(""), y((Z = q.current.defaultFilter) != null ? Z : null), b(0), T(0), D(null), I(new Map((o != null ? o : []).map((R) => [R.cd, R]))), l.current && l.current.focus();
    const L = window.setTimeout(() => {
      l.current && document.activeElement !== l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(L);
  }, [u.key]), U(() => {
    let L = !0;
    w(!0);
    const Z = () => {
      q.current.fetch({ q: f.trim(), ty: p, page: d }).then((X) => {
        var z, H;
        if (!L) return;
        w(!1), $((z = X.rows) != null ? z : []), x(!!X.hasMore), D(null);
        const G = s ? ((H = X.rows) != null ? H : []).findIndex((ie) => ie.cd === s) : -1;
        T(G > 0 ? G : 0);
      }).catch(() => {
        L && (w(!1), $([]), x(!1), D("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        L && w(!1);
      });
    }, R = window.setTimeout(Z, f.trim() ? jr : 0);
    return () => {
      L = !1, window.clearTimeout(R);
    };
  }, [u.key, f, p, d]);
  const F = B(null);
  U(() => {
    const L = F.current && F.current.children[C];
    L && "scrollIntoView" in L && L.scrollIntoView({ block: "nearest" });
  }, [C, N]);
  const Y = ke(() => {
    var Z, R;
    const L = [
      { key: "cd", label: "코드", width: (Z = u.codeWidth) != null ? Z : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (X) => /* @__PURE__ */ n.createElement(n.Fragment, null, X.nm, X.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: K.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && L.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (X) => u.typeLabel ? u.typeLabel(X) : ""
    }), L.concat((R = u.extraColumns) != null ? R : []);
  }, [u]), W = re((L) => {
    I((Z) => {
      const R = new Map(Z);
      return R.has(L.cd) ? R.delete(L.cd) : R.set(L.cd, L), R;
    });
  }, []), j = re((L) => c([L]), [c]), ne = re(() => c(Array.from(M.values())), [M, c]), te = N.length > 0 && N.every((L) => M.has(L.cd)), v = () => {
    I((L) => {
      const Z = new Map(L);
      return te ? N.forEach((R) => Z.delete(R.cd)) : N.forEach((R) => Z.set(R.cd, R)), Z;
    });
  }, O = B(null);
  U(() => {
    const L = document.activeElement;
    return () => {
      window.setTimeout(() => {
        L && L.isConnected && typeof L.focus == "function" && (!document.activeElement || document.activeElement === document.body) && L.focus();
      }, 0);
    };
  }, []);
  const V = B(i);
  V.current = i, U(() => {
    const L = (Z) => {
      Z.key !== "Escape" || Z.isComposing || (Z.stopPropagation(), Z.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", L, !0), () => document.removeEventListener("keydown", L, !0);
  }, []);
  const Q = (L) => {
    var X;
    if (L.nativeEvent.isComposing || L.keyCode === 229) return;
    if (L.key === "Tab" && O.current) {
      const G = Array.from(O.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (G.length) {
        const z = G[0], H = G[G.length - 1], ie = document.activeElement;
        L.shiftKey && ie === z ? (L.preventDefault(), H.focus()) : !L.shiftKey && ie === H && (L.preventDefault(), z.focus());
      }
      return;
    }
    if (L.key === "Escape") {
      L.stopPropagation(), i();
      return;
    }
    const Z = L.target, R = Z === l.current;
    if (!(!R && Z !== O.current)) {
      if (L.key === "ArrowDown" || L.key === "ArrowUp") {
        L.preventDefault(), T((G) => Math.max(0, Math.min(N.length - 1, G + (L.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (L.key === " " && r && N[C] && !(R && ((X = l.current) != null && X.value))) {
        L.preventDefault(), W(N[C]);
        return;
      }
      if (L.key === "Enter") {
        if (L.preventDefault(), h) return;
        r ? ne() : N[C] && j(N[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { className: K.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${K.modal} ${K.modalWide}` : K.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: O,
      onClick: (L) => L.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: K.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: K.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: K.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: K.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((L) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L.value,
        type: "button",
        className: p === L.value ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(L.value), b(0);
        }
      },
      L.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: K.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (L) => {
          _(L.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: K.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: K.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), Y.map((L) => /* @__PURE__ */ n.createElement("th", { key: L.key, style: L.width ? { width: L.width } : void 0 }, L.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: F, className: h && N.length > 0 ? K.busy : void 0, "aria-busy": h }, N.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: K.emptyCell, colSpan: Y.length + (r ? 1 : 0) }, h ? "검색 중…" : E || u.emptyText || "검색 결과가 없습니다")) : N.map((L, Z) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: L.cd,
        className: [
          K.row,
          Z === C ? K.rowCursor : "",
          M.has(L.cd) ? K.rowPicked : "",
          !r && s && L.cd === s ? K.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": Z === C,
        onClick: () => {
          T(Z), r ? W(L) : j(L);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: K.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: M.has(L.cd),
          onChange: () => W(L),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${L.cd} 선택`
        }
      )),
      Y.map((R) => {
        var X, G;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? K.tdLeft : K.tdCenter,
            title: R.render ? void 0 : String((X = L[R.key]) != null ? X : "")
          },
          R.render ? R.render(L) : String((G = L[R.key]) != null ? G : ""),
          R.key === "cd" && !r && s && L.cd === s && /* @__PURE__ */ n.createElement("em", { className: K.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: K.count, role: "status", "aria-live": "polite" }, h ? "검색 중…" : E ? "" : `${N.length}건`, !r && !h && !E && N.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 행을 누르세요"), (g || d > 0) && /* @__PURE__ */ n.createElement("div", { className: K.more }, /* @__PURE__ */ n.createElement("span", null, g ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: K.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((L) => Math.max(0, L - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), g && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((L) => L + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: K.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, M.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: K.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.primary, onClick: ne }, "확인"))
  )));
}
let zu = 0;
function Xu({ source: e, items: t, anchorRef: a }) {
  const [r, o] = A(null), [s, l] = A(-1), [c, i] = A(null), m = B(null), u = B(0), f = B(`axe-cp-${++zu}`), _ = B(e);
  _.current = e;
  const p = B(t);
  p.current = t;
  const y = re(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, o(null), l(-1);
  }, []);
  U(() => y, [y]);
  const d = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const N = u.current;
    if (!b.trim()) {
      o(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var x;
      let $ = [], g = !1;
      try {
        const h = _.current;
        if (h) {
          const w = await h.fetch({ q: b, ty: null, page: 0 });
          $ = w.rows, g = !!w.hasMore || $.length > gn;
        } else {
          const w = b.trim().toLowerCase();
          $ = ((x = p.current) != null ? x : []).filter((E) => {
            var D;
            return E.code.toLowerCase().includes(w) || E.name.toLowerCase().includes(w) || ((D = E.sub) != null ? D : "").toLowerCase().includes(w);
          }).map((E) => ({ cd: E.code, nm: E.name, sub: E.sub })), g = $.length > gn;
        }
      } catch {
        return;
      }
      N === u.current && (o({ rows: $.slice(0, gn), more: g, q: b }), l(-1));
    }, jr);
  };
  return U(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const N = a.current;
      if (!N) return;
      const $ = N.getBoundingClientRect(), g = Math.min(r.rows.length, gn) * 28 + 34, x = $.bottom + g > window.innerHeight - 8 && $.top - g - 2 > 8 ? $.top - g - 2 : $.bottom + 2, h = Math.max($.width, 260);
      i({ left: Math.max(8, Math.min($.left, window.innerWidth - h - 8)), top: x, width: h });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: s, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: y };
}
function H0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: o,
  source: s,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: f = "전체",
  open: _,
  onOpenChange: p,
  placeholder: y,
  title: d = "코드 선택",
  variant: b,
  disabled: N,
  className: $ = "",
  maxLength: g,
  numeric: x = !1,
  ariaLabel: h,
  autoFocus: w,
  onEnter: E,
  openOnEmptyEnter: D,
  onEscape: C,
  onBlur: T,
  invalid: M,
  selectOnFocus: I = !1
}) {
  const q = s ? "source" : "static", F = h != null ? h : (s == null ? void 0 : s.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", Y = b != null ? b : q === "source" ? "modal" : "anchor", W = u != null ? u : l ? "summary" : "input", [j, ne] = A(!1), te = _ != null ? _ : j, v = re(
    (k) => {
      _ === void 0 && ne(k), p && p(k);
    },
    [_, p]
  ), O = B(null), V = B(!1), Q = B(null), se = B(null), [L, Z] = A(null), R = () => {
    if (!N) {
      if (Y === "anchor") {
        const k = O.current;
        if (!k) return;
        const P = k.getBoundingClientRect(), J = 320, oe = P.bottom + J > window.innerHeight ? Math.max(8, P.top - J - 4) : P.bottom + 4;
        Z({ left: Math.min(P.left, window.innerWidth - 320), top: oe });
      }
      v(!0);
    }
  }, X = re(() => v(!1), [v]), [G, z] = A(!1), [H, ie] = A(null), Pe = B(null);
  (!Pe.current || Pe.current.name !== t) && (Pe.current = { name: t, code: e });
  const xe = Xi(e, Pe.current, H, o), Fe = oa(e, xe, a), dt = oa(e, xe), Rt = G && xe && a !== "code" ? xe : "", Nt = (k) => {
    !l && k[0] && ie({ code: k[0].cd, name: k[0].nm }), i ? i(k) : k[0] && r && r(k[0].cd, { code: k[0].cd, name: k[0].nm });
  }, { sugg: pe, active: nt, setActive: Ue, suggPos: Pt, suggId: ft, runSuggest: Ot, cancelSuggest: $t } = Xu({ source: s, items: o, anchorRef: O }), bn = (k) => {
    $t(), Nt([k]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: [W === "none" ? K.rootNone : K.root, $].filter(Boolean).join(" ") }, W === "input" && /* @__PURE__ */ n.createElement("span", { className: K.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: K.codeInput,
      style: { paddingRight: Rt ? "calc(24px + 45%)" : 24 },
      value: G ? e : Fe,
      placeholder: y,
      disabled: N,
      maxLength: g,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: w,
      "aria-label": F,
      "aria-invalid": M ? !0 : void 0,
      onChange: (k) => {
        const P = k.target.value.trim(), J = x ? P.replace(/[^0-9]/g, "") : P, oe = g ? J.slice(0, g) : J;
        r && r(oe), !N && (s || o) && Ot(oe);
      },
      onKeyDown: (k) => {
        if (k.key === "F2") {
          k.preventDefault(), $t(), R();
          return;
        }
        if (!pe) {
          if (k.key === "Enter" && D && !e.trim() && !k.nativeEvent.isComposing) {
            k.preventDefault(), R();
            return;
          }
          k.key === "Enter" && E && !k.nativeEvent.isComposing ? (k.preventDefault(), E()) : k.key === "Escape" && C && (k.preventDefault(), C());
          return;
        }
        const P = pe.rows.length;
        k.key === "ArrowDown" && P ? (k.preventDefault(), Ue((J) => (J + 1) % P)) : k.key === "ArrowUp" && P ? (k.preventDefault(), Ue((J) => (J <= 0 ? P : J) - 1)) : k.key === "Enter" && nt >= 0 && pe.rows[nt] ? (k.preventDefault(), bn(pe.rows[nt])) : k.key === "Enter" && E && !k.nativeEvent.isComposing ? (k.preventDefault(), $t(), E()) : k.key === "Escape" && (k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), $t());
      },
      onFocus: (k) => {
        if (z(!0), !I) return;
        const P = k.currentTarget;
        window.requestAnimationFrame(() => P.select());
      },
      onMouseDown: (k) => {
        I && document.activeElement !== k.currentTarget && (V.current = !0);
      },
      onMouseUp: (k) => {
        V.current && (k.preventDefault(), V.current = !1);
      },
      onBlur: () => {
        z(!1), $t(), T && T();
      },
      title: typeof M == "string" && M ? M : dt && dt !== e ? `${dt} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!pe,
      "aria-controls": pe ? ft.current : void 0,
      "aria-activedescendant": pe && nt >= 0 ? `${ft.current}-${nt}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${ft.current}-inv` : void 0
    }
  ), Rt && /* @__PURE__ */ n.createElement("span", { className: K.nameHint, "aria-hidden": "true" }, Rt), typeof M == "string" && M && /* @__PURE__ */ n.createElement(Lr, { id: `${ft.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: K.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: N,
      onClick: R,
      onMouseDown: (k) => k.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 })
  )), W === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.summaryBtn, disabled: N, onClick: R }, /* @__PURE__ */ n.createElement("span", null, zi(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 }))), pe && Pt && W === "input" && !te && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: K.suggest,
      style: { left: Pt.left, top: Pt.top, width: Pt.width },
      onMouseDown: (k) => k.preventDefault()
    },
    pe.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: K.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: ft.current, role: "listbox", className: K.suggestList }, pe.rows.map((k, P) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: k.cd,
        id: `${ft.current}-${P}`,
        role: "option",
        "aria-selected": P === nt,
        className: [K.suggestRow, P === nt ? K.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Ue(P),
        onClick: () => bn(k)
      },
      /* @__PURE__ */ n.createElement("code", null, La(k.cd, pe.q)),
      /* @__PURE__ */ n.createElement("span", null, La(k.nm, pe.q)),
      k.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    pe.more && /* @__PURE__ */ n.createElement("div", { className: K.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && q === "static" && Y === "anchor" && L && /* @__PURE__ */ n.createElement(
    Ru,
    {
      items: o != null ? o : [],
      value: e,
      title: d,
      popupRef: Q,
      anchorRef: O,
      pos: L,
      onPick: (k) => {
        ie({ code: k.code, name: k.name }), r && r(k.code, k), X();
      },
      onClose: X
    }
  ), te && (q === "source" || Y === "modal") && /* @__PURE__ */ n.createElement(
    Ou,
    {
      source: s,
      items: o,
      title: d,
      multiple: l,
      selected: c,
      current: m,
      searchRef: se,
      onConfirm: (k) => {
        Nt(k), X();
      },
      onClose: X
    }
  ));
}
const ga = 864e5;
function Fu(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Fu(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function vt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ga);
}
function Wu(e) {
  const t = new Date(e * ga);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function In(e, t) {
  return Wu(vt(e) + t);
}
function va(e) {
  return new Date(vt(e) * ga).getUTCDay();
}
const ja = "1900-01-01", Ia = "2099-12-31", Hn = ["일", "월", "화", "수", "목", "금", "토"], Cn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${Cn(t)}-${Cn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], o = +t[3];
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Hu(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function en(e, t) {
  return t === "month" ? Hu(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${Cn(e.m)}` : tt(e.y, e.m, e.d);
}
function Ie(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function fn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function wt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = (a % 12 + 12) % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
function Ku(e, t, a) {
  return e >= t && e <= a;
}
function Xt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function Kn(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), o = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + r), t === "date" && e.length > 6 && (s += "-" + o), s;
}
function Ra(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function xn(e, t, a) {
  let r, o, s = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), o = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), o = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, o = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return o < 1 || o > 12 || s < 1 || s > Le(r, o) ? null : { y: r, m: o, d: s };
}
function Uu(e, t, a) {
  const r = e.trim(), o = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (o) {
    const s = { y: +o[1], m: +o[2], d: t === "month" ? 1 : +o[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Le(s.y, s.m) ? s : null;
  }
  return xn(r.replace(/\D/g, ""), t, a);
}
function Gu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = fn(a, -Ie(a));
  return Array.from({ length: 42 }, (o, s) => fn(r, s));
}
function Yu(e, t) {
  const a = e.y, r = [], o = (m, u) => `${String(m).padStart(4, "0")}-${Cn(u)}`, s = (m, u, f) => tt(m, u, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: o(a, e.m), to: o(a, e.m) });
    const m = wt(e, -1);
    r.push({ label: "지난달", from: o(m.y, m.m), to: o(m.y, m.m) }), r.push({ label: "올해", from: o(a, 1), to: o(a, 12) }), r.push({ label: "올해 누계", from: o(a, 1), to: o(a, e.m) }), r.push({ label: "전년도", from: o(a - 1, 1), to: o(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: o(a, u * 3 - 2), to: o(a, u * 3) });
    return r.push({ label: "상반기", from: o(a, 1), to: o(a, 6) }), r.push({ label: "하반기", from: o(a, 7), to: o(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = fn(e, -Ie(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(fn(c, 6), "date") }), r.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Le(a, e.m)) });
  const i = wt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: s(i.y, i.m, 1), to: s(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), r.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: s(a, m * 3 - 2, 1), to: s(a, m * 3, Le(a, m * 3)) });
  return r;
}
const Vu = "_wrap_uxy72_1", Qu = "_disabled_uxy72_18", Ju = "_input_uxy72_22", Zu = "_month_uxy72_36", em = "_weekday_uxy72_39", tm = "_sun_uxy72_40", nm = "_sat_uxy72_41", am = "_icon_uxy72_43", rm = "_readOnly_uxy72_57", om = "_required_uxy72_62", sm = "_invalid_uxy72_63", lm = "_pop_uxy72_66", cm = "_calHead_uxy72_79", im = "_calTitleStatic_uxy72_80", um = "_calTitle_uxy72_80", mm = "_grid_uxy72_90", dm = "_wd_uxy72_91", fm = "_day_uxy72_95", _m = "_mon_uxy72_36", pm = "_out_uxy72_104", ym = "_sel_uxy72_105", bm = "_today_uxy72_108", Em = "_months_uxy72_111", hm = "_foot_uxy72_114", gm = "_clear_uxy72_127", vm = "_range_uxy72_130", km = "_tilde_uxy72_131", wm = "_rangeErr_uxy72_132", ae = {
  wrap: Vu,
  disabled: Qu,
  input: Ju,
  month: Zu,
  weekday: em,
  sun: tm,
  sat: nm,
  icon: am,
  readOnly: rm,
  required: om,
  invalid: sm,
  pop: lm,
  calHead: cm,
  calTitleStatic: im,
  calTitle: um,
  grid: mm,
  wd: dm,
  day: fm,
  mon: _m,
  out: pm,
  sel: ym,
  today: bm,
  months: Em,
  foot: hm,
  clear: gm,
  range: vm,
  tilde: km,
  rangeErr: wm
}, yt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Pa({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: o,
  disabled: s,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: f,
  id: _,
  name: p,
  onBlur: y,
  "aria-label": d,
  "aria-describedby": b,
  className: N = "",
  style: $
}) {
  const g = a === "month", x = Qt("axe-dp"), h = r || (g ? ja.slice(0, 7) : ja), w = o || (g ? Ia.slice(0, 7) : Ia), E = (k) => Ku(k, h, w), D = !!s || !!l, [C, T] = A(e || ""), [M, I] = A(!1), [q, F] = A(!1), [Y, W] = A(g ? "month" : "day"), [j, ne] = A(() => {
    var P;
    const k = (P = en(e, a)) != null ? P : yt();
    return { y: k.y, m: k.m };
  }), [te, v] = A({ top: 0, left: 0 }), O = B(null), V = B(null), Q = B(null), se = B(null);
  U(() => {
    T(e || ""), I(!1);
  }, [e]), U(() => {
    const k = en(e, a);
    k && ne({ y: k.y, m: k.m });
  }, [e, a]), $e(() => {
    const k = V.current;
    se.current != null && k && document.activeElement === k && k.setSelectionRange(se.current, se.current), se.current = null;
  }, [C]), $e(() => {
    if (!q) return;
    const k = () => {
      const P = O.current, J = Q.current;
      if (!P || !J) return;
      const oe = P.getBoundingClientRect(), ue = J.offsetHeight, Ee = J.offsetWidth;
      let De = oe.bottom + 4;
      De + ue > window.innerHeight - 8 && oe.top - ue - 4 > 8 && (De = oe.top - ue - 4);
      const Jt = Math.max(8, Math.min(oe.left, window.innerWidth - Ee - 8));
      v((Fn) => Fn.top === De && Fn.left === Jt ? Fn : { top: De, left: Jt });
    };
    return k(), window.addEventListener("resize", k), window.addEventListener("scroll", k, !0), () => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    };
  }, [q, Y, j.y, j.m]), U(() => {
    if (!q) return;
    const k = (P) => {
      var oe, ue;
      const J = P.target;
      (oe = O.current) != null && oe.contains(J) || (ue = Q.current) != null && ue.contains(J) || F(!1);
    };
    return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
  }, [q]);
  const L = (k) => {
    k !== (e || "") && t(k);
  }, Z = (k) => {
    T(k), I(!1), L(k);
  }, R = () => {
    const k = Xt(C, a);
    if (!k) return;
    const P = xn(k, a, yt()), J = P ? Be(P, a) : null;
    if (J && E(J)) {
      Z(J);
      return;
    }
    u == null || u(C, J ? "range" : "format"), T(e || ""), I(!1);
  }, X = (k, P) => {
    const J = Xt(k.slice(0, P), a).length, oe = Xt(k, a), ue = Kn(oe, a);
    if (se.current = Ra(ue, Math.min(J, oe.length)), T(ue), !oe) {
      I(!1), L("");
      return;
    }
    if (oe.length === (g ? 6 : 8)) {
      const Ee = xn(oe, a, yt()), De = Ee ? Be(Ee, a) : null;
      De && E(De) ? (I(!1), L(De)) : I(!0);
    } else I(!1);
  }, G = (k, P) => {
    var Jt;
    const J = yt(), oe = Xt(C, a), ue = (Jt = xn(oe, a, J)) != null ? Jt : en(e, a);
    let Ee;
    ue ? g ? Ee = wt(ue, k === "year" ? 12 * P : P) : k === "day" ? Ee = fn(ue, P) : Ee = wt(ue, k === "month" ? P : 12 * P) : Ee = J;
    const De = Be(Ee, a);
    E(De) && Z(De);
  }, z = (k) => {
    var P;
    Z(k), F(!1), (P = V.current) == null || P.focus();
  }, H = () => {
    var P;
    if (D) return;
    const k = (P = en(e, a)) != null ? P : yt();
    ne({ y: k.y, m: k.m }), W(g ? "month" : "day"), F(!0);
  }, ie = (k) => {
    var J, oe;
    if (D) return;
    const P = k.currentTarget;
    switch (k.key) {
      case "Escape":
        q ? (F(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (T(e || ""), I(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => P.select()));
        break;
      case "ArrowDown":
        k.preventDefault(), k.altKey ? q ? F(!1) : H() : G("day", 1);
        break;
      case "ArrowUp":
        k.preventDefault(), G("day", -1);
        break;
      case "PageDown":
        k.preventDefault(), G("month", 1);
        break;
      case "PageUp":
        k.preventDefault(), G("month", -1);
        break;
      case "F2":
      case "F4":
        k.preventDefault(), q ? F(!1) : H();
        break;
      case "Enter":
        R(), q && F(!1);
        break;
      case "t":
      case "T":
        if (k.ctrlKey || k.metaKey || k.altKey) break;
        k.preventDefault(), Z(Be(yt(), a));
        break;
      case "Backspace": {
        const ue = (J = P.selectionStart) != null ? J : 0;
        if (ue === ((oe = P.selectionEnd) != null ? oe : 0) && ue > 0 && C[ue - 1] === "-") {
          k.preventDefault();
          const Ee = Xt(C.slice(0, ue), a).length, De = Xt(C, a);
          X(Kn(De.slice(0, Ee - 1) + De.slice(Ee), a), 0), se.current = Ra(Kn(De.slice(0, Ee - 1) + De.slice(Ee), a), Ee - 1);
        }
        break;
      }
    }
  }, Pe = (k) => {
    if (D) return;
    k.preventDefault();
    const P = Uu(k.clipboardData.getData("text"), a, yt()), J = P ? Be(P, a) : null;
    J && E(J) ? Z(J) : I(!0);
  }, xe = (k) => {
    var J, oe;
    const P = k.relatedTarget;
    P && ((J = O.current) != null && J.contains(P) || (oe = Q.current) != null && oe.contains(P)) || (R(), F(!1), y && y());
  }, Fe = en(e, a), dt = yt(), Rt = M || !!i, Nt = m && !g && Fe ? Ie(Fe) : null, pe = (k) => Be(k, a), nt = (k, P) => {
    const J = Be({ y: k, m: P, d: 1 }, "date"), oe = Be({ y: k, m: P, d: Le(k, P) }, "date"), ue = g ? h + "-01" : h, Ee = g ? w + "-31" : w;
    return oe >= ue && J <= Ee;
  }, Ue = (k) => {
    const P = wt({ y: j.y, m: j.m, d: 1 }, k);
    ne({ y: P.y, m: P.m });
  }, Pt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ue(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Ue(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => W("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Ue(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ue(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.grid }, Hn.map((k, P) => /* @__PURE__ */ n.createElement("span", { key: k, className: [ae.wd, P === 0 ? ae.sun : "", P === 6 ? ae.sat : ""].join(" ") }, k)), Gu(j.y, j.m).map((k) => {
    const P = Be(k, "date"), J = Ie(k), oe = [
      ae.day,
      k.m !== j.m ? ae.out : "",
      J === 0 ? ae.sun : "",
      J === 6 ? ae.sat : "",
      P === Be(dt, "date") ? ae.today : "",
      Fe && P === Be(Fe, "date") ? ae.sel : ""
    ].join(" "), ue = !E(P);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: P,
        type: "button",
        tabIndex: -1,
        className: oe,
        disabled: ue,
        "aria-label": `${k.y}년 ${k.m}월 ${k.d}일 ${Hn[J]}요일`,
        "aria-pressed": !!Fe && P === Be(Fe, "date"),
        onClick: () => z(P)
      },
      k.d
    );
  }))), ft = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ue(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: ae.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ue(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (k, P) => P + 1).map((k) => {
    const P = !!Fe && Fe.y === j.y && Fe.m === k, J = [ae.mon, P ? ae.sel : "", dt.y === j.y && dt.m === k ? ae.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k,
        type: "button",
        tabIndex: -1,
        className: J,
        disabled: !nt(j.y, k),
        "aria-pressed": P,
        onClick: () => {
          g ? z(pe({ y: j.y, m: k, d: 1 })) : (ne({ y: j.y, m: k }), W("day"));
        }
      },
      k,
      "월"
    );
  }))), Ot = Be(dt, a), $t = g ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Ot), onClick: () => z(Ot) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Ot), onClick: () => z(Ot) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(pe({ y: j.y, m: j.m, d: 1 })),
      onClick: () => z(pe({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(pe({ y: j.y, m: j.m, d: Le(j.y, j.m) })),
      onClick: () => z(pe({ y: j.y, m: j.m, d: Le(j.y, j.m) }))
    },
    "월말"
  )), bn = [
    ae.wrap,
    s ? ae.disabled : "",
    l ? ae.readOnly : "",
    c && !e && !C ? ae.required : "",
    Rt ? ae.invalid : "",
    g ? ae.month : "",
    N
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: bn, style: $, onBlur: xe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: _,
      name: p,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: f != null ? f : g ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": q,
      "aria-controls": x,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": Rt || void 0,
      "aria-required": c || void 0,
      onChange: (k) => {
        var P;
        return X(k.target.value, (P = k.target.selectionStart) != null ? P : k.target.value.length);
      },
      onKeyDown: ie,
      onPaste: Pe
    }
  ), Nt != null && /* @__PURE__ */ n.createElement("span", { className: [ae.weekday, Nt === 0 ? ae.sun : "", Nt === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", Hn[Nt], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: D,
      "aria-label": g ? "월 선택 열기" : "달력 열기",
      onMouseDown: (k) => k.preventDefault(),
      onClick: () => {
        var k;
        (k = V.current) == null || k.focus(), q ? F(!1) : H();
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "calendar", size: 15 })
  ), q && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: x,
      className: ae.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": g ? "월 선택" : "날짜 선택",
      onMouseDown: (k) => k.preventDefault()
    },
    Y === "day" && !g ? Pt() : ft(),
    /* @__PURE__ */ n.createElement("div", { className: ae.foot }, $t, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => z("") }, "비우기"))
  )));
}
const Tt = (e) => String(e).padStart(2, "0");
function Ir() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Tt(e.getMonth() + 1)}-${Tt(e.getDate())}`;
}
function K0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Tt(t.getMonth() + 1)}-${Tt(t.getDate())} ${Tt(t.getHours())}:${Tt(t.getMinutes())}:${Tt(t.getSeconds())}`;
}
function U0(e, t) {
  return !!e && !!t && e <= t;
}
function G0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: o,
  max: s,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const f = !!e && !!t && e > t, _ = /* @__PURE__ */ new Date(), p = i === !1 ? [] : Array.isArray(i) ? i : Yu({ y: _.getFullYear(), m: _.getMonth() + 1, d: _.getDate() }, r), y = (d) => (!o || d.from >= o) && (!s || d.to <= s);
  return /* @__PURE__ */ n.createElement("span", { className: ae.range }, /* @__PURE__ */ n.createElement(
    Pa,
    {
      value: e,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: u && ((d, b) => u(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    Pa,
    {
      value: t,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: u && ((d, b) => u(d, b, "to"))
    }
  ), p.length > 0 && /* @__PURE__ */ n.createElement(
    ys,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: p.map((d) => ps(
        d.label,
        d.label,
        () => a(d.from, d.to),
        y(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const Rr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function Pr(e, t = Rr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const o of t) o.start <= e.slice(0, 10) && (!r || o.start > r.start) && (r = o);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Nm(e, t = {}) {
  const a = Pr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function Y0(e, t) {
  const a = Pr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, Sn = (e) => String(e).padStart(2, "0");
function _e(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function Bt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function on(e) {
  const t = new Date(e * 6e4);
  return `${Bt(e)}T${Sn(t.getUTCHours())}:${Sn(t.getUTCMinutes())}`;
}
function Je(e) {
  const t = (e % Se + Se) % Se;
  return `${Sn(Math.floor(t / 60))}:${Sn(t % 60)}`;
}
function ve(e, t) {
  return de(e) ? In(e, t) : e;
}
function Gt(e, t) {
  return Math.round((_e(t) - _e(e)) / Se);
}
function _n(e) {
  if (!de(e)) return !1;
  const t = va(e);
  return t === 0 || t === 6;
}
function $m(e) {
  var o;
  const t = _e(e.start);
  if (Number.isNaN(t)) return null;
  const a = (o = e.allDay) != null ? o : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = Bt(t), l = e.end ? Bt(_e(e.end)) : s, c = l < s ? s : l;
    return { ev: e, s: _e(s), e: _e(c) + Se, allDay: a, sDay: s, eDay: c };
  }
  let r = e.end ? _e(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: Bt(t), eDay: Bt(r - 1) };
}
function Rn(e, t, a, r) {
  const o = [];
  for (const s of e) {
    const l = r && s.id === r.id ? { ...s, start: r.start, end: r.end } : s, c = $m(l);
    c && c.eDay >= t && c.sDay <= a && o.push(c);
  }
  return o.sort(xm);
}
function xm(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Gt(t.sDay, t.eDay) - Gt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function Dm(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Or(e) {
  return e.allDay || e.e - e.s >= Se;
}
function Mn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Ie(a) - t + 7) % 7;
  return ve(e, -r);
}
function Pn(e, t) {
  const a = Gt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, o) => ve(e, o));
}
function zr(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), o = tt(a.y, a.m, Le(a.y, a.m)), s = Mn(r, t), l = ve(Mn(o, t), 6), c = Pn(s, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function ka(e, t, a) {
  if (e === "month") {
    const r = zr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = Mn(t, a);
    return { from: r, to: ve(r, 6) };
  }
  return { from: t, to: t };
}
function Am(e, t, a, r = !1) {
  const o = de(t);
  if (!o) return t;
  if (e === "month" || e === "agenda") {
    const l = wt(o, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ve(t, 7 * a);
  let s = ve(t, a);
  for (; r && _n(s); ) s = ve(s, a);
  return s;
}
function Cm(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: o, to: s } = ka("week", t, a);
  return r.year(o) !== r.year(s) ? `${r.ymd(o)} – ${r.ymd(s)}` : o.slice(5, 7) !== s.slice(5, 7) ? `${r.ymd(o)} – ${r.md(s)}` : `${r.ymd(o)} – ${r.d(s)}`;
}
function Xr(e, t) {
  const a = [], r = [];
  for (const o of e) {
    let s = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= o.sDay && t[i] <= o.eDay && (s < 0 && (s = i), l = i);
    if (s < 0) continue;
    let c = r.findIndex((i) => i < s);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: o, col: s, span: l - s + 1, lane: c, contL: o.sDay < t[s], contR: o.eDay > t[l] });
  }
  return a;
}
function Sm(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const o = Math.max(1, a), s = e.filter((c) => {
    if (c.lane < o - 1) return !0;
    if (c.lane > o - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > o) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of s) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: s, more: r.map((c, i) => c - l[i]) };
}
const Mm = 20;
function Tm(e, t) {
  const a = _e(t), r = a + Se, o = e.filter((m) => !Or(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let s = [], l = [], c = -1;
  const i = () => {
    for (const m of s) m.cols = l.length;
    s = [], l = [];
  };
  for (const m of o) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + Mm);
    let f = l.findIndex((_) => _ <= m.top);
    f < 0 ? (f = l.length, l.push(u)) : l[f] = u, m.col = f, s.push(m), c = Math.max(c, u);
  }
  return i(), o;
}
function Oa(e, t) {
  return Math.round(e / t) * t;
}
function sa(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ve(e.sDay, a), end: ve(e.eDay, a) };
  }
  return { start: on(e.s + t), end: on(e.e + t) };
}
function wa(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = _e(e.sDay), r = Je(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : Je(e.e - a)}`;
  const o = de(e.sDay), s = de(Bt(e.e));
  return `${o.m}/${o.d} ${r} – ${s.m}/${s.d} ${Je(e.e - _e(Bt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: Ie(t) };
};
function za(e, t, a, r, o) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return s;
  const l = Nm(e, { eras: r, gannen: o });
  return l ? t === "era" ? l : `${s}(${l})` : s;
}
function qm(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : Rr, o = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], f = (p) => za(p, a, "年", r, o), _ = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${_[p]} (P)`,
      next: (p) => `次の${_[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, y) => `${p}/${y}日目`,
      openDay: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: f,
      ym: (p) => `${f(p)}${Ae(p).m}月`,
      ymd: (p) => {
        const y = Ae(p);
        return `${f(p)}${y.m}月${y.d}日`;
      },
      md: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日`;
      },
      d: (p) => `${Ae(p).d}日`,
      m: (p) => `${Ae(p).m}月`,
      dayTitle: (p) => {
        const y = Ae(p);
        return `${f(p)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => za(u, a, "년", r, o), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, f) => `${u}/${f}일째`,
    openDay: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${Ae(u).m}월`,
    ymd: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일`;
    },
    md: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일`;
    },
    d: (u) => `${Ae(u).d}일`,
    m: (u) => `${Ae(u).m}월`,
    dayTitle: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일 (${s[f.w]})`;
    },
    dayAria: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 ${s[f.w]}요일`;
    }
  };
}
const Fr = qm("ko"), Bm = "_cal_38qtm_2", Lm = "_toolbar_38qtm_20", jm = "_navBtns_38qtm_28", Im = "_title_38qtm_29", Rm = "_toolRight_38qtm_36", Pm = "_toggle_38qtm_37", Om = "_body_38qtm_58", zm = "_busy_38qtm_59", Xm = "_sun_38qtm_71", Fm = "_sat_38qtm_72", Wm = "_tAccent_38qtm_75", Hm = "_tOk_38qtm_76", Km = "_tWarn_38qtm_77", Um = "_tDanger_38qtm_78", Gm = "_tViolet_38qtm_79", Ym = "_tGray_38qtm_80", Vm = "_month_38qtm_83", Qm = "_mHead_38qtm_84", Jm = "_wdName_38qtm_85", Zm = "_mBody_38qtm_91", ed = "_mWeek_38qtm_92", td = "_mCells_38qtm_94", nd = "_cell_38qtm_96", ad = "_out_38qtm_104", rd = "_dayNum_38qtm_105", od = "_creatable_38qtm_106", sd = "_selDay_38qtm_109", ld = "_cellHead_38qtm_111", cd = "_isToday_38qtm_124", id = "_holiday_38qtm_125", ud = "_addHint_38qtm_130", md = "_barLayer_38qtm_138", dd = "_chip_38qtm_139", fd = "_more_38qtm_139", _d = "_tEv_38qtm_155", pd = "_aRow_38qtm_155", yd = "_popItem_38qtm_155", bd = "_bar_38qtm_138", Ed = "_contL_38qtm_165", hd = "_contR_38qtm_166", gd = "_dotChip_38qtm_167", vd = "_dot_38qtm_167", kd = "_chipTime_38qtm_170", wd = "_chipTitle_38qtm_171", Nd = "_movable_38qtm_173", $d = "_ghost_38qtm_176", xd = "_time_38qtm_189", Dd = "_tHead_38qtm_190", Ad = "_tAllDay_38qtm_190", Cd = "_gutter_38qtm_193", Sd = "_tHeadDays_38qtm_197", Md = "_tAllDayCells_38qtm_197", Td = "_tDay_38qtm_198", qd = "_tDayBtn_38qtm_202", Bd = "_tWd_38qtm_206", Ld = "_tDayNum_38qtm_208", jd = "_tAllDayRow_38qtm_216", Id = "_allDayCell_38qtm_218", Rd = "_tBody_38qtm_222", Pd = "_tGrid_38qtm_223", Od = "_tGutter_38qtm_224", zd = "_tCols_38qtm_230", Xd = "_tCol_38qtm_230", Fd = "_tSel_38qtm_238", Wd = "_tEvTitle_38qtm_258", Hd = "_tEvTime_38qtm_259", Kd = "_tEvShort_38qtm_261", Ud = "_contTop_38qtm_263", Gd = "_contBottom_38qtm_264", Yd = "_resize_38qtm_265", Vd = "_now_38qtm_268", Qd = "_agenda_38qtm_272", Jd = "_aDay_38qtm_273", Zd = "_aDate_38qtm_275", ef = "_aDateBtn_38qtm_276", tf = "_aDayNum_38qtm_280", nf = "_aDayWd_38qtm_286", af = "_aList_38qtm_288", rf = "_aTime_38qtm_295", of = "_aTitle_38qtm_296", sf = "_aSpan_38qtm_297", lf = "_aLoc_38qtm_298", cf = "_empty_38qtm_303", uf = "_pop_38qtm_155", mf = "_popHead_38qtm_321", df = "_popDay_38qtm_322", ff = "_popClose_38qtm_329", _f = "_popList_38qtm_334", pf = "_tAllDayOnly_38qtm_348", S = {
  cal: Bm,
  toolbar: Lm,
  navBtns: jm,
  title: Im,
  toolRight: Rm,
  toggle: Pm,
  body: Om,
  busy: zm,
  sun: Xm,
  sat: Fm,
  tAccent: Wm,
  tOk: Hm,
  tWarn: Km,
  tDanger: Um,
  tViolet: Gm,
  tGray: Ym,
  month: Vm,
  mHead: Qm,
  wdName: Jm,
  mBody: Zm,
  mWeek: ed,
  mCells: td,
  cell: nd,
  out: ad,
  dayNum: rd,
  creatable: od,
  selDay: sd,
  cellHead: ld,
  isToday: cd,
  holiday: id,
  addHint: ud,
  barLayer: md,
  chip: dd,
  more: fd,
  tEv: _d,
  aRow: pd,
  popItem: yd,
  bar: bd,
  contL: Ed,
  contR: hd,
  dotChip: gd,
  dot: vd,
  chipTime: kd,
  chipTitle: wd,
  movable: Nd,
  ghost: $d,
  time: xd,
  tHead: Dd,
  tAllDay: Ad,
  gutter: Cd,
  tHeadDays: Sd,
  tAllDayCells: Md,
  tDay: Td,
  tDayBtn: qd,
  tWd: Bd,
  tDayNum: Ld,
  tAllDayRow: jd,
  allDayCell: Id,
  tBody: Rd,
  tGrid: Pd,
  tGutter: Od,
  tCols: zd,
  tCol: Xd,
  tSel: Fd,
  tEvTitle: Wd,
  tEvTime: Hd,
  tEvShort: Kd,
  contTop: Ud,
  contBottom: Gd,
  resize: Yd,
  now: Vd,
  agenda: Qd,
  aDay: Jd,
  aDate: Zd,
  aDateBtn: ef,
  aDayNum: tf,
  aDayWd: nf,
  aList: af,
  aTime: rf,
  aTitle: of,
  aSpan: sf,
  aLoc: lf,
  empty: cf,
  pop: uf,
  popHead: mf,
  popDay: df,
  popClose: ff,
  popList: _f,
  tAllDayOnly: pf
}, pn = 22, yf = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function On(e) {
  var t;
  return e.color ? "" : yf[(t = e.tone) != null ? t : "accent"];
}
function zn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function Wr(e, t) {
  return [e.ev.title, wa(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const sn = (e, t) => !!e.onEventChange && !t.locked;
function Dn(e, t, a) {
  var r;
  for (const o of document.elementsFromPoint(e, t)) {
    const s = (r = o.closest) == null ? void 0 : r.call(o, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function Tn(e, t) {
  const a = e.clientX, r = e.clientY;
  let o = !1;
  const s = (u) => {
    !o && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (o = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, o);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function Hr(e) {
  const [t, a] = A(null), [r, o] = A(null), s = B(!1);
  return { preview: t, items: (f, _) => Rn(e.events, f, _, t), onItemDown: (f, _) => {
    var d;
    if (f.button !== 0 || !sn(e, _.ev)) return;
    const p = (d = Dn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!p) return;
    s.current = !1;
    let y = 0;
    Tn(f, {
      move: (b) => {
        var $;
        s.current = !0;
        const N = ($ = Dn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : $.dataset.calDay;
        N && (y = Gt(p, N), a({ id: _.ev.id, ...sa(_, y * Se) }));
      },
      end: (b, N) => {
        var $;
        a(null), N && y && (($ = e.onEventChange) == null || $.call(e, _.ev, sa(_, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, _) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let p = _;
    o({ a: _, b: _ }), Tn(f, {
      move: (y) => {
        var b;
        const d = (b = Dn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (p = d, o({ a: _, b: d }));
      },
      end: () => {
        var b;
        o(null);
        const [y, d] = _ <= p ? [_, p] : [p, _];
        (b = e.onCreate) == null || b.call(e, { start: y, end: d, allDay: !0 });
      },
      cancel: () => o(null)
    });
  }, clickItem: (f, _) => {
    var p;
    if (s.current) {
      s.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, _, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function Kr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: o
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((s) => {
    var f;
    const l = s.item, c = l.ev, i = Dm(l), m = Je(l.s - _e(l.sDay)), u = [
      S.chip,
      i ? S.bar : S.dotChip,
      On(c),
      s.contL ? S.contL : "",
      s.contR ? S.contR : "",
      ((f = o.preview) == null ? void 0 : f.id) === c.id ? S.ghost : "",
      sn(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${s.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${s.col / t * 100}% + 2px)`,
          width: `calc(${s.span / t * 100}% - 4px)`,
          top: a + s.lane * pn,
          ...zn(c)
        },
        "aria-label": Wr(l, r.L),
        onPointerDown: (_) => o.onItemDown(_, l),
        onClick: (_) => o.clickItem(_.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Un = 26;
function bf({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: o, showWeekends: s, holidays: l } = e, c = a.slice(0, 7), i = ke(
    () => zr(a, o).map((x) => s ? x : x.filter((h) => !_n(h))),
    [a, o, s]
  ), m = i[0].length, u = Hr(e), f = u.items(i[0][0], i[i.length - 1][m - 1]), _ = B(null), [p, y] = A(0);
  $e(() => {
    const x = _.current;
    if (!x) return;
    const h = () => y(x.clientHeight / i.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const w = new ResizeObserver(h);
    return w.observe(x), () => w.disconnect();
  }, [i.length]);
  const d = p ? Math.max(1, Math.floor((p - Un - 4) / pn)) : 3, b = B(!1), N = B(null);
  U(() => {
    var x, h;
    b.current && (b.current = !1, (h = (x = N.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, c]);
  const $ = (x, h) => {
    let w = ve(x, h);
    for (; !s && _n(w); ) w = ve(w, h > 0 ? 1 : -1);
    return w;
  }, g = (x, h, w) => {
    let E = null;
    if (x.key === "ArrowLeft") E = $(h, -1);
    else if (x.key === "ArrowRight") E = $(h, 1);
    else if (x.key === "ArrowUp") E = $(h, -7);
    else if (x.key === "ArrowDown") E = $(h, 7);
    else if (x.key === "Home") E = w[0];
    else if (x.key === "End") E = w[w.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", h);
      return;
    }
    E && (x.preventDefault(), b.current = !0, e.setCursor(E));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: N }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map((x) => {
    const h = Ie(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [S.wdName, h === 0 ? S.sun : "", h === 6 ? S.sat : ""].join(" ") }, t.weekdays[h]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: _ }, i.map((x) => {
    const { shown: h, more: w } = Sm(Xr(f, x), m, d);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, x.map((E) => {
      const D = de(E), C = Ie(D), T = l[E], M = f.filter((q) => q.sDay <= E && q.eDay >= E).length, I = [
        S.cell,
        E.slice(0, 7) !== c ? S.out : "",
        C === 0 || T ? S.sun : C === 6 ? S.sat : "",
        E === r ? S.isToday : "",
        u.inSel(E) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: E,
          role: "gridcell",
          "data-cal-day": E,
          tabIndex: E === a ? 0 : -1,
          "aria-selected": E === a,
          "aria-current": E === r ? "date" : void 0,
          "aria-label": `${t.dayAria(E)}${T ? ` ${T}` : ""}, ${t.eventCount(M)}`,
          className: I,
          onPointerDown: (q) => u.onCellDown(q, E),
          onKeyDown: (q) => g(q, E, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(E),
            onPointerDown: (q) => q.stopPropagation(),
            onClick: () => e.goto("day", E)
          },
          D.d === 1 ? t.md(E) : D.d
        ), T && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: T }, T), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Kr, { segs: h, cols: m, top: Un, ctx: e, drag: u }), w.map((E, D) => E > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[D],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${D / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: Un + (d - 1) * pn
        },
        onClick: (C) => e.openMore(x[D], C.currentTarget)
      },
      t.more(E)
    ) : null));
  })));
}
const Ye = 44, Ef = Array.from({ length: 23 }, (e, t) => t + 1);
function Xa() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Gn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Ye * 60));
}
function Fa({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, o = Hr(e), [s, l] = A(null), [c, i] = A(null), m = B(!1), u = Rn(e.events, t[0], t[a - 1], s != null ? s : o.preview), f = Xr(e.timeGrid ? u.filter(Or) : u, t), _ = f.reduce((h, w) => Math.max(h, w.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, d] = A(Xa);
  U(() => {
    const h = window.setInterval(() => d(Xa()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const b = B(null), N = t.includes(e.today);
  $e(() => {
    const h = b.current;
    if (!h) return;
    const w = N ? Math.max(0, Math.floor((y - _e(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = w * Ye;
  }, [t[0], a]);
  const $ = (h, w) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const E = h.currentTarget, D = Math.min(Se - r, Math.floor(Gn(h.clientY, E) / r) * r);
    let C = D;
    i({ day: w, a: D, b: D + r }), Tn(h, {
      move: (T) => {
        C = Math.min(Se - r, Math.floor(Gn(T.clientY, E) / r) * r), i({ day: w, a: Math.min(D, C), b: Math.max(D, C) + r });
      },
      end: (T, M) => {
        var Y;
        i(null);
        const I = _e(w), q = M ? Math.min(D, C) : D, F = M ? Math.max(D, C) + r : Math.min(D + 60, Se);
        (Y = e.onCreate) == null || Y.call(e, { start: on(I + q), end: on(I + F), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, g = (h, w, E) => {
    if (h.stopPropagation(), h.button !== 0 || !sn(e, w.ev)) return;
    const D = (M, I) => {
      const q = Dn(M, I, "data-cal-col");
      return q ? _e(q.dataset.calCol) + Gn(I, q) : null;
    }, C = D(h.clientX, h.clientY);
    if (C == null) return;
    m.current = !1;
    let T = null;
    Tn(h, {
      move: (M) => {
        m.current = !0;
        const I = D(M.clientX, M.clientY);
        if (I != null) {
          if (E === "move") {
            const q = Oa(I - C, r);
            T = q ? sa(w, q) : null;
          } else {
            const q = Math.max(w.s + r, Oa(I, r));
            T = q !== w.e ? { start: w.ev.start, end: on(q) } : null;
          }
          l(T ? { id: w.ev.id, ...T } : null);
        }
      },
      end: (M, I) => {
        var q;
        l(null), I && T && ((q = e.onEventChange) == null || q.call(e, w.ev, T));
      },
      cancel: () => l(null)
    });
  }, x = (h, w) => {
    var E;
    if (m.current) {
      m.current = !1;
      return;
    }
    (E = e.onEventClick) == null || E.call(e, w, h);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: p }, t.map((h) => {
    const w = de(h), E = Ie(w), D = e.holidays[h];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        className: [S.tDay, h === e.today ? S.isToday : "", E === 0 || D ? S.sun : E === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[E]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, w.d)),
      D && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: D }, D)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, _) * pn + 6 } : { minHeight: Math.max(1, _) * pn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: p }, t.map((h) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-day": h,
        className: [S.allDayCell, o.inSel(h) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (w) => o.onCellDown(w, h)
      }
    ))),
    /* @__PURE__ */ n.createElement(Kr, { segs: f, cols: a, top: 3, ctx: e, drag: o })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Ye } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, Ef.map((h) => /* @__PURE__ */ n.createElement("span", { key: h, style: { top: h * Ye } }, Je(h * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ...p, backgroundSize: `100% ${Ye}px` } }, t.map((h) => {
    const w = Tm(u, h);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [S.tCol, h === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (E) => $(E, h)
      },
      (c == null ? void 0 : c.day) === h && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Ye, height: (c.b - c.a) / 60 * Ye } }, Je(c.a), " – ", c.b === Se ? "24:00" : Je(c.b)),
      w.map((E) => {
        const D = E.item.ev, C = (E.bottom - E.top) / 60 * Ye, T = [
          S.tEv,
          On(D),
          C < 34 ? S.tEvShort : "",
          E.contTop ? S.contTop : "",
          E.contBottom ? S.contBottom : "",
          (s == null ? void 0 : s.id) === D.id ? S.ghost : "",
          sn(e, D) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: D.id,
            type: "button",
            className: T,
            style: {
              top: E.top / 60 * Ye,
              height: Math.max(18, C - 1),
              left: `calc(${E.col / E.cols * 100}% + 1px)`,
              width: `calc(${100 / E.cols}% - 4px)`,
              ...zn(D)
            },
            "aria-label": Wr(E.item, e.L),
            onPointerDown: (M) => g(M, E.item, "move"),
            onClick: (M) => x(M.currentTarget, D)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, D.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, wa(E.item, e.L.allDay)),
          sn(e, D) && !E.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (M) => g(M, E.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (y - _e(h)) / 60 * Ye }, "aria-hidden": !0 })
    );
  })))));
}
function Wa(e, t, a) {
  return e.sDay === e.eDay ? wa(e, a) : e.allDay ? a : t === e.sDay ? `${Je(e.s - _e(t))} ~` : t === e.eDay ? `~ ${Je(e.e - _e(t))}` : a;
}
function hf({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = ka("agenda", e.cursor, e.weekStartsOn), o = Rn(e.events, a, r), s = Pn(a, r).filter((l) => e.showWeekends || !_n(l)).map((l) => {
    const c = _e(l), i = (u) => Wa(u, l, "") === "" ? -1 : Math.max(u.s, c), m = o.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, f) => i(u) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, s.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = Ie(i), f = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, u === 0 || m ? S.sun : u === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", f)), m && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((_) => {
      const p = _.ev, y = Gt(_.sDay, _.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: p.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, On(p)].join(" "),
          style: zn(p),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, p, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Wa(_, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, p.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Gt(_.sDay, l) + 1, y))),
        p.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const Yn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Ha(e, t, a) {
  const [r, o] = A(t), s = e !== void 0 ? e : r;
  return [s, (c) => {
    e === void 0 && o(c), c !== s && (a == null || a(c));
  }];
}
const Ka = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function V0({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: o,
  defaultDate: s,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: f,
  slotMinutes: _ = 30,
  scrollToHour: p = 8,
  timeGrid: y = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: N,
  onEventChange: $,
  locale: g = Fr,
  loading: x,
  headerExtra: h,
  className: w = "",
  style: E,
  "aria-label": D
}) {
  var G;
  const C = Ir(), [T, M] = Ha(t, (G = a != null ? a : c[0]) != null ? G : "month", r), [I, q] = Ha(o, s != null ? s : C, l), F = de(I) ? I : C, [Y, W] = A(m), [j, ne] = A(null), te = B(null), v = B(!1);
  U(() => {
    var H;
    if (!v.current) return;
    v.current = !1;
    const z = te.current;
    !z || z.contains(document.activeElement) || ((H = z.querySelector('[data-cal-day][tabindex="0"]')) != null ? H : z).focus();
  });
  const { from: O, to: V } = ka(T, F, i), Q = B(d);
  Q.current = d, U(() => {
    var z;
    (z = Q.current) == null || z.call(Q, { from: O, to: V, view: T });
  }, [O, V, T]);
  const se = (z, H) => {
    q(H), c.includes(z) && M(z);
  }, L = {
    events: e,
    L: g,
    cursor: F,
    today: C,
    weekStartsOn: i,
    showWeekends: Y,
    holidays: f != null ? f : {},
    slotMinutes: _,
    scrollToHour: p,
    timeGrid: y,
    setCursor: q,
    goto: se,
    openMore: (z, H) => ne({ day: z, anchor: H }),
    onEventClick: b,
    onCreate: N,
    onEventChange: $
  }, Z = (z) => q(Am(T, F, z, T === "day" && !Y)), R = (z) => {
    if (z.defaultPrevented || z.ctrlKey || z.metaKey || z.altKey || z.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const H = z.nativeEvent.code;
    if (H === "KeyT") q(C);
    else if (H === "KeyN" || H === "KeyJ" || z.key === "PageDown") Z(1);
    else if (H === "KeyP" || H === "KeyK" || z.key === "PageUp") Z(-1);
    else if (Yn[H] && c.includes(Yn[H])) M(Yn[H]);
    else if (H === "KeyC" && N)
      N(T === "month" || T === "agenda" ? { start: F, end: F, allDay: !0 } : { start: `${F}T09:00`, end: `${F}T10:00`, allDay: !1 });
    else return;
    z.preventDefault(), v.current = !0;
  }, X = ke(
    () => Pn(O, V).filter((z) => Y || !_n(z)),
    [O, V, Y]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, w].filter(Boolean).join(" "),
      style: E,
      role: "region",
      "aria-label": D != null ? D : g.region,
      "aria-busy": x || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: te,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(et, { onClick: () => q(C), title: `${g.today} (T)` }, g.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(ra, { label: g.prev(T), onClick: () => Z(-1) }, /* @__PURE__ */ n.createElement(Ka, { dir: "l" })), /* @__PURE__ */ n.createElement(ra, { label: g.next(T), onClick: () => Z(1) }, /* @__PURE__ */ n.createElement(Ka, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, Cm(T, F, i, g)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, h, u && T !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !Y,
        onClick: () => W((z) => !z)
      },
      g.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      Dr,
      {
        variant: "segmented",
        "aria-label": g.viewTabs,
        items: c.map((z) => ({ key: z, label: g.views[z] })),
        value: T,
        onChange: (z) => M(z)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, x && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": g.loading }), T === "month" && /* @__PURE__ */ n.createElement(bf, { ctx: L }), T === "week" && /* @__PURE__ */ n.createElement(Fa, { ctx: L, days: X }), T === "day" && /* @__PURE__ */ n.createElement(Fa, { ctx: L, days: [F] }), T === "agenda" && /* @__PURE__ */ n.createElement(hf, { ctx: L })),
    j && /* @__PURE__ */ n.createElement(gf, { ctx: L, day: j.day, anchor: j.anchor, onClose: () => ne(null) })
  );
}
function gf({ ctx: e, day: t, anchor: a, onClose: r }) {
  const o = B(null), [s, l] = A({ top: -9999, left: -9999 }), c = de(t), i = Rn(e.events, t, t);
  return $e(() => {
    var p;
    const m = o.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), f = m.offsetWidth, _ = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - _ - 8))
    }), (p = m.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), U(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (_) => {
      var p;
      (p = o.current) != null && p.contains(_.target) || r();
    }, f = (_) => {
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { ref: o, className: S.pop, style: s, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Ie(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((m) => {
    const u = m.ev, f = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, f ? S.bar : S.dotChip, On(u)].join(" "),
        style: zn(u),
        onClick: () => {
          var _;
          r(), (_ = e.onEventClick) == null || _.call(e, u, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, Je(Math.max(m.s, _e(t)) - _e(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, u.title)
    ));
  }))));
}
const vf = "_mini_10rxe_3", kf = "_nav_10rxe_5", wf = "_navBtn_10rxe_6", Nf = "_todayBtn_10rxe_6", $f = "_title_10rxe_6", xf = "_day_10rxe_25", Df = "_mon_10rxe_25", Af = "_grid_10rxe_29", Cf = "_wdRow_10rxe_30", Sf = "_row_10rxe_30", Mf = "_sun_10rxe_35", Tf = "_sat_10rxe_36", qf = "_num_10rxe_45", Bf = "_sel_10rxe_46", Lf = "_out_10rxe_50", jf = "_isToday_10rxe_52", If = "_dots_10rxe_55", Rf = "_months_10rxe_59", le = {
  mini: vf,
  nav: kf,
  navBtn: wf,
  todayBtn: Nf,
  title: $f,
  day: xf,
  mon: Df,
  grid: Af,
  wdRow: Cf,
  row: Sf,
  sun: Mf,
  sat: Tf,
  num: qf,
  sel: Bf,
  out: Lf,
  isToday: jf,
  dots: If,
  months: Rf
}, Ua = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function Q0({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: o = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Fr,
  today: m,
  children: u,
  className: f = "",
  "aria-label": _
}) {
  const p = m != null ? m : Ir(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, d = de(y), b = Mn(y, c), N = Pn(b, ve(b, 41)), $ = s != null ? s : i.eventCount, [g, x] = A("day"), [h, w] = A(d.y), E = (W) => !!W && W.slice(0, 7) === y.slice(0, 7), [D, C] = A(() => E(a) ? a : E(p) ? p : y);
  U(() => {
    E(D) || C(E(a) ? a : E(p) ? p : y);
  }, [y]);
  const T = B(!1), M = B(null);
  U(() => {
    var W, j;
    T.current && (T.current = !1, (j = (W = M.current) == null ? void 0 : W.querySelector(`[data-day="${D}"]`)) == null || j.focus());
  }, [D, y]);
  const I = (W) => {
    T.current = !0, C(W), E(W) || t(W.slice(0, 7));
  }, q = (W) => {
    const j = wt(d, W);
    t(Ua(j.y, j.m));
  }, F = (W, j) => {
    const ne = de(j), te = (Ie(ne) - c + 7) % 7;
    let v = null;
    if (W.key === "ArrowLeft") v = ve(j, -1);
    else if (W.key === "ArrowRight") v = ve(j, 1);
    else if (W.key === "ArrowUp") v = ve(j, -7);
    else if (W.key === "ArrowDown") v = ve(j, 7);
    else if (W.key === "Home") v = ve(j, -te);
    else if (W.key === "End") v = ve(j, 6 - te);
    else if (W.key === "PageUp" || W.key === "PageDown") {
      const O = wt(ne, W.key === "PageUp" ? -1 : 1);
      v = tt(O.y, O.m, O.d);
    }
    v && (W.preventDefault(), I(v));
  }, Y = () => {
    w(d.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, f].filter(Boolean).join(" "), role: _ ? "group" : void 0, "aria-label": _ }, g === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => q(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: Y }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => q(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: E(p),
      onClick: () => {
        t(p.slice(0, 7)), I(p);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => w((W) => W - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${h}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => w((W) => W + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), g === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (W) => {
    W.key === "Escape" && (W.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (W, j) => {
    const ne = Ua(h, j + 1), te = ne === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, te ? le.sel : "", ne === p.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ne), x("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(y), ref: M }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, N.slice(0, 7).map((W) => {
    const j = Ie(de(W));
    return /* @__PURE__ */ n.createElement("span", { key: W, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((W) => /* @__PURE__ */ n.createElement("div", { key: W, className: le.row, role: "row" }, N.slice(W * 7, W * 7 + 7).map((j) => {
    var V;
    const ne = Ie(de(j)), te = l[j], v = (V = o[j]) != null ? V : 0, O = [
      le.day,
      E(j) ? "" : le.out,
      ne === 0 || te ? le.sun : ne === 6 ? le.sat : "",
      j === p ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: O,
        tabIndex: j === D ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === p ? "date" : void 0,
        "aria-label": [i.dayAria(j), te, v ? $(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => F(Q, j),
        onFocus: () => C(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), u);
}
function Pf(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function J0({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: o,
  className: s,
  ...l
}) {
  const c = B(null), i = B(null), [m, u] = A(!1), f = e == null || e === "";
  $e(() => {
    const p = c.current, y = i.current;
    if (i.current = null, !p || y === null) return;
    let d = 0, b = 0;
    for (; d < p.value.length && b < y; )
      /\d/.test(p.value[d]) && (b += 1), d += 1;
    d === 0 && p.value[0] === "-" && (d = 1), p.setSelectionRange(d, d);
  });
  const _ = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: m && f ? "-" : yo(e),
      onChange: (p) => {
        var b;
        const y = p.target;
        i.current = Pf(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const d = _o(y.value, a);
        if (r) {
          const N = kr(y.value);
          !a && /^\s*-/.test(N) ? r("sign") : (/\.\d/.test(N.replace(/^\s*-/, "")) || /\.$/.test(N)) && r("decimal");
        }
        u(d === "-"), t({ text: d, num: po(d) });
      }
    }
  );
  return o ? /* @__PURE__ */ n.createElement(n.Fragment, null, _, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, o)) : _;
}
function la(e) {
  const t = kr(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function Ga(e, t) {
  const a = la(e), r = la(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function Z0(e, t) {
  var s, l;
  const a = Ga(e.qty, e.unitAm), r = Ga((s = t.qty) != null ? s : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const o = la(e.lineAm);
  return o == null || o === a ? { ...t, lineAm: String(r) } : t;
}
const Of = "_box_qzg36_3", zf = "_banner_qzg36_9", Xf = "_verify_qzg36_10", Ff = "_t_info_qzg36_15", Wf = "_t_warn_qzg36_16", Hf = "_t_danger_qzg36_17", Kf = "_error_qzg36_22", Uf = "_note_qzg36_30", Gf = "_noteI_qzg36_42", Yf = "_noteBody_qzg36_43", Vf = "_badge_qzg36_49", Qf = "_b_muted_qzg36_53", Jf = "_b_ok_qzg36_54", Zf = "_b_warn_qzg36_55", e_ = "_b_info_qzg36_56", t_ = "_b_off_qzg36_57", Xe = {
  box: Of,
  banner: zf,
  verify: Xf,
  t_info: Ff,
  t_warn: Wf,
  t_danger: Hf,
  error: Kf,
  note: Uf,
  noteI: Gf,
  noteBody: Yf,
  badge: Vf,
  b_muted: Qf,
  b_ok: Jf,
  b_warn: Zf,
  b_info: e_,
  b_off: t_
};
function n_({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.banner, Xe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function ek({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.verify, Xe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Ur({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Xe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(a_, { text: t }) : t);
}
function tk({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Xe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Xe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Xe.noteBody }, a));
}
function Ya({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Xe.badge, Xe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function a_({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(uo, { key: a }, t))) : null;
}
const r_ = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function o_(e, t = r_) {
  const a = B(e);
  return a.current = e, U(() => {
    if (!e) return;
    const r = (o) => {
      o.preventDefault(), o.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), re(() => !a.current || window.confirm(t), [t]);
}
const s_ = "_overlay_1s8aj_2", l_ = "_modal_1s8aj_8", c_ = "_wide_1s8aj_15", i_ = "_head_1s8aj_16", u_ = "_title_1s8aj_20", m_ = "_close_1s8aj_21", d_ = "_body_1s8aj_25", f_ = "_flush_1s8aj_26", __ = "_error_1s8aj_27", p_ = "_foot_1s8aj_29", y_ = "_overlayTop_1s8aj_35", Oe = {
  overlay: s_,
  modal: l_,
  wide: c_,
  head: i_,
  title: u_,
  close: m_,
  body: d_,
  flush: f_,
  error: __,
  foot: p_,
  overlayTop: y_
}, qt = [];
function Va(e) {
  const t = qt[qt.length - 1];
  if (e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc) return;
  const a = document.activeElement;
  a instanceof HTMLSelectElement || a != null && a.closest('[aria-expanded="true"]') || (e.preventDefault(), t.close());
}
const b_ = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Qa(e) {
  return Array.from(e.querySelectorAll(b_)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Ja = 0, Za = "";
function Xn({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: o,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !0,
  error: m,
  confirmDiscard: u = !0,
  layer: f
}) {
  const [_, p] = A(!1), y = u ? () => {
    _ || p(!0);
  } : void 0, d = o_(u && _, "입력한 내용을 저장하지 않고 닫을까요?"), b = () => {
    d() && t();
  }, N = B(b);
  N.current = b;
  const $ = B({ close: () => N.current(), esc: i });
  $.current.esc = i, U(() => {
    const E = $.current;
    return qt.push(E), qt.length === 1 && window.addEventListener("keydown", Va), () => {
      const D = qt.lastIndexOf(E);
      D >= 0 && qt.splice(D, 1), qt.length === 0 && window.removeEventListener("keydown", Va);
    };
  }, []);
  const g = B(null), x = B(null), h = B(void 0);
  h.current === void 0 && (h.current = typeof document == "undefined" ? null : document.activeElement), U(() => {
    var C;
    const E = g.current, D = (C = h.current) != null ? C : null;
    return E && !E.contains(document.activeElement) && (x.current && Qa(x.current)[0] || null || E).focus(), Ja++ === 0 && (Za = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ja === 0 && (document.body.style.overflow = Za), D && D.isConnected && typeof D.focus == "function" && D.focus();
    };
  }, []);
  const w = (E) => {
    const D = g.current;
    if (E.key !== "Tab" || !D || !D.contains(E.target)) return;
    const C = Qa(D);
    if (C.length === 0) {
      E.preventDefault(), D.focus();
      return;
    }
    const T = C[0], M = C[C.length - 1], I = document.activeElement;
    E.shiftKey && (I === T || I === D) ? (E.preventDefault(), M.focus()) : !E.shiftKey && I === M && (E.preventDefault(), T.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: f === "top" ? `${Oe.overlay} ${Oe.overlayTop}` : Oe.overlay, onClick: c ? b : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: g,
      tabIndex: -1,
      className: [Oe.modal, r ? Oe.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (E) => E.stopPropagation(),
      onKeyDown: w
    },
    /* @__PURE__ */ n.createElement("header", { className: Oe.head }, /* @__PURE__ */ n.createElement("strong", { className: Oe.title }, e), s, /* @__PURE__ */ n.createElement("button", { type: "button", className: Oe.close, onClick: b, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: x,
        className: [Oe.body, l ? Oe.flush : ""].filter(Boolean).join(" "),
        onInputCapture: y,
        onChangeCapture: y
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Oe.error }, /* @__PURE__ */ n.createElement(Ur, null, m)),
    o && /* @__PURE__ */ n.createElement("footer", { className: Oe.foot }, o)
  ));
}
function nk(e = 4e3) {
  const [t, a] = A(""), [r, o] = A(!1), s = B(void 0), l = re((m) => {
    window.clearTimeout(s.current), o(!1), a(m), s.current = window.setTimeout(() => a(""), e);
  }, [e]), c = re((m) => {
    window.clearTimeout(s.current), o(!0), a(m);
  }, []), i = re(() => {
    window.clearTimeout(s.current), o(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const E_ = "_message_psco6_1", h_ = "_details_psco6_2", g_ = "_warn_psco6_7", v_ = "_field_psco6_8", vn = {
  message: E_,
  details: h_,
  warn: g_,
  field: v_
};
function ak() {
  var p, y;
  const [e, t] = A(null), [a, r] = A(""), o = B(null), s = B(null), l = B(null), c = re((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = re((d) => new Promise((b) => {
    var N, $, g, x;
    r((x = (g = d.defaultValue) != null ? g : ($ = (N = d.choices) == null ? void 0 : N[0]) == null ? void 0 : $.value) != null ? x : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  U(() => {
    var d, b, N;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : (N = o.current) == null || N.focus());
  }, [e]);
  const m = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), _ = e && u ? /* @__PURE__ */ n.createElement(
    Xn,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      layer: "top",
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { ref: s, onClick: () => m(!1) }, (p = u.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ n.createElement(
        et,
        {
          ref: o,
          variant: u.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: vn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: vn.details }, u.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: vn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: vn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: _ };
}
function rk(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + k_(e);
}
function k_(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function ok() {
  const [e, t] = A(!1), a = B(!1), r = re(async (o) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await o();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function sk(e, t, a, r) {
  const [o, s] = A(null), [l, c] = A(a), [i, m] = A(null), [u, f] = A(!1), [_, p] = A(0), y = B(0), d = B(r);
  d.current = r;
  const b = re(() => p((N) => N + 1), []);
  return U(() => {
    if (!a) return;
    const N = ++y.current;
    return c(!0), e().then(($) => {
      N === y.current && (s($), m(null), f(!1));
    }).catch(($) => {
      var g, x, h;
      N === y.current && (m(d.current.errorText($)), f((h = (x = (g = d.current).isUnavailable) == null ? void 0 : x.call(g, $)) != null ? h : !1));
    }).finally(() => {
      N === y.current && c(!1);
    }), () => {
      y.current++;
    };
  }, [a, _, ...t]), { data: o, loading: l, error: i, unavailable: u, reload: b };
}
function lk(e) {
  const [t, a] = A(null), [r, o] = A(null), [s, l] = A(!1), [c, i] = A(1), m = B(0), u = B(e);
  u.current = e;
  const f = re(async (p, y) => {
    const d = ++m.current;
    l(!0), o(null);
    try {
      const b = await y(p);
      if (d !== m.current) return;
      a(b), i(p);
    } catch (b) {
      if (d !== m.current) return;
      a(null), o(u.current.errorText(b));
    } finally {
      d === m.current && l(!1);
    }
  }, []), _ = re(() => {
    m.current++, a(null), o(null), l(!1);
  }, []);
  return { data: t, err: r, loading: s, page: c, load: f, clear: _ };
}
const w_ = "_section_dyrr7_3", N_ = "_row_dyrr7_10", $_ = "_label_dyrr7_15", x_ = "_value_dyrr7_21", D_ = "_invalid_dyrr7_43", A_ = "_help_dyrr7_45", C_ = "_err_dyrr7_45", S_ = "_req_dyrr7_49", M_ = "_opt_dyrr7_50", T_ = "_sr_dyrr7_51", q_ = "_ro_dyrr7_10", B_ = "_readonly_dyrr7_58", L_ = "_hint_dyrr7_65", j_ = "_toggle_dyrr7_73", I_ = "_table_dyrr7_80", R_ = "_isReq_dyrr7_95", Ce = {
  section: w_,
  row: N_,
  label: $_,
  value: x_,
  invalid: D_,
  help: A_,
  err: C_,
  req: S_,
  opt: M_,
  sr: T_,
  ro: q_,
  readonly: B_,
  hint: L_,
  toggle: j_,
  table: I_,
  isReq: R_
};
let P_ = 0;
const O_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function ck({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: o,
  required: s,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var h, w, E, D;
  const u = B(`axe-fr${++P_}`).current, f = `${u}-lbl`, _ = B(null), p = c ? `${u}-help` : void 0, y = i ? `${u}-err` : void 0, d = [p, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let N = t;
  const $ = aa.count(t) === 1 ? aa.toArray(t)[0] : null, g = un($) && typeof $.type != "string" && !!$.type.axeFormControl;
  if (un($) && (typeof $.type == "string" && O_.has($.type) || g)) {
    const C = $, T = C.props;
    N = _a(C, {
      id: (h = T.id) != null ? h : o,
      "aria-describedby": (w = T["aria-describedby"]) != null ? w : d,
      "aria-invalid": (E = T["aria-invalid"]) != null ? E : i ? !0 : void 0,
      "aria-required": (D = T["aria-required"]) != null ? D : s ? !0 : void 0
    });
  }
  $e(() => {
    var I;
    const C = (I = _.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const T = (q, F) => {
      const Y = `data-fr-${q}`;
      if (F == null) {
        C.hasAttribute(Y) && (C.removeAttribute(q), C.removeAttribute(Y));
        return;
      }
      C.hasAttribute(q) && !C.hasAttribute(Y) || (C.getAttribute(q) !== F && C.setAttribute(q, F), C.setAttribute(Y, ""));
    }, M = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    T("aria-labelledby", M ? null : f), T("aria-invalid", i ? "true" : null), T("aria-required", s ? "true" : null), T("aria-describedby", d != null ? d : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, s && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", s ? Ce.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, o ? /* @__PURE__ */ n.createElement("label", { htmlFor: o, id: f }, x) : /* @__PURE__ */ n.createElement("span", { id: f }, x), a && /* @__PURE__ */ n.createElement(It, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: _, className: `axe-form-value ${Ce.value}` }, N, c && /* @__PURE__ */ n.createElement("span", { id: p, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function ik({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function uk({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function mk({ checked: e, onChange: t, disabled: a, label: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => t(s.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const z_ = "_mono_6omzf_2", X_ = "_invalid_6omzf_3", F_ = "_qty_6omzf_6", W_ = "_qtyInput_6omzf_7", H_ = "_unit_6omzf_8", K_ = "_note_6omzf_9", U_ = "_qtyErr_6omzf_10", gt = {
  mono: z_,
  invalid: X_,
  qty: F_,
  qtyInput: W_,
  unit: H_,
  note: K_,
  qtyErr: U_
};
function G_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: o,
  mono: s,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": f,
  "aria-invalid": _,
  "aria-required": p,
  className: y = ""
}) {
  const d = [s ? gt.mono : "", l ? gt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: o,
    disabled: a,
    "aria-label": m,
    "aria-describedby": f,
    "aria-invalid": _ != null ? _ : l || void 0,
    "aria-required": p,
    onChange: (N) => t(N.target.value === "" ? null : N.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
G_.axeFormControl = !0;
function Y_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: o,
    label: s,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u,
    title: f,
    style: _,
    onClick: p
  } = e, y = (b) => {
    e.codeType === "string" ? e.onChange(b === "" ? null : b) : e.onChange(b === "" ? null : Number(b));
  }, d = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      title: f,
      style: _,
      onClick: p,
      value: t == null ? "" : String(t),
      disabled: o,
      "aria-label": s,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (b) => y(b.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    d.map(([b, N, $]) => /* @__PURE__ */ n.createElement("option", { key: b, value: String(b), disabled: $ || void 0 }, N))
  );
}
Y_.axeFormControl = !0;
function V_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const Q_ = /^-?(\d+\.?\d*|\.\d+)$/;
function tn(e) {
  const t = V_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!Q_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function qn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const o = t.slice(0, a), s = o.indexOf(".");
    return (s >= 0 ? o.length - s - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Gr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (qn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, o = Math.abs(e).toFixed(Math.min(20, qn(e))), s = Math.round(+`${o}e${a}`), l = r * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function Ft(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function J_(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function Z_(e, t, a, r, o, s) {
  let l = e == null ? o != null ? o : 0 : Gr(e + a * t, Math.max(r, qn(t)));
  return o != null && l < o && (l = o), s != null && l > s && (l = s), l;
}
const ep = 2500;
function tp({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: o,
  step: s,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": f,
  "aria-required": _,
  width: p,
  onEnter: y,
  onInvalidChange: d,
  placeholder: b,
  className: N = ""
}) {
  const [$, g] = A(() => Ft(e)), [x, h] = A(!1), [w, E] = A(null), [D, C] = A(!1), T = B(null), M = B($);
  M.current = $, U(() => {
    const v = tn(M.current), O = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    O !== void 0 && O === (e != null ? e : null) || g(Ft(e));
  }, [e]), U(() => () => {
    T.current && clearTimeout(T.current);
  }, []);
  const I = tn($), q = I.kind === "bad" || I.kind === "partial";
  U(() => {
    q || C(!1);
  }, [q]);
  const F = B(d);
  F.current = d, U(() => {
    var v;
    (v = F.current) == null || v.call(F, q);
  }, [q]), U(() => () => {
    var v;
    (v = F.current) == null || v.call(F, !1);
  }, []);
  const Y = (v) => {
    T.current && clearTimeout(T.current), E(v), T.current = setTimeout(() => E(null), ep);
  }, W = (v) => {
    g(v);
    const O = tn(v);
    O.kind === "empty" ? t(null) : O.kind === "num" && t(O.value);
  }, j = () => {
    const v = tn($);
    if (v.kind !== "num") return;
    if (qn(v.value) > a) {
      const V = Gr(v.value, a);
      g(Ft(V)), t(V), Y(`반올림했습니다 → ${Ft(V)}`);
      return;
    }
    const O = Ft(v.value);
    O !== $ && g(O);
  }, ne = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (q) {
          C(!0);
          return;
        }
        j(), y == null || y();
        return;
      }
      if (s && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const O = tn($), V = O.kind === "num" ? O.value : O.kind === "empty" ? null : e, Q = Z_(V, s, v.key === "ArrowUp" ? 1 : -1, a, r, o);
        g(Ft(Q)), t(Q);
      }
    }
  }, te = I.kind === "bad" || I.kind === "partial" && (!x || D) || I.kind === "num" && J_(I.value, r, o);
  return /* @__PURE__ */ n.createElement("span", { className: [gt.qty, N].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [gt.qtyInput, te ? gt.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: $,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": f != null ? f : te || void 0,
      "aria-required": _,
      onChange: (v) => W(v.target.value),
      onFocus: () => h(!0),
      onBlur: () => {
        h(!1), j();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: gt.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!x || D)) && /* @__PURE__ */ n.createElement("span", { className: gt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: gt.note, role: "status", "aria-live": "polite" }, w));
}
tp.axeFormControl = !0;
function np(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function ap(e, t) {
  var o;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((o = e != null ? e : t) != null ? o : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((s) => {
    np(e[s], t[s]) || r.push(s);
  }), r;
}
function rp(e, t) {
  return e === null || t === null ? e === t : ap(e, t).length === 0;
}
function dk() {
  const [e, t] = A(null), [a, r] = A(!1), [o, s] = A(null), l = ke(() => a || !rp(o, e), [a, o, e]), c = re((p) => {
    t((y) => y === null ? y : { ...y, ...p });
  }, []), i = re((p, y) => {
    t((d) => d === null ? d : { ...d, [p]: y });
  }, []), m = B(null), u = re((p) => {
    m.current = p, t(p), s(p), r(!1);
  }, []), f = re((p) => {
    m.current = p, t(p), s(p), r(!0);
  }, []), _ = re(() => t(m.current), []);
  return ke(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: f, reset: _, snapshot: o }),
    [e, a, l, i, c, u, f, _, o]
  );
}
function fk() {
  const e = B(!1), [t, a] = A(!1), r = re(async (o) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await o();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const op = "_panel_1w7xx_2", sp = "_band_1w7xx_7", lp = "_chev_1w7xx_11", cp = "_title_1w7xx_17", ip = "_note_1w7xx_19", up = "_chip_1w7xx_21", mp = "_other_1w7xx_32", dp = "_reset_1w7xx_33", fp = "_form_1w7xx_42", rt = {
  panel: op,
  band: sp,
  chev: lp,
  title: cp,
  note: ip,
  chip: up,
  other: mp,
  reset: dp,
  form: fp
};
function _k({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: o = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const f = B(null);
  if (i && !a && e.length === 0) return null;
  const _ = (y, d = 0) => {
    var x, h, w;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? x : f.current, N = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), $ = (w = N && ((h = N[y]) != null ? h : N[y - 1])) != null ? w : b == null ? void 0 : b.querySelector("button[aria-expanded]"), g = !document.activeElement || document.activeElement === document.body;
    $ && $ !== document.activeElement && (d === 0 || g) && $.focus(), d < 4 && setTimeout(() => _(y, d + 1), 250);
  }, p = (y) => {
    e[y].onClear(), requestAnimationFrame(() => _(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [rt.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: rt.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", o), s !== null && /* @__PURE__ */ n.createElement("span", { className: rt.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [rt.chip, y.tone === "other" ? rt.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => p(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.reset, onClick: () => {
    t(), requestAnimationFrame(() => _(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: rt.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: rt.form }, c));
}
const _p = "_zone_1y6sp_2", pp = "_drag_1y6sp_8", yp = "_busy_1y6sp_9", bp = "_attached_1y6sp_10", Ep = "_left_1y6sp_12", hp = "_icon_1y6sp_13", gp = "_title_1y6sp_18", vp = "_desc_1y6sp_19", kp = "_right_1y6sp_20", wp = "_count_1y6sp_21", Np = "_pick_1y6sp_22", We = {
  zone: _p,
  drag: pp,
  busy: yp,
  attached: bp,
  left: Ep,
  icon: hp,
  title: gp,
  desc: vp,
  right: kp,
  count: wp,
  pick: Np
};
function $p({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: o,
  multiple: s = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = B(null), [f, _] = A(!1), p = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [We.zone, f ? We.drag : "", l ? We.busy : "", c ? We.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || _(!0);
      },
      onDragLeave: () => _(!1),
      onDrop: (y) => {
        y.preventDefault(), _(!1), p(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: We.left }, /* @__PURE__ */ n.createElement("div", { className: We.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: We.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: We.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: We.right }, r && /* @__PURE__ */ n.createElement("span", { className: We.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: We.pick,
        disabled: l,
        onClick: (y) => {
          var d;
          y.stopPropagation(), (d = u.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: o,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          p(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function xp(e, t) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const o = /filename="?([^";]+)"?/i.exec(a);
  return (l = o == null ? void 0 : o[1]) != null ? l : t;
}
function Yr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function pk(e, t, a) {
  Yr(await e.blob(), a != null ? a : xp(e, t));
}
const Dp = /^([△▲\-−]?)\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, Ap = /^\(\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Vr(e, t = {}) {
  var o, s;
  const a = e.trim();
  if (t.parenNegative) {
    const l = Ap.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(o = l[2]) != null ? o : ""}`;
  }
  const r = Dp.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((s = r[3]) != null ? s : "") : null;
}
function Kt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function Cp(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => wn(Kt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let o = null;
  const s = (l) => {
    var i;
    const c = Sp(l, e);
    !c || c === o || (o = c, a.length > r && a.push(""), a.push(wn(Kt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var p;
    if (l.tagName !== "TABLE") {
      if ((p = l.parentElement) != null && p.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = Mp(l, t);
      if (!y) return;
      s(l), a.push(y.map(wn).join(","));
      return;
    }
    const c = l;
    s(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, f = u >= 0 && !!c.querySelector("[data-csv-path]"), _ = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const N = () => {
        for (; _[b] && _[b].n > 0; )
          _[b].n -= 1, _[b].skip || d.push(""), b += 1;
      };
      Array.from(y.cells).forEach(($) => {
        var E, D;
        N();
        const g = qp($), x = g ? "" : Bp($, t), h = Math.max(1, $.colSpan || 1), w = Math.max(1, $.rowSpan || 1);
        for (let C = 0; C < h; C += 1)
          g || d.push(C === 0 ? x : ""), _[b] = { n: w - 1, skip: g }, b += 1;
        if (u >= 0 && $.cellIndex === u) {
          const C = $.querySelector("[data-tree-depth]");
          C ? (d.push(String(Number(C.getAttribute("data-tree-depth")) + 1)), f && d.push(Kt((E = C.getAttribute("data-csv-path")) != null ? E : ""))) : ((D = y.parentElement) == null ? void 0 : D.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), N(), d.some(($) => $ !== "") && a.push(d.map(wn).join(","));
    });
  }), a.join(`\r
`);
}
function Sp(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function Mp(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), o = e.querySelector("[data-csv-unit]"), s = o ? kn(o) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? kn(a) : "");
  if (!c) return null;
  s && (c = `${c} (${s})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = kn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = kn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Kt(c), (u = Vr(i, t)) != null ? u : Kt(i)];
}
function kn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function Tp(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Yr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function qp(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Bp(e, t) {
  var o, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((s = (o = a.innerText) != null ? o : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Vr(r, t)) != null ? l : Kt(r);
}
function wn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const Lp = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function yk({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: o, prepare: s, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    ra,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        s && (c = await s(), await Lp());
        try {
          const i = e.current;
          if (!i) return;
          Tp(Cp(i, { parenNegative: o, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "download", size: 14 }),
    "CSV"
  );
}
const jp = "_root_kpw7f_1", Ip = "_guide_kpw7f_2", Rp = "_tpl_kpw7f_3", Vn = {
  root: jp,
  guide: Ip,
  tpl: Rp
};
function bk({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: o,
  maxBytes: s,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: m = "CSV 파일",
  pickLabel: u = "파일 선택",
  busyReason: f,
  className: _ = ""
}) {
  const p = (d) => {
    var N;
    const b = (N = d[0]) != null ? N : null;
    if (b && s !== void 0 && b.size > s) {
      l == null || l(b);
      return;
    }
    o(b);
  }, y = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Vn.root, _].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(n_, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Vn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Vn.tpl }, /* @__PURE__ */ n.createElement(et, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    $p,
    {
      title: m,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: y,
      accept: i,
      multiple: !1,
      disabled: !!f,
      pickLabel: u,
      onFiles: p
    }
  ));
}
const Pp = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function Ek({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Ya, { tone: Pp[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Ya, null, String(t));
}
const er = "axerp-form-modal";
function hk({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: o,
  submitLabel: s,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: m,
  children: u
}) {
  var _, p, y;
  const f = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    Xn,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: o,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { onClick: t, disabled: r }, (_ = i == null ? void 0 : i.cancel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(et, { type: "submit", form: er, variant: "primary", blockedReason: r ? (p = i == null ? void 0 : i.saving) != null ? p : "저장 중입니다" : l }, (y = s != null ? s : i == null ? void 0 : i.save) != null ? y : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: er, className: m, onSubmit: f, noValidate: !0 }, u)
  );
}
const Op = { left: "axe-l", center: "axe-c", right: "axe-r" };
function tr(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const nr = (e) => {
  var t;
  return Op[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function gk({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: o = null,
  emptyText: s = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: m,
  grow: u = !1,
  growClassName: f,
  pagination: _,
  stickyCols: p
}) {
  const y = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(zc, { grow: u, className: u ? f : void 0, cols: e.map((d) => d.width), busy: r, title: m, pagination: _, stickyCols: p }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((d) => /* @__PURE__ */ n.createElement("th", { key: d.key, className: nr(d) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: tr }, d.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    qr,
    {
      colSpan: e.length,
      loading: r,
      error: o,
      count: t ? y.length : null,
      empty: s,
      idle: null
    }
  ), y.map((d, b) => {
    var g;
    const N = a(d), $ = [c ? "axe-clickable" : "", l === N ? "axe-sel" : "", (g = i == null ? void 0 : i(d)) != null ? g : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: N,
        className: $ || void 0,
        onClick: c ? () => c(d) : void 0,
        ...c ? ni(() => c(d), l === void 0 ? void 0 : l === N) : {}
      },
      e.map((x) => /* @__PURE__ */ n.createElement("td", { key: x.key, className: nr(x), onMouseEnter: tr }, x.render(d, b)))
    );
  })));
}
function vk({ title: e, info: t, badge: a, notice: r, actions: o, minWidth: s, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(No, { style: { height: "100%" }, minWidth: s }, /* @__PURE__ */ n.createElement(Ko, { title: e, info: t, badge: a, notice: r }, o), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const zp = "_menu_1ow3k_1", Xp = "_heading_1ow3k_11", Fp = "_section_1ow3k_18", Wp = "_item_1ow3k_23", Nn = {
  menu: zp,
  heading: Xp,
  section: Fp,
  item: Wp
}, $n = 8;
function kk({ x: e, y: t, entries: a, onClose: r, ariaLabel: o, heading: s }) {
  const l = B(null), c = B(r);
  c.current = r;
  const [i, m] = A({ left: e, top: t });
  $e(() => {
    const _ = l.current;
    if (!_) return;
    const p = Math.max($n, Math.min(e, window.innerWidth - _.offsetWidth - $n)), y = Math.max($n, Math.min(t, window.innerHeight - _.offsetHeight - $n));
    m({ left: p, top: y });
  }, [e, t]);
  const u = () => {
    var _, p;
    return Array.from((p = (_ = l.current) == null ? void 0 : _.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  U(() => {
    var _;
    (_ = u()[0]) == null || _.focus();
  }, []), U(() => {
    const _ = () => c.current(), p = (d) => {
      l.current && !l.current.contains(d.target) && _();
    }, y = (d) => {
      d.key !== "Escape" || d.isComposing || (d.preventDefault(), d.stopPropagation(), _());
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", y, !0), window.addEventListener("resize", _), window.addEventListener("scroll", _, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", _), window.removeEventListener("scroll", _, !0);
    };
  }, []);
  const f = (_) => {
    const p = u();
    if (p.length === 0) return;
    const y = p.indexOf(document.activeElement);
    let d = -1;
    if (_.key === "ArrowDown") d = (y + 1) % p.length;
    else if (_.key === "ArrowUp") d = (y - 1 + p.length) % p.length;
    else if (_.key === "Home") d = 0;
    else if (_.key === "End") d = p.length - 1;
    else if (_.key === "Tab") {
      c.current();
      return;
    }
    d >= 0 && (_.preventDefault(), p[d].focus());
  };
  return pa(
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: l,
        className: Nn.menu,
        role: "menu",
        "aria-label": o,
        style: { left: i.left, top: i.top },
        onKeyDown: f,
        onContextMenu: (_) => _.preventDefault()
      },
      s && /* @__PURE__ */ n.createElement("div", { className: Nn.heading }, s),
      a.map((_) => _.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: _.key, className: Nn.section }, _.label) : /* @__PURE__ */ n.createElement(
        "button",
        {
          key: _.key,
          type: "button",
          role: "menuitem",
          className: Nn.item,
          disabled: _.disabled,
          onClick: () => {
            c.current(), _.onClick();
          }
        },
        _.label
      ))
    ),
    document.body
  );
}
const Hp = "_sw_xhqlf_1", Kp = "_on_xhqlf_10", ar = {
  sw: Hp,
  on: Kp
};
function wk({ checked: e, onChange: t, label: a, onText: r = "ON", offText: o = "OFF", disabled: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      "aria-label": a,
      disabled: s,
      className: [ar.sw, e ? ar.on : "", l].filter(Boolean).join(" "),
      onClick: () => t(!e)
    },
    /* @__PURE__ */ n.createElement("span", null, e ? r : o),
    /* @__PURE__ */ n.createElement("i", null)
  );
}
function Up({ accept: e, multiple: t = !0, onFiles: a }) {
  const r = B(null), o = B(a);
  return o.current = a, { open: re(() => {
    var c;
    (c = r.current) == null || c.click();
  }, []), input: /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: r,
      type: "file",
      accept: e,
      multiple: t,
      hidden: !0,
      onChange: (c) => {
        var m;
        const i = Array.from((m = c.target.files) != null ? m : []);
        c.target.value = "", i.length > 0 && o.current(i);
      }
    }
  ) };
}
function Nk({ accept: e, multiple: t = !0, onFiles: a, disabled: r, title: o, variant: s, size: l, children: c }) {
  const { open: i, input: m } = Up({ accept: e, multiple: t, onFiles: a });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { variant: s, size: l, onClick: i, disabled: r, title: o }, c), m);
}
const Gp = "_over_bhzlv_1", Yp = "_thumbs_bhzlv_2", Vp = "_thumb_bhzlv_2", ca = {
  over: Gp,
  thumbs: Yp,
  thumb: Vp
};
function $k({ onFiles: e, accept: t, disabled: a, className: r = "", children: o }) {
  const [s, l] = A(!1), c = (m) => !t || t.some((u) => m.startsWith(u)), i = (m) => Array.from(m).some((u) => u.kind === "file" && c(u.type));
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [r, s ? ca.over : ""].filter(Boolean).join(" "),
      onDragOver: (m) => {
        var u;
        a || (u = m.dataTransfer) != null && u.items && !i(m.dataTransfer.items) || (m.preventDefault(), l(!0));
      },
      onDragLeave: () => l(!1),
      onDrop: (m) => {
        if (m.preventDefault(), l(!1), a) return;
        const u = Array.from(m.dataTransfer.files).filter((f) => c(f.type));
        u.length > 0 && e(u);
      }
    },
    o
  );
}
function xk({ images: e, onRemove: t, removeLabel: a, disabled: r }) {
  return /* @__PURE__ */ n.createElement("div", { className: ca.thumbs }, e.map((o) => {
    var s;
    return /* @__PURE__ */ n.createElement("figure", { key: o.uid, className: ca.thumb, title: (s = o.title) != null ? s : o.name }, /* @__PURE__ */ n.createElement("img", { src: o.previewUrl, alt: o.name }), /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => t(o.uid), "aria-label": a(o.name), disabled: r }, "×"), o.caption !== void 0 && /* @__PURE__ */ n.createElement("figcaption", null, o.caption));
  }));
}
const Qp = "_box_lrwei_1", Jp = "_btn_lrwei_2", Zp = "_pop_lrwei_9", Qn = {
  box: Qp,
  btn: Jp,
  pop: Zp
};
function Dk({ summary: e, items: t, onToggle: a, label: r, disabled: o, className: s = "" }) {
  const [l, c] = A(!1), i = B(null), m = B(null);
  return U(() => {
    if (!l) return;
    const u = (_) => {
      i.current && !i.current.contains(_.target) && c(!1);
    }, f = (_) => {
      var p;
      _.key !== "Escape" || _.isComposing || (_.stopPropagation(), c(!1), (p = m.current) == null || p.focus());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [l]), /* @__PURE__ */ n.createElement("div", { className: [Qn.box, s].filter(Boolean).join(" "), ref: i }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: m,
      type: "button",
      className: Qn.btn,
      "aria-haspopup": "listbox",
      "aria-expanded": l,
      "aria-label": r,
      disabled: o,
      onClick: () => c((u) => !u)
    },
    e,
    " ▾"
  ), l && /* @__PURE__ */ n.createElement("div", { className: Qn.pop, role: "listbox", "aria-multiselectable": "true", "aria-label": r }, t.map((u) => /* @__PURE__ */ n.createElement("label", { key: u.key }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: u.checked, onChange: () => a(u.key) }), u.label))));
}
const ey = "_card_krkjh_1", ty = "_sub_krkjh_2", ny = "_state_krkjh_3", ay = "_list_krkjh_7", ry = "_row_krkjh_8", oy = "_warn_krkjh_21", sy = "_danger_krkjh_22", At = {
  card: ey,
  sub: ty,
  state: ny,
  list: ay,
  row: ry,
  warn: oy,
  danger: sy
};
function Ak({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: o,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    Br,
    {
      flush: !0,
      className: [At.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: At.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: At.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: At.state }, /* @__PURE__ */ n.createElement(Ur, null, o != null ? o : "불러오지 못했습니다"), s && /* @__PURE__ */ n.createElement(ya, { onClick: s }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: At.list }, c.map((m, u) => {
      var p, y;
      const f = [At.row, m.tone ? At[m.tone] : ""].filter(Boolean).join(" "), _ = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (p = m.key) != null ? p : u, className: f, onClick: m.onClick }, _) : /* @__PURE__ */ n.createElement("div", { key: (y = m.key) != null ? y : u, className: f }, _);
    }))
  );
}
function ly(e, t, a, r, o) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, o != null && o > 0 ? Math.floor(o) : s)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(s / c);
  return Math.ceil(s / i);
}
const cy = "_group_44kzq_1", iy = "_tile_44kzq_2", uy = "_click_44kzq_9", my = "_pressed_44kzq_13", dy = "_ok_44kzq_14", fy = "_warn_44kzq_15", _y = "_danger_44kzq_16", py = "_info_44kzq_17", yy = "_accent_44kzq_18", by = "_muted_44kzq_19", Ey = "_label_44kzq_20", hy = "_value_44kzq_22", gy = "_desc_44kzq_27", ht = {
  group: cy,
  tile: iy,
  click: uy,
  pressed: my,
  ok: dy,
  warn: fy,
  danger: _y,
  info: py,
  accent: yy,
  muted: by,
  label: Ey,
  value: hy,
  desc: gy
};
function Ck({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: o = "info",
  onClick: s,
  pressed: l,
  title: c,
  className: i = ""
}) {
  const m = [ht.tile, ht[o], s ? ht.click : "", s && l ? ht.pressed : "", i].filter(Boolean).join(" "), u = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ht.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: ht.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: ht.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return s ? /* @__PURE__ */ n.createElement("button", { type: "button", className: m, onClick: s, "aria-pressed": l, title: c, "data-csv-kv": "" }, u) : /* @__PURE__ */ n.createElement("div", { className: m, title: c, "data-csv-kv": "" }, u);
}
const vy = 150, ky = 12, wy = 8;
function Sk({ children: e, columns: t, className: a = "" }) {
  const r = B(null), o = aa.toArray(e).filter(un).length, s = t != null || o <= wy, [l, c] = A(null);
  $e(() => {
    const u = r.current;
    if (!s || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(u.clientWidth));
    return f.observe(u), () => f.disconnect();
  }, [s]);
  const i = s ? ly(o, l != null ? l : Number.MAX_SAFE_INTEGER, vy, ky, t) : 0, m = s ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [ht.group, a].filter(Boolean).join(" "), style: m }, e);
}
const Ny = "_card_nvp4o_1", $y = "_n_nvp4o_2", xy = "_list_nvp4o_7", Dy = "_item_nvp4o_8", Ay = "_row_nvp4o_9", Cy = "_launch_nvp4o_14", Sy = "_tabBtn_nvp4o_17", My = "_starBtn_nvp4o_17", Ty = "_on_nvp4o_21", qy = "_name_nvp4o_23", By = "_empty_nvp4o_24", Ly = "_star_nvp4o_17", jy = "_clear_nvp4o_34", je = {
  card: Ny,
  n: $y,
  list: xy,
  item: Dy,
  row: Ay,
  launch: Cy,
  tabBtn: Sy,
  starBtn: My,
  on: Ty,
  name: qy,
  empty: By,
  star: Ly,
  clear: jy
};
function Iy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Ry() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Mk({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  onRemoveMine: o,
  onOpenNewTab: s,
  mineHint: l = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: c = ""
}) {
  const [i, m] = A("mine"), u = i === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    Br,
    {
      flush: !0,
      className: [je.card, c].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        Dr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: i,
          onChange: (f) => m(f),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, t.length)) }
          ]
        }
      ),
      trailing: i === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(ya, { className: je.clear, onClick: r }, "목록 비우기") : void 0
    },
    u.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: je.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.path, className: je.item }, /* @__PURE__ */ n.createElement("button", { type: "button", className: je.row, onClick: () => a(f) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.launch }, /* @__PURE__ */ n.createElement(Iy, null)), /* @__PURE__ */ n.createElement("span", { className: je.name }, f.label)), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: je.tabBtn,
        "aria-label": `${f.label} 새 탭으로 열기`,
        title: "새 탭으로 열기",
        onClick: () => s ? s(f) : window.open(f.path, "_blank", "noopener")
      },
      /* @__PURE__ */ n.createElement(Ry, null)
    ), i === "mine" && o && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: `${je.starBtn} ${je.on}`,
        "aria-pressed": !0,
        "aria-label": `${f.label} 마이메뉴에서 삭제`,
        title: "마이메뉴에서 삭제",
        onClick: () => o(f)
      },
      "★"
    )))) : /* @__PURE__ */ n.createElement("div", { className: je.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, i === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, i === "mine" ? l : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function rr(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Jn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function Tk({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, o] = A(() => rr(e)), [s, l] = A(() => rr(t)), c = re((f) => r.some((_) => _.path === f), [r]), i = re((f) => o((_) => {
    const p = _.some((y) => y.path === f.path) ? _.filter((y) => y.path !== f.path) : [..._, f];
    return Jn(e, p), p;
  }), [e]), m = re((f) => l((_) => {
    const p = [f, ..._.filter((y) => y.path !== f.path)].slice(0, a);
    return Jn(t, p), p;
  }), [t, a]), u = re(() => {
    l([]), Jn(t, []);
  }, [t]);
  return { mine: r, recent: s, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const Py = "_banner_7tqhk_2", Oy = "_heading_7tqhk_7", zy = "_sparkleBox_7tqhk_8", Xy = "_eyebrow_7tqhk_12", Fy = "_headline_7tqhk_13", Wy = "_desc_7tqhk_15", Hy = "_err_7tqhk_16", Ky = "_chips_7tqhk_18", Uy = "_footer_7tqhk_28", Gy = "_kicker_7tqhk_35", Yy = "_list_7tqhk_36", Vy = "_row_7tqhk_37", Qy = "_icon_7tqhk_39", Jy = "_text_7tqhk_40", Zy = "_cap_7tqhk_41", eb = "_body_7tqhk_43", tb = "_reason_7tqhk_44", nb = "_empty_7tqhk_45", ye = {
  banner: Py,
  heading: Oy,
  sparkleBox: zy,
  eyebrow: Xy,
  headline: Fy,
  desc: Wy,
  err: Hy,
  chips: Ky,
  footer: Uy,
  kicker: Gy,
  list: Yy,
  row: Vy,
  icon: Qy,
  text: Jy,
  cap: Zy,
  body: eb,
  reason: tb,
  empty: nb
};
function or({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function qk({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: o,
  maxChips: s = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: f = ""
}) {
  const _ = o.slice(0, s), p = o.length - _.length;
  return /* @__PURE__ */ n.createElement("section", { className: [ye.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ye.heading }, /* @__PURE__ */ n.createElement("span", { className: ye.sparkleBox }, /* @__PURE__ */ n.createElement(or, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: ye.eyebrow }, /* @__PURE__ */ n.createElement(or, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: ye.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [ye.desc, r ? ye.err : ""].filter(Boolean).join(" ") }, a) : null)), o.length > 0 && /* @__PURE__ */ n.createElement("div", { className: ye.chips }, _.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), p > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", p, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: ye.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? ye.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(ya, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function ab({ items: e, onRun: t, onSkip: a, busy: r, emptyText: o = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: ye.empty }, o) : /* @__PURE__ */ n.createElement("ul", { className: ye.list }, e.map((s) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: s.id, className: ye.row }, /* @__PURE__ */ n.createElement("span", { className: ye.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: ye.text }, /* @__PURE__ */ n.createElement("div", { className: ye.cap }, s.title, s.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ n.createElement("div", { className: ye.body }, s.body), s.reason ? /* @__PURE__ */ n.createElement("div", { className: ye.reason }, s.reason) : null), /* @__PURE__ */ n.createElement(et, { size: "sm", variant: "primary", disabled: r, onClick: () => t(s) }, (c = s.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(et, { size: "sm", disabled: r, onClick: () => a(s) }, "무시"));
  }));
}
function Bk({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: o, onSkip: s }) {
  const l = B(!1), [c, i] = A(!1), [m, u] = A(""), f = async (_) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await _();
      } catch {
        u("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    Xn,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: ye.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(et, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(ab, { items: a, busy: c, onRun: (_) => f(() => o(_)), onSkip: (_) => f(() => s(_)) })
  );
}
const rb = "_wrap_1wvdc_2", ob = "_header_1wvdc_7", sb = "_iconBox_1wvdc_8", lb = "_headText_1wvdc_12", cb = "_eyebrow_1wvdc_13", ib = "_headline_1wvdc_14", ub = "_headerExtra_1wvdc_16", mb = "_grid_1wvdc_19", db = "_card_1wvdc_20", fb = "_badge_1wvdc_29", _b = "_toneRed_1wvdc_33", pb = "_toneViolet_1wvdc_34", yb = "_toneGreen_1wvdc_35", bb = "_toneBlue_1wvdc_36", Eb = "_title_1wvdc_38", hb = "_summary_1wvdc_42", gb = "_action_1wvdc_46", vb = "_notice_1wvdc_53", kb = "_err_1wvdc_56", fe = {
  wrap: rb,
  header: ob,
  iconBox: sb,
  headText: lb,
  eyebrow: cb,
  headline: ib,
  headerExtra: ub,
  grid: mb,
  card: db,
  badge: fb,
  toneRed: _b,
  toneViolet: pb,
  toneGreen: yb,
  toneBlue: bb,
  title: Eb,
  summary: hb,
  action: gb,
  notice: vb,
  err: kb
};
function sr({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const wb = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function Lk({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: o,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(sr, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, o) : null, e.length === 0 ? o ? null : s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((m) => {
    var u, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: fe.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, wb[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(sr, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (f = m.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const Nb = "_wrapper_1j5pd_1", $b = "_searchIcon_1j5pd_17", xb = "_input_1j5pd_25", Db = "_clearButton_1j5pd_39", Ab = "_hint_1j5pd_59", nn = {
  wrapper: Nb,
  searchIcon: $b,
  input: xb,
  clearButton: Db,
  hint: Ab
}, Cb = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Sb({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: o,
  onClear: s
}) {
  const l = (c) => {
    c.key === "Enter" && (o == null || o());
  };
  return /* @__PURE__ */ n.createElement("div", { className: `${nn.wrapper} axe-focus-box` }, /* @__PURE__ */ n.createElement("span", { className: nn.searchIcon }, Cb), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: nn.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.clearButton,
      onClick: s,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: nn.hint }, r));
}
const Mb = "_screen_sizmw_1", Tb = "_shell_sizmw_8", qb = "_command_sizmw_10", Bb = "_body_sizmw_20", Lb = "_overview_sizmw_22", jb = "_areaHead_sizmw_25", Ib = "_hintPart_sizmw_28", Rb = "_hintIcon_sizmw_29", kt = {
  screen: Mb,
  shell: Tb,
  command: qb,
  body: Bb,
  overview: Lb,
  areaHead: jb,
  hintPart: Ib,
  hintIcon: Rb
};
function jk({ search: e, panel: t, children: a, className: r = "" }) {
  var o;
  return /* @__PURE__ */ n.createElement("main", { className: [kt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: kt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: kt.command }, /* @__PURE__ */ n.createElement(
    Sb,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (o = e.hint) != null ? o : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: kt.body }, a)));
}
function Ik({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [kt.overview, t].filter(Boolean).join(" ") }, e);
}
function Pb() {
  return /* @__PURE__ */ n.createElement("svg", { className: kt.hintIcon, width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Ob(e) {
  return typeof e != "string" || e.indexOf("↗") < 0 ? e : e.split("↗").map((a, r) => /* @__PURE__ */ n.createElement("span", { key: r, className: kt.hintPart }, r > 0 && /* @__PURE__ */ n.createElement(Pb, null), a));
}
function Rk({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: kt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, Ob(t)));
}
const zb = "_group_oodts_1", Xb = "_grid_oodts_7", Fb = "_row_oodts_8", Wb = "_item_oodts_9", Hb = "_launch_oodts_14", Kb = "_name_oodts_17", Ub = "_desc_oodts_18", Gb = "_badge_oodts_19", Yb = "_disabled_oodts_23", Vb = "_tab_oodts_25", Qb = "_star_oodts_25", Jb = "_on_oodts_30", Zb = "_empty_oodts_32", Re = {
  group: zb,
  grid: Xb,
  row: Fb,
  item: Wb,
  launch: Hb,
  name: Kb,
  desc: Ub,
  badge: Gb,
  disabled: Yb,
  tab: Vb,
  star: Qb,
  on: Jb,
  empty: Zb
};
function eE() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function tE() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Pk({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Re.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Re.grid }, t.map((o) => /* @__PURE__ */ n.createElement("div", { className: Re.row, key: o.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.item, o.disabled ? Re.disabled : ""].filter(Boolean).join(" "),
      disabled: o.disabled,
      onClick: o.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Re.launch }, /* @__PURE__ */ n.createElement(eE, null)),
    /* @__PURE__ */ n.createElement("span", { className: Re.name }, o.label),
    o.desc && /* @__PURE__ */ n.createElement("span", { className: Re.desc }, o.desc),
    o.badge != null && /* @__PURE__ */ n.createElement("em", { className: Re.badge }, o.badge)
  ), o.onOpenNewTab && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Re.tab,
      "aria-label": `${o.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: o.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(tE, null)
  ), o.onToggleStar && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.star, o.starred ? Re.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!o.starred,
      "aria-label": `${o.label} ${o.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: o.onToggleStar
    },
    o.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Re.empty }, a)));
}
const nE = "_strip_8zhai_2", aE = "_day_8zhai_9", rE = "_total_8zhai_10", oE = "_sel_8zhai_31", sE = "_today_8zhai_35", lE = "_md_8zhai_35", cE = "_off_8zhai_36", iE = "_head_8zhai_45", uE = "_wd_8zhai_46", mE = "_sun_8zhai_47", dE = "_sat_8zhai_48", fE = "_lock_8zhai_50", _E = "_value_8zhai_60", pE = "_mark_8zhai_66", yE = "_warn_8zhai_67", bE = "_danger_8zhai_68", EE = "_info_8zhai_69", we = {
  strip: nE,
  day: aE,
  total: rE,
  sel: oE,
  today: sE,
  md: lE,
  off: cE,
  head: iE,
  wd: uE,
  sun: mE,
  sat: dE,
  lock: fE,
  value: _E,
  mark: pE,
  warn: yE,
  danger: bE,
  info: EE
}, lr = ["일", "월", "화", "수", "목", "금", "토"];
function hE(e) {
  const [t, a, r] = e.split("-").map(Number), o = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: o };
}
function Ok({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: o,
  totalLabel: s = "합계",
  "aria-label": l,
  className: c
}) {
  const i = B([]), m = (_) => {
    var y;
    const p = e.length;
    for (let d = 0; d < p; d++) {
      const b = (_ + d + p) % p;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (_, p) => {
    _.key === "ArrowRight" ? (_.preventDefault(), m(p + 1)) : _.key === "ArrowLeft" ? (_.preventDefault(), m(p - 1)) : _.key === "Home" ? (_.preventDefault(), m(0)) : _.key === "End" && (_.preventDefault(), m(e.length - 1));
  }, f = Math.max(0, e.findIndex((_) => _.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${we.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((_, p) => {
    var $, g, x, h;
    const { md: y, wd: d } = hE(_.date), b = [
      we.day,
      _.off ? we.off : "",
      _.date === t ? we.sel : "",
      _.date === a ? we.today : "",
      d === 0 ? we.sun : d === 6 ? we.sat : ""
    ].filter(Boolean).join(" "), N = [`${y}(${lr[d]})`, _.offLabel, _.locked ? "잠김" : null, ($ = _.mark) == null ? void 0 : $.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: _.date,
        ref: (w) => {
          i.current[p] = w;
        },
        type: "button",
        className: b,
        disabled: _.disabled,
        tabIndex: p === f ? 0 : -1,
        "aria-pressed": _.date === t,
        "aria-label": N,
        title: N,
        onClick: () => r == null ? void 0 : r(_.date),
        onKeyDown: (w) => u(w, p)
      },
      /* @__PURE__ */ n.createElement("span", { className: we.head }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, lr[d]), /* @__PURE__ */ n.createElement("span", { className: we.md }, y), _.locked && /* @__PURE__ */ n.createElement("span", { className: we.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: we.value }, _.value),
      /* @__PURE__ */ n.createElement("span", { className: `${we.mark}${_.mark ? ` ${we[_.mark.tone]}` : ""}` }, (h = (g = _.mark) == null ? void 0 : g.text) != null ? h : _.off && (x = _.offLabel) != null ? x : "")
    );
  }), o !== void 0 && /* @__PURE__ */ n.createElement("div", { className: we.total }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, s), /* @__PURE__ */ n.createElement("span", { className: we.value }, o)));
}
const gE = "_stepper_1wbt2_1", vE = "_nav_1wbt2_2", kE = "_today_1wbt2_3", wE = "_range_1wbt2_14", an = {
  stepper: gE,
  nav: vE,
  today: kE,
  range: wE
};
function NE(e) {
  const t = va(e);
  return t === 0 ? 7 : t;
}
function $E(e, t = 1) {
  const a = (NE(e) - t + 7) % 7;
  return In(e, -a);
}
function Zn(e, t) {
  return In(e, t);
}
function zk({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: o, label: s = "주" }) {
  const l = Zn(e, 6), c = $E(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: an.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(Zn(e, -7)),
      disabled: o,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: an.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(Zn(e, 7)),
      disabled: o,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.today,
      onClick: () => t(c),
      disabled: o || e === c
    },
    "이번 주"
  ));
}
const xE = "_wrap_1dtpy_1", DE = "_svg_1dtpy_2", AE = "_grid_1dtpy_3", CE = "_axis_1dtpy_4", SE = "_accent_1dtpy_5", ME = "_muted_1dtpy_6", TE = "_ok_1dtpy_7", qE = "_warn_1dtpy_8", BE = "_danger_1dtpy_9", LE = "_legend_1dtpy_10", jE = "_dot_accent_1dtpy_13", IE = "_dot_muted_1dtpy_14", RE = "_dot_ok_1dtpy_15", PE = "_dot_warn_1dtpy_16", OE = "_dot_danger_1dtpy_17", bt = {
  wrap: xE,
  svg: DE,
  grid: AE,
  axis: CE,
  accent: SE,
  muted: ME,
  ok: TE,
  warn: qE,
  danger: BE,
  legend: LE,
  dot_accent: jE,
  dot_muted: IE,
  dot_ok: RE,
  dot_warn: PE,
  dot_danger: OE
}, zE = 600;
function XE(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const cr = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function Xk({ categories: e, series: t, unit: a = "", height: r = 180, label: o, labelEvery: s }) {
  const l = B(null), [c, i] = A(zE);
  $e(() => {
    const E = l.current;
    if (!E) return;
    const D = () => {
      const T = E.clientWidth;
      T > 0 && i((M) => M === T ? M : T);
    };
    if (D(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(D);
    return C.observe(E), () => C.disconnect();
  }, []);
  const m = r, u = 40, f = 22, _ = 8, p = c - u - 4, y = m - f - _, d = t.flatMap((E) => E.values.filter((D) => D != null)), b = XE(Math.max(0, ...d)), N = Math.max(e.length, 1), $ = p / N, g = Math.min(8, $ * 0.2), x = Math.max(1, ($ - g) / Math.max(t.length, 1)), h = s != null ? s : Math.max(1, Math.ceil(N / 8)), w = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: bt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: bt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": o,
      style: { height: r }
    },
    w.map((E) => {
      const D = _ + y - E / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: E }, /* @__PURE__ */ n.createElement("line", { className: bt.grid, x1: u, x2: c - 4, y1: D, y2: D }), /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: u - 4, y: D + 3, textAnchor: "end" }, cr(E)));
    }),
    e.map((E, D) => /* @__PURE__ */ n.createElement("g", { key: E }, t.map((C, T) => {
      var q;
      const M = C.values[D];
      if (M == null || M <= 0) return null;
      const I = M / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: bt[(q = C.tone) != null ? q : "accent"],
          x: u + D * $ + g / 2 + T * x,
          y: _ + y - I,
          width: x,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${E} · ${C.label} ${cr(M)}${a}`)
      );
    }), D % h === 0 && /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: u + D * $ + $ / 2, y: m - 6, textAnchor: "middle" }, E)))
  ), /* @__PURE__ */ n.createElement("ul", { className: bt.legend }, t.map((E) => {
    var D;
    return /* @__PURE__ */ n.createElement("li", { key: E.key }, /* @__PURE__ */ n.createElement("i", { className: bt[`dot_${(D = E.tone) != null ? D : "accent"}`], "aria-hidden": "true" }), E.label, a ? ` (${a})` : "");
  })));
}
const FE = "_wrap_85lir_1", WE = "_track_85lir_2", HE = "_accent_85lir_3", KE = "_muted_85lir_3", UE = "_ok_85lir_3", GE = "_warn_85lir_3", YE = "_danger_85lir_3", VE = "_center_85lir_9", QE = "_legend_85lir_10", JE = "_name_85lir_13", ZE = "_val_85lir_14", e1 = "_pct_85lir_15", t1 = "_dot_accent_85lir_16", n1 = "_dot_muted_85lir_17", a1 = "_dot_ok_85lir_18", r1 = "_dot_warn_85lir_19", o1 = "_dot_danger_85lir_20", ot = {
  wrap: FE,
  track: WE,
  accent: HE,
  muted: KE,
  ok: UE,
  warn: GE,
  danger: YE,
  center: VE,
  legend: QE,
  name: JE,
  val: ZE,
  pct: e1,
  dot_accent: t1,
  dot_muted: n1,
  dot_ok: a1,
  dot_warn: r1,
  dot_danger: o1
}, ia = 40, ir = 2 * Math.PI * ia;
function Fk({ items: e, center: t, size: a = 120, label: r, emptyText: o = "자료 없음", unit: s = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: ot.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: ot.track, cx: "50", cy: "50", r: ia }), l > 0 && e.map((i) => {
    var f;
    const m = Math.max(0, i.value) / l * ir, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: ot[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: ia,
        strokeDasharray: `${m} ${ir - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: ot.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : o)), /* @__PURE__ */ n.createElement("ul", { className: ot.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: ot[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: ot.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: ot.val }, i.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ n.createElement("span", { className: ot.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const s1 = "_wrap_1b8ll_1", l1 = "_track_1b8ll_2", c1 = "_compact_1b8ll_3", i1 = "_fill_1b8ll_4", u1 = "_accent_1b8ll_5", m1 = "_muted_1b8ll_6", d1 = "_ok_1b8ll_7", f1 = "_warn_1b8ll_8", _1 = "_danger_1b8ll_9", p1 = "_num_1b8ll_10", y1 = "_none_1b8ll_12", Ct = {
  wrap: s1,
  track: l1,
  compact: c1,
  fill: i1,
  accent: u1,
  muted: m1,
  ok: d1,
  warn: f1,
  danger: _1,
  num: p1,
  none: y1
};
function Wk({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Ct.none, "aria-label": `${t} 해당 없음` }, "-");
  const o = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Ct.wrap, r ? Ct.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": o
    },
    /* @__PURE__ */ n.createElement("span", { className: Ct.track }, /* @__PURE__ */ n.createElement("span", { className: `${Ct.fill} ${Ct[a]}`, style: { width: `${o}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Ct.num }, o, "%")
  );
}
const b1 = { day: 28, week: 10, month: 3 };
function Lt(e, t) {
  return In(e, t);
}
function ua(e, t) {
  return vt(t) - vt(e) + 1;
}
function Qr(e) {
  return va(e);
}
const ur = (e) => {
  const t = Qr(e);
  return t === 0 || t === 6;
};
function Wt(e, t, a, r) {
  const o = [], s = ua(e, t);
  for (let l = 0; l < s; l++) {
    const c = Lt(e, l), i = a(c), m = o[o.length - 1];
    m && m.key === i ? m.days++ : o.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return o;
}
function E1(e, t, a) {
  const r = (s) => s.slice(0, 7), o = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Wt(e, t, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: Wt(e, t, r, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Lt(l, -((Qr(l) + 6) % 7));
    return {
      top: Wt(e, t, r, o),
      bottom: Wt(e, t, s, (l) => {
        const c = s(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Wt(e, t, r, o),
    bottom: Wt(e, t, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function ea(e, t, a, r) {
  if (a === "move") return { start: Lt(e, r), end: Lt(t, r) };
  if (a === "start") {
    const s = Lt(e, r);
    return { start: s > t ? t : s, end: t };
  }
  const o = Lt(t, r);
  return { start: e, end: o < e ? e : o };
}
const h1 = "_gantt_1smka_3", g1 = "_scroll_1smka_15", v1 = "_canvas_1smka_21", k1 = "_head_1smka_24", w1 = "_headLabel_1smka_32", N1 = "_headTrack_1smka_43", $1 = "_band_1smka_44", x1 = "_seg_1smka_46", D1 = "_tick_1smka_59", A1 = "_tickOff_1smka_60", C1 = "_body_1smka_62", S1 = "_overlay_1smka_65", M1 = "_weekend_1smka_66", T1 = "_holiday_1smka_66", q1 = "_today_1smka_68", B1 = "_row_1smka_70", L1 = "_label_1smka_76", j1 = "_sel_1smka_77", I1 = "_track_1smka_77", R1 = "_dim_1smka_78", P1 = "_labelText_1smka_95", O1 = "_dot_1smka_96", z1 = "_warn_1smka_97", X1 = "_err_1smka_98", F1 = "_bar_1smka_113", W1 = "_can_1smka_21", H1 = "_dragging_1smka_126", K1 = "_fill_1smka_127", U1 = "_late_1smka_128", G1 = "_summary_1smka_130", Y1 = "_handle_1smka_133", V1 = "_hL_1smka_134", Q1 = "_hR_1smka_135", J1 = "_mark_1smka_137", Z1 = "_barText_1smka_138", eh = "_empty_1smka_147", th = "_srOnly_1smka_150", ee = {
  gantt: h1,
  scroll: g1,
  canvas: v1,
  head: k1,
  headLabel: w1,
  headTrack: N1,
  band: $1,
  seg: x1,
  tick: D1,
  tickOff: A1,
  body: C1,
  overlay: S1,
  weekend: M1,
  holiday: T1,
  today: q1,
  row: B1,
  label: L1,
  sel: j1,
  track: I1,
  dim: R1,
  labelText: P1,
  dot: O1,
  warn: z1,
  err: X1,
  bar: F1,
  can: W1,
  dragging: H1,
  fill: K1,
  late: U1,
  summary: G1,
  handle: Y1,
  hL: V1,
  hR: Q1,
  mark: J1,
  barText: Z1,
  empty: eh,
  srOnly: th
}, mr = 28, dr = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let nh = 0;
function Hk({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: o = {},
  today: s,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: f,
  lockedReason: _,
  scrollMemory: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = B("");
  N.current || (N.current = `axe-gantt-keys-${++nh}`);
  const $ = b1[r], g = Math.max(ua(t, a), 1), x = vt(t), h = g * $, w = ke(() => E1(t, a, r), [t, a, r]), E = ke(() => {
    const v = [];
    for (let O = 0; O < g; O++) {
      const V = Lt(t, O), Q = V in o;
      if (!Q && !ur(V)) continue;
      const se = v[v.length - 1];
      se && se.offset + se.days === O && se.holiday === Q ? se.days++ : v.push({ offset: O, days: 1, holiday: Q });
    }
    return v;
  }, [t, g, o]), [D, C] = A(null), T = B(null), M = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, O, V) => {
    if (!M(O) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: O.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    T.current = Q, C(Q);
  }, q = (v) => {
    const O = T.current;
    if (!O) return;
    const V = Math.round((v.clientX - O.x) / $), Q = O.moved || Math.abs(v.clientX - O.x) > 3;
    if (V !== O.delta || Q !== O.moved) {
      const se = { ...O, delta: V, moved: Q };
      T.current = se, C(se);
    }
  }, F = (v) => {
    const O = T.current;
    if (T.current = null, C(null), !!O) {
      if (!O.moved) {
        i == null || i(v);
        return;
      }
      O.delta !== 0 && v.start && v.end && (c == null || c(v, ea(v.start, v.end, O.mode, O.delta), O.mode));
    }
  }, Y = () => {
    T.current = null, C(null);
  }, W = (v, O) => {
    if (v.key === "Escape" && T.current) {
      Y();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(O);
      return;
    }
    if (!M(O) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(O, ea(O.start, O.end, Q, V), Q);
  }, j = s ? vt(s) - x : -1, ne = B(null), te = B(null);
  return $e(() => {
    const v = ne.current;
    if (v && (p != null && p.current) && te.current === null) {
      te.current = r, v.scrollLeft = p.current.left, v.scrollTop = p.current.top;
      return;
    }
    if (!l || !v || j < 0 || j >= g || te.current === r) return;
    te.current = r;
    const O = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, j * $ + $ / 2 - O / 3);
  }, [l, r, j, g, $, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, y].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && T.current && Y();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: N.current, className: ee.srOnly }, dr),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ee.scroll,
        onScroll: p ? (v) => {
          p.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: u + h } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${u}px ${h}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * $, width: v.days * $ }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.bottom.map((v) => {
        var V;
        const O = r === "day" && (v.key in o || ur(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, O ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * $, width: v.days * $ },
            title: (V = o[v.key]) != null ? V : v.key
          },
          v.days * $ >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: mr } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: u, width: h }, "aria-hidden": "true" }, E.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * $, width: v.days * $ } })), j >= 0 && j < g && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * $ + $ / 2 }, title: "오늘" })), e.map((v) => {
        var z, H, ie, Pe;
        const O = !!v.start && !!v.end && v.start <= v.end, V = D && D.id === v.id ? D : null, Q = O && V && V.delta !== 0 ? ea(v.start, v.end, V.mode, V.delta) : O ? { start: v.start, end: v.end } : null, se = Q ? (vt(Q.start) - x) * $ : 0, L = Q ? ua(Q.start, Q.end) * $ : 0, Z = Math.max(0, Math.min(100, (z = v.progress) != null ? z : 0)), R = m != null && m === v.id, X = M(v), G = !X && c && Q ? _ == null ? void 0 : _(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, R ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: mr }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: h }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", X ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(L, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(H = v.name) != null ? H : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${Z}%` : ""}${v.late ? " 지연" : ""}${G ? ` 잠김: ${G}` : ""}`,
              "aria-describedby": X ? N.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${Z}%` : ""}${v.late ? " · 지연" : ""}${X ? `
끌어 옮기기·양 끝 조절
${dr}` : ""}${G ? `
잠김: ${G}` : ""}`,
              onPointerDown: (xe) => I(xe, v, "move"),
              onPointerMove: q,
              onPointerUp: () => F(v),
              onPointerCancel: Y,
              onClick: (xe) => xe.stopPropagation(),
              onKeyDown: (xe) => W(xe, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${Z}%` } }),
            X && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (xe) => I(xe, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (xe) => I(xe, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (vt(v.markDate) - x + 1) * $ - 1 }, title: (ie = v.markLabel) != null ? ie : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(L, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Pe = v.emptyText) != null ? Pe : "기간 없음"))
        );
      })))
    )
  );
}
const ah = "_board_192fl_3", rh = "_col_192fl_15", oh = "_over_192fl_23", sh = "_head_192fl_25", lh = "_title_192fl_33", ch = "_count_192fl_34", ih = "_hint_192fl_43", uh = "_list_192fl_45", mh = "_empty_192fl_54", dh = "_card_192fl_56", fh = "_sel_192fl_68", _h = "_dragging_192fl_69", ph = "_hasErr_192fl_70", yh = "_dot_192fl_71", bh = "_err_192fl_72", Te = {
  board: ah,
  col: rh,
  over: oh,
  head: sh,
  title: lh,
  count: ch,
  hint: ih,
  list: uh,
  empty: mh,
  card: dh,
  sel: fh,
  dragging: _h,
  hasErr: ph,
  dot: yh,
  err: bh
}, ta = "application/x-axerp-kanban";
function Kk({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: o,
  cardLabel: s,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: f,
  emptyText: _ = "카드가 없습니다",
  moveHint: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = Qt("axe-kb"), [$, g] = A(null), [x, h] = A(null), w = new Map(t.map((M) => [String(a(M)), M])), E = B(null), D = B(null);
  U(() => {
    var q, F;
    const M = D.current;
    if (!M) return;
    if (Date.now() > M.until) {
      D.current = null;
      return;
    }
    const I = Array.from((F = (q = E.current) == null ? void 0 : q.querySelectorAll("[data-kanban-key]")) != null ? F : []).find((Y) => Y.dataset.kanbanKey === M.key);
    I && document.activeElement !== I && I.focus(), D.current = null;
  });
  const C = (M, I) => {
    M.preventDefault(), g(null), h(null);
    const q = M.dataTransfer.getData(ta), F = w.get(q);
    F && r(F) !== I && (l == null || l(F, I));
  }, T = (M, I) => {
    if (M.key === "Enter" || M.key === " ") {
      M.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !M.altKey || M.key !== "ArrowLeft" && M.key !== "ArrowRight" || f != null && f(I)) return;
    M.preventDefault();
    const q = e.findIndex((Y) => Y.key === r(I)), F = q + (M.key === "ArrowLeft" ? -1 : 1);
    q >= 0 && F >= 0 && F < e.length && (D.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[F].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: E, className: [Te.board, y].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((M) => {
    const I = t.filter((q) => r(q) === M.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: M.key,
        className: [Te.col, $ === M.key ? Te.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof M.title == "string" ? M.title : void 0,
        onDragOver: l ? (q) => {
          q.dataTransfer.types.includes(ta) && (q.preventDefault(), g(M.key));
        } : void 0,
        onDragLeave: l ? (q) => {
          q.currentTarget.contains(q.relatedTarget) || g((F) => F === M.key ? null : F);
        } : void 0,
        onDrop: l ? (q) => C(q, M.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Te.head }, /* @__PURE__ */ n.createElement("span", { className: Te.title }, M.title), /* @__PURE__ */ n.createElement("span", { className: Te.count }, I.length), M.hint && /* @__PURE__ */ n.createElement("span", { className: Te.hint }, M.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Te.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Te.empty }, _), I.map((q) => {
        const F = a(q), Y = f == null ? void 0 : f(q), W = u == null ? void 0 : u(q), j = !!l && !Y, ne = Y != null ? Y : j ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: F,
            className: [Te.card, i === F ? Te.sel : "", x === F ? Te.dragging : "", W ? Te.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(F),
            role: "button",
            "aria-label": s == null ? void 0 : s(q),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${N}-h-${String(F)}` : void 0,
            draggable: j,
            onDragStart: j ? (te) => {
              te.dataTransfer.setData(ta, String(F)), te.dataTransfer.effectAllowed = "move", h(F);
            } : void 0,
            onDragEnd: () => {
              h(null), g(null);
            },
            onClick: () => c == null ? void 0 : c(q),
            onKeyDown: (te) => T(te, q)
          },
          ne && /* @__PURE__ */ n.createElement(Lr, { id: `${N}-h-${String(F)}` }, ne),
          (m == null ? void 0 : m(q)) && /* @__PURE__ */ n.createElement("span", { className: Te.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          o(q),
          W && /* @__PURE__ */ n.createElement("p", { className: Te.err, role: "alert" }, W)
        );
      }))
    );
  }));
}
const Eh = "_list_1aqum_2", hh = "_empty_1aqum_3", gh = "_item_1aqum_5", vh = "_row_block_1aqum_6", kh = "_row_warn_1aqum_7", wh = "_head_1aqum_9", Nh = "_mark_1aqum_16", $h = "_msg_1aqum_17", xh = "_count_1aqum_18", Dh = "_aside_1aqum_19", Ah = "_caret_1aqum_20", Ch = "_block_1aqum_22", Sh = "_warn_1aqum_23", Mh = "_info_1aqum_24", Th = "_body_1aqum_29", qh = "_actions_1aqum_30", qe = {
  list: Eh,
  empty: hh,
  item: gh,
  row_block: vh,
  row_warn: kh,
  head: wh,
  mark: Nh,
  msg: $h,
  count: xh,
  aside: Dh,
  caret: Ah,
  block: Ch,
  warn: Sh,
  info: Mh,
  body: Th,
  actions: qh
}, Bh = { block: "■", warn: "▲", info: "●" }, Lh = { block: "차단", warn: "경고", info: "정보" };
function Uk({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [o, s] = A({}), [l, c] = A(e);
  return l !== e && (c(e), s({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${qe.list} ${r}` }, e.map((i) => {
    var _;
    const m = !!i.detail || !!i.actions, u = m && ((_ = o[i.key]) != null ? _ : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${qe.mark} ${qe[i.tone]}`, "aria-label": Lh[i.tone], role: "img" }, Bh[i.tone]), /* @__PURE__ */ n.createElement("span", { className: qe.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${qe.count} ${qe[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: qe.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: qe.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${qe.item} ${qe[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: qe.head,
        "aria-expanded": u,
        onClick: () => s((p) => ({ ...p, [i.key]: !u }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: qe.head }, f), u && /* @__PURE__ */ n.createElement("div", { className: qe.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: qe.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${qe.empty} ${r}` }, t);
}
function jh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), o = (s, l) => Array.from({ length: l - s + 1 }, (c, i) => s + i);
  return a <= 10 ? o(1, a) : r <= 5 ? [...o(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...o(a - 6, a)] : [1, "…", ...o(r - 2, r + 2), "…", a];
}
function Ih(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function Gk(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function Yk(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const Rh = "_nav_1r2z8_1", Ph = "_list_1r2z8_3", Oh = "_btn_1r2z8_4", zh = "_cur_1r2z8_13", Xh = "_gap_1r2z8_15", Fh = "_total_1r2z8_16", Wh = "_jump_1r2z8_17", Hh = "_go_1r2z8_20", Kh = "_size_1r2z8_22", Uh = "_more_1r2z8_24", Gh = "_moreBtn_1r2z8_25", Yh = "_moreN_1r2z8_29", he = {
  nav: Rh,
  list: Ph,
  btn: Oh,
  cur: zh,
  gap: Xh,
  total: Fh,
  jump: Wh,
  in: "_in_1r2z8_18",
  go: Hh,
  size: Kh,
  more: Uh,
  moreBtn: Gh,
  moreN: Yh
};
function Vk({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: o, pageSize: s, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [f, _] = A(String(u));
  U(() => _(String(u)), [u]);
  const p = (d) => {
    d !== u && d >= 1 && d <= m && a(d);
  }, y = () => {
    const d = Ih(f, m);
    if (d === null) {
      _(String(u));
      return;
    }
    _(String(d)), p(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [he.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: he.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: he.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), jh(u, m).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: he.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [he.btn, d === u ? he.cur : ""].filter(Boolean).join(" "),
      onClick: () => p(d),
      "aria-current": d === u ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: he.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: he.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: he.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => _(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: he.go, onClick: y }, "이동")), o && s !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: he.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: s, onChange: (d) => l(Number(d.target.value)) }, o.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function Qk({ shown: e, total: t, onMore: a, busy: r = !1, className: o = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [he.more, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: he.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const Vh = "_ol_fbatg_1", Qh = "_li_fbatg_2", Jh = "_done_fbatg_5", Zh = "_now_fbatg_5", eg = "_item_fbatg_6", tg = "_dot_fbatg_12", ng = "_label_fbatg_19", ag = "_opt_fbatg_21", rg = "_sr_fbatg_22", st = {
  ol: Vh,
  li: Qh,
  done: Jh,
  now: Zh,
  item: eg,
  dot: tg,
  label: ng,
  opt: ag,
  sr: rg
};
function Jk({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [st.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((o, s) => {
    const l = s < t ? "done" : s === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: st.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ n.createElement("span", { className: st.label }, o.label, o.optional && /* @__PURE__ */ n.createElement("span", { className: st.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: st.sr }, " 완료"))), i = !!a && s <= t;
    return /* @__PURE__ */ n.createElement("li", { key: o.key, className: [st.li, st[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: st.item, onClick: () => a(s, o) }, c) : /* @__PURE__ */ n.createElement("span", { className: st.item }, c));
  }));
}
const og = "_root_7y5bc_5", sg = "_block_7y5bc_6", lg = "_svg_7y5bc_7", cg = "_sm_7y5bc_8", ig = "_md_7y5bc_9", ug = "_lg_7y5bc_10", mg = "_track_7y5bc_11", dg = "_bar_7y5bc_12", fg = "_spin_7y5bc_13", _g = "_txt_7y5bc_15", Et = {
  root: og,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: sg,
  svg: lg,
  sm: cg,
  md: ig,
  lg: ug,
  track: mg,
  bar: dg,
  spin: fg,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: _g,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function Zk({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: o = !1, className: s = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Et.root, o ? Et.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [Et.svg, Et[e], l ? "" : Et.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: Et.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: Et.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: Et.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const pg = "_group_vdqk6_1", yg = "_legend_vdqk6_2", bg = "_req_vdqk6_3", Eg = "_opts_vdqk6_4", hg = "_inline_vdqk6_5", gg = "_all_vdqk6_6", vg = "_opt_vdqk6_4", kg = "_compact_vdqk6_11", wg = "_dis_vdqk6_13", Ng = "_radio_vdqk6_14", $g = "_check_vdqk6_14", xg = "_text_vdqk6_16", Dg = "_hint_vdqk6_17", Ag = "_err_vdqk6_18", Cg = "_srOnly_vdqk6_20", me = {
  group: pg,
  legend: yg,
  req: bg,
  opts: Eg,
  inline: hg,
  all: gg,
  opt: vg,
  compact: kg,
  dis: wg,
  radio: Ng,
  check: $g,
  text: xg,
  hint: Dg,
  err: Ag,
  srOnly: Cg
};
function Jr({ legend: e, required: t, hidden: a }) {
  return /* @__PURE__ */ n.createElement("legend", { className: [me.legend, a ? me.srOnly : ""].filter(Boolean).join(" ") }, e, t && /* @__PURE__ */ n.createElement("span", { className: me.req }, " (필수)"));
}
function ew({ name: e, legend: t, options: a, value: r, onChange: o, required: s, disabled: l, error: c, inline: i = !1, className: m = "", legendHidden: u = !1 }) {
  const f = Qt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? f : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Jr, { legend: t, required: s, hidden: u }),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, i ? me.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((_) => /* @__PURE__ */ n.createElement("label", { key: _.value, className: [me.opt, _.disabled ? me.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: me.radio,
        name: e,
        value: _.value,
        checked: r === _.value,
        disabled: _.disabled,
        required: s,
        onChange: () => o(_.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: me.text }, _.label, _.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, _.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: f, className: me.err }, c)
  );
}
function fr({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: o, className: s = "", compact: l = !1, title: c }) {
  return /* @__PURE__ */ n.createElement("label", { title: c, className: [me.opt, l ? me.compact : "", r ? me.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: me.check,
      checked: e,
      disabled: r,
      ref: (i) => {
        i && (i.indeterminate = t && !e);
      },
      onChange: (i) => a(i.target.checked)
    }
  ), o !== void 0 && /* @__PURE__ */ n.createElement("span", { className: me.text }, o));
}
function tw({ legend: e, options: t, value: a, onChange: r, required: o, disabled: s, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Qt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), _ = f.length > 0 && f.every((d) => a.includes(d)), p = f.some((d) => a.includes(d)), y = (d, b) => r(b ? [...a, d] : a.filter((N) => N !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, m].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Jr, { legend: e, required: o }),
    i && /* @__PURE__ */ n.createElement("div", { className: me.all }, /* @__PURE__ */ n.createElement(
      fr,
      {
        checked: _,
        indeterminate: p && !_,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, c ? me.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(fr, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => y(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: me.err }, l)
  );
}
const Sg = "_list_13vw7_1", Mg = "_tag_13vw7_2", Tg = "_main_13vw7_3", qg = "_x_13vw7_6", Bg = "_t_muted_13vw7_10", Lg = "_t_accent_13vw7_11", jg = "_t_ok_13vw7_12", Ig = "_t_warn_13vw7_13", Rg = "_t_danger_13vw7_14", Pg = "_sel_13vw7_16", St = {
  list: Sg,
  tag: Mg,
  main: Tg,
  x: qg,
  t_muted: Bg,
  t_accent: Lg,
  t_ok: jg,
  t_warn: Ig,
  t_danger: Rg,
  sel: Pg
};
function nw({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: o, removeLabel: s, disabled: l, className: c = "" }) {
  const i = [St.tag, St[`t_${t}`], a ? St.sel : "", c].filter(Boolean).join(" "), m = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: St.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: St.main }, e), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: St.x, onClick: o, disabled: l, "aria-label": m }, "✕"));
}
function aw({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [St.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, o) => /* @__PURE__ */ n.createElement("li", { key: o }, r)));
}
const Og = "_acc_1lmty_1", zg = "_item_1lmty_2", Xg = "_h_1lmty_3", Fg = "_btn_1lmty_4", Wg = "_title_1lmty_8", Hg = "_meta_1lmty_9", Kg = "_chev_1lmty_10", Ug = "_open_1lmty_11", Gg = "_body_1lmty_12", lt = {
  acc: Og,
  item: zg,
  h: Xg,
  btn: Fg,
  title: Wg,
  meta: Hg,
  chev: Kg,
  open: Ug,
  body: Gg
};
function rw({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: o, headingLevel: s = 3, className: l = "" }) {
  const [c, i] = A(a), m = r != null ? r : c, u = Qt("axe-acc"), f = `h${s}`, _ = (p) => {
    const y = m.includes(p) ? m.filter((d) => d !== p) : t ? [p] : [...m, p];
    r === void 0 && i(y), o == null || o(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [lt.acc, l].filter(Boolean).join(" ") }, e.map((p) => {
    const y = m.includes(p.key), d = `${u}-b-${p.key}`, b = `${u}-p-${p.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: p.key, className: [lt.item, y ? lt.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: lt.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: lt.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: p.disabled,
        onClick: () => _(p.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: lt.title }, p.title),
      p.meta && /* @__PURE__ */ n.createElement("span", { className: lt.meta }, p.meta),
      /* @__PURE__ */ n.createElement("span", { className: lt.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !y, className: lt.body }, p.content));
  }));
}
const Yg = "_stack_1u83j_2", Vg = "_toast_1u83j_3", Qg = "_t_danger_1u83j_9", Jg = "_ico_1u83j_10", Zg = "_t_ok_1u83j_11", ev = "_msg_1u83j_12", tv = "_act_1u83j_13", nv = "_x_1u83j_15", Mt = {
  stack: Yg,
  toast: Vg,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: Qg,
  ico: Jg,
  t_ok: Zg,
  msg: ev,
  act: tv,
  x: nv
}, Zr = jn(null);
let av = 0;
function ow() {
  const e = Ln(Zr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function rv({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = A(!1), o = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  U(() => {
    if (a || o === 0) return;
    const i = window.setTimeout(t, o);
    return () => window.clearTimeout(i);
  }, [a, o, t, e.message]);
  const s = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Mt.toast, Mt[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Mt.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Mt.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Mt.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Mt.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function sw({ children: e }) {
  const [t, a] = A([]), r = B(t);
  r.current = t;
  const o = re((c) => a((i) => i.filter((m) => m.id !== c)), []), s = re((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((f) => f.message === i.message);
    if (m)
      return a((f) => f.map((_) => _.id === m.id ? { ..._, ...i } : _)), m.id;
    const u = ++av;
    return a((f) => [...f, { ...i, id: u }].slice(-3)), u;
  }, []), l = ke(() => ({ toast: s, dismiss: o }), [s, o]);
  return /* @__PURE__ */ n.createElement(Zr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Mt.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(rv, { key: c.id, item: c, onClose: () => o(c.id) }))));
}
const ov = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function sv(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const lv = "_grid_yplhe_1", cv = "_group_yplhe_2", iv = "_h_yplhe_3", uv = "_list_yplhe_4", mv = "_row_yplhe_5", dv = "_keys_yplhe_6", fv = "_text_yplhe_7", _v = "_or_yplhe_8", pv = "_kbd_yplhe_9", ct = {
  grid: lv,
  group: cv,
  h: iv,
  list: uv,
  row: mv,
  keys: dv,
  text: fv,
  or: _v,
  kbd: pv
};
function yv({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...ov];
  return /* @__PURE__ */ n.createElement(Xn, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ct.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ct.group }, /* @__PURE__ */ n.createElement("h3", { className: ct.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ct.list }, r.items.map((o, s) => /* @__PURE__ */ n.createElement("div", { key: s, className: ct.row }, /* @__PURE__ */ n.createElement("dt", { className: ct.keys }, o.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ct.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ct.text }, o.text))))))));
}
function bv(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function lw(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, o] = A(!1);
  return U(() => {
    if (!t) return;
    const s = (l) => {
      sv(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, bv(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), o(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [t]), { open: () => o(!0), dialog: r ? /* @__PURE__ */ n.createElement(yv, { extra: a, onClose: () => o(!1) }) : null };
}
const _r = 30, Ev = BigInt(10);
function Yt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * Ev;
  return t;
}
function ut(e, t = 0) {
  return { u: e, s: t };
}
const eo = ut(BigInt(0));
function to(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Yt(a - e.s), t.u * Yt(a - t.s), a];
}
function yn(e, t) {
  const [a, r, o] = to(e, t);
  return ut(a + r, o);
}
function Na(e, t) {
  const [a, r, o] = to(e, t);
  return ut(a - r, o);
}
function Ze(e, t) {
  return ut(e.u * t.u, e.s + t.s);
}
function jt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Yt(t.s + _r), r = t.u * Yt(e.s);
  return ut(a / r, _r);
}
function no(e) {
  return ut(-e.u, e.s);
}
function mt(e, t, a) {
  if (t >= e.s)
    return ut(e.u * Yt(t - e.s), t);
  const r = Yt(e.s - t), o = e.u < BigInt(0), s = o ? -e.u : e.u, l = s / r, c = s % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, ut(o ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o) + r.slice(o + 1), l = o < 0 ? 0 : r.length - o - 1, c = BigInt(s === "" ? "0" : s);
  return ut(a ? -c : c, l);
}
function $a(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : eo);
}
function Ke(e, t = e.s, a = !1) {
  const r = mt(e, Math.max(t, 0), "half"), o = r.u < BigInt(0), s = (o ? -r.u : r.u).toString().padStart(t + 1, "0"), l = s.length - t;
  let c = s.slice(0, l);
  const i = s.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (o ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function ma(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Ht({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), o = e + 4800 - r, s = t + 12 * r - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) - 32045;
}
function ao(e, t) {
  const a = Ht(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), o = a - Math.floor(146097 * r / 4), s = Math.floor((4 * o + 3) / 1461), l = o - Math.floor(1461 * s / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + s - 4800 + Math.floor(c / 10)
  };
}
function ro(e, t, a = "exclude-first") {
  const r = Ht(e) > Ht(t), o = r ? t : e, s = r ? e : t, l = a === "include-first", c = Ht(s) - Ht(o) + (l ? 1 : 0), i = l ? ao(s, 1) : s;
  let m = i.y - o.y, u = i.m - o.m, f = i.d - o.d;
  if (f < 0) {
    u -= 1;
    const _ = i.m === 1 ? 12 : i.m - 1, p = i.m === 1 ? i.y - 1 : i.y;
    f += Le(p, _);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d: f, swapped: r };
}
function Bn(e, t) {
  return ao(e, t);
}
function pr(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = a % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
const hv = ["월", "화", "수", "목", "금", "토", "일"];
function da(e) {
  return hv[Ht(e) % 7];
}
function ze(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const rn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], na = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function yr(e) {
  var t;
  return (t = na[e]) != null ? t : e in na ? na[e] : null;
}
function fa(e, t) {
  return e.find((a) => a.code === t);
}
function oo(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function so(e, t, a, r) {
  const o = fa(e, a), s = fa(e, r);
  if (!o || !s) return null;
  const l = be(o.krw), c = be(s.krw), i = be(String(o.per)), m = be(String(s.per));
  if (!l || !c || !i || !m) return null;
  const u = jt(Ze(t, l), i);
  if (!u) return null;
  const f = jt(Ze(u, m), c);
  return f ? {
    value: mt(f, 2, "half"),
    notice: `${oo(o)} · 참고용 환율`
  } : null;
}
function gv(e, t) {
  let a = null;
  for (const o of e)
    if (o.value) {
      if (a === null) {
        a = o.sign === "-" ? no(o.value) : o.value;
        continue;
      }
      switch (o.sign) {
        case "+":
          a = yn(a, o.value);
          break;
        case "-":
          a = Na(a, o.value);
          break;
        case "*":
          a = Ze(a, o.value);
          break;
        default: {
          const s = jt(a, o.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const r = a != null ? a : eo;
  return { ok: !0, value: t ? mt(r, t.digits, t.mode) : r };
}
const br = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function ln() {
  return { sign: "+", text: "" };
}
function vv(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o), l = o < 0 ? "" : "." + r.slice(o + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function kv(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function wv(e) {
  const { lines: t, onLines: a, active: r, onActive: o, digits: s, onDigits: l, mode: c, onMode: i } = e, m = B([]), u = Math.min(r, t.length - 1);
  U(() => {
    var g;
    (g = m.current[u]) == null || g.focus();
  }, [u, t.length]);
  const f = gv(kv(t), { digits: s, mode: c }), _ = f.ok ? Ke(f.value, s, !0) : "0으로 나눌 수 없음", p = (g, x) => {
    a(t.map((h, w) => w === g ? { ...h, ...x } : h));
  }, y = (g = t.length, x = "") => {
    const h = [...t];
    h.splice(g, 0, { ...ln(), text: x }), a(h), o(g);
  }, d = (g) => {
    if (t.length === 1) {
      a([ln()]);
      return;
    }
    a(t.filter((x, h) => h !== g)), o(Math.max(0, g - 1));
  }, b = () => {
    f.ok && y(t.length, Ke(f.value, s, !0));
  }, N = (g, x) => {
    const h = g.key, w = Nv(h);
    if (w && !(h === "-" && t[x].text === "")) {
      g.preventDefault(), p(x, { sign: w });
      return;
    }
    if (h === "v" || h === "V") {
      g.preventDefault(), b();
      return;
    }
    h === "Enter" ? (g.preventDefault(), x === t.length - 1 ? y() : o(x + 1)) : h === "ArrowDown" ? (g.preventDefault(), o(Math.min(x + 1, t.length - 1))) : h === "ArrowUp" ? (g.preventDefault(), o(Math.max(x - 1, 0))) : h === "Insert" ? (g.preventDefault(), y(x + 1)) : h === "Delete" && t[x].text === "" ? (g.preventDefault(), d(x)) : h === "F4" && (g.preventDefault(), $());
  }, $ = () => {
    a([ln()]), o(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "행 추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(u) }, "행 삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: $ }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, br.map((g) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: g.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[u]) == null ? void 0 : x.sign) === g.key,
        onClick: () => p(u, { sign: g.key })
      },
      g.label,
      " (",
      g.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: s, onChange: (g) => l(Number(g.target.value)) }, [0, 1, 2, 3, 4].map((g) => /* @__PURE__ */ n.createElement("option", { key: g, value: g }, g))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (g) => i(g.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((g, x) => {
    var h;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (h = br.find((w) => w.key === g.sign)) == null ? void 0 : h.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (w) => {
          m.current[x] = w;
        },
        value: g.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => o(x),
        onChange: (w) => p(x, { text: vv(w.target.value) }),
        onKeyDown: (w) => N(w, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, _))));
}
function Nv(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function $v(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let o = a;
      for (; o < e.length && (e[o] >= "0" && e[o] <= "9" || e[o] === "." || e[o] === ","); ) o += 1;
      const s = be(e.slice(a, o));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = o;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class xv {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? yn(t.value, r.value) : Na(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: Ze(t.value, r.value) };
      else {
        const o = jt(t.value, r.value);
        if (!o) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: o };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? no(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function Dv(e) {
  const t = $v(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new xv(t).parse();
}
const cn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], Av = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function Cv(e, t) {
  return e.replace(/오늘/g, ze(t)).replace(/내일/g, ze(Bn(t, 1))).replace(/어제/g, ze(Bn(t, -1)));
}
function Sv(e) {
  const t = [];
  for (const a of e.matchAll(Av)) {
    const r = ma(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const Mv = /부터|까지|에서|일수|며칠|기간|차이|~/;
function Tv(e, t) {
  if (t.length < 2 || !Mv.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = ro(t[0], t[1], a ? "include-first" : "exclude-first"), o = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ze(t[0])} ~ ${ze(t[1])} 기간(${o})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const qv = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Bv(e, t) {
  if (t.length !== 1) return null;
  const a = qv.exec(e);
  if (!a) return null;
  const r = Number(a[1]), o = a[3] === "전" || a[3] === "이전", s = o ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = Bn(l, s) : a[2] === "주" ? c = Bn(l, s * 7) : a[2] === "년" ? c = pr(l, s * 12) : c = pr(l, s), {
    ok: !0,
    explain: `${ze(l)} 에서 ${r}${a[2]} ${o ? "전" : "후"}`,
    value: `${ze(c)} (${da(c)})`
  };
}
function Lv(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? lo(a[2]) : null, o = be(a[1]);
  if (!o) return null;
  const s = r ? Ze(o, r) : o, l = yr(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : yr(jv(e));
  if (!i || i === l) return null;
  const m = so(t, s, l, i);
  return m ? {
    ok: !0,
    explain: `${Ke(s, s.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ke(m.value, 2, !0)} ${i}`
  } : null;
}
function jv(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const Iv = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function lo(e) {
  var t;
  return (t = be(Iv[e])) != null ? t : $a(1);
}
const Rv = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Pv = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Ov(e) {
  return e.replace(Rv, (t) => {
    let a = be("0"), r = !1;
    for (const o of t.matchAll(Pv)) {
      const s = be(o[1]);
      s && (r = !0, a = yn(a, o[2] ? Ze(s, lo(o[2])) : s));
    }
    return r ? Ke(a, a.s) : t;
  });
}
const zv = /원화|원|엔|씩|개월|개|명|건/g;
function Xv(e) {
  return Ov(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(zv, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Fv = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Wv(e, t, a) {
  const r = be("1"), o = Ke(Ze(t, $a(100)), 0);
  if (a === "add")
    return {
      value: mt(Ze(e, yn(r, t)), 0, "half"),
      explain: `消費税 ${o}% 가산(税抜 기준)`
    };
  const s = jt(Ze(e, t), yn(r, t));
  return {
    value: s ? mt(s, 0, "down") : e,
    explain: `消費税 ${o}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Hv(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: cn };
  const r = Cv(a, t.today), o = Sv(r), s = Tv(r, o);
  if (s) return s;
  const l = Bv(r, o);
  if (l) return l;
  const c = Lv(r, (i = t.rates) != null ? i : []);
  return c || Kv(r, t);
}
function Kv(e, t) {
  var m, u;
  const a = Fv.exec(e), r = a ? e.slice(0, a.index) : e, o = Xv(r);
  if (!o) return { ok: !1, supported: cn };
  const s = Dv(o);
  if (!s.ok)
    return { ok: !1, supported: cn };
  if (!a)
    return { ok: !0, explain: o, value: Er(s.value), expr: o };
  const l = (u = (m = Uv(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...cn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Wv(s.value, l, c);
  return {
    ok: !0,
    explain: `${o} · ${i.explain}`,
    value: Er(i.value),
    expr: o
  };
}
function Uv(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = jt(t, $a(100))) != null ? a : null;
}
function Er(e) {
  const t = mt(e, 2, "half"), a = mt(t, 0, "down");
  return Na(t, a).u === BigInt(0) ? Ke(t, 0, !0) : Ke(t, 2, !0);
}
const He = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function hr(e, t) {
  const a = He[e].units.find((o) => o.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function Gv(e, t, a, r, o = 4, s = "half") {
  const l = hr(e, t), c = hr(e, a);
  if (!l || !c) return null;
  const i = jt(Ze(r, l), c);
  return i ? mt(i, o, s) : null;
}
const Yv = [0, 1, 2, 3, 4, 6], Vv = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Qv(e) {
  const { tab: t, onTab: a, seed: r, onClose: o, history: s, onHistory: l } = e, [c, i] = A(() => r == null ? [ln()] : [{ sign: "+", text: Ke(r0(r), 0, !0) }]), [m, u] = A(0), [f, _] = A(0), [p, y] = A("half"), d = B(null);
  U(() => {
    const N = ($) => {
      $.key === "Escape" && ($.preventDefault(), o());
    };
    return document.addEventListener("keydown", N), () => document.removeEventListener("keydown", N);
  }, [o]), U(() => {
    var N, $;
    ($ = (N = d.current) == null ? void 0 : N.querySelector("[data-autofocus]")) == null || $.focus();
  }, [t]);
  const b = (N) => {
    const $ = [...c.filter((g) => g.text !== ""), { sign: "+", text: N }, ln()];
    i($), u($.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: o }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, Vv.map((N) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: N.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": N.key === t,
      onClick: () => a(N.key)
    },
    N.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(e0, { history: s, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    wv,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: f,
      onDigits: _,
      mode: p,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(t0, null), t === "unit" && /* @__PURE__ */ n.createElement(n0, null), t === "fx" && /* @__PURE__ */ n.createElement(a0, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: o }, "닫기"))));
}
const Jv = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Zv = 20;
function e0({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, o] = A(""), [s, l] = A(null), [c, i] = A(!1), [m, u] = A(!1), f = B(!1), _ = ke(xa, []), p = (d) => {
    o(d), u(!1);
    const b = Hv(d, { today: _, rates: rn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((N) => N !== d)].slice(0, Zv));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => o(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), p(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, Jv.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => p(d) }, d))), s && (s.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(s.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : cn).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => p(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function t0() {
  const e = ke(xa, []), [t, a] = A(ze(e)), [r, o] = A(ze(e)), [s, l] = A("exclude-first"), c = ma(t), i = ma(r), m = c && i ? ro(c, i, s) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: s, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => o(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ze(c), "(", da(c), ") ~ ", ze(i), "(", da(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function n0() {
  const [e, t] = A("area"), [a, r] = A(He.area.units[0].key), [o, s] = A(He.area.units[4].key), [l, c] = A(""), [i, m] = A(4), [u, f] = A("half"), _ = (d) => {
    t(d), r(He[d].units[0].key), s(He[d].units[1].key), c("");
  }, p = be(l), y = p ? Gv(e, a, o, p, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => _(d.target.value) }, Object.keys(He).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, He[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", He[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: o, onChange: (d) => s(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => m(Number(d.target.value)) }, Yv.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, gr(e, a), " → ", gr(e, o), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ke(y, i, !0) : "—")));
}
function gr(e, t) {
  var a, r;
  return (r = (a = He[e].units.find((o) => o.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function a0() {
  const e = ke(xa, []), [t, a] = A(ze(e)), [r, o] = A("JPY"), [s, l] = A("KRW"), [c, i] = A(""), m = be(c), u = m ? so(rn, m, r, s) : null, f = fa(rn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (_) => a(_.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (_) => i(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (_) => o(_.target.value) }, rn.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: s, onChange: (_) => l(_.target.value) }, rn.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? oo(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ke(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function xa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function r0(e) {
  var t;
  return mt((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const co = jn(null);
function cw({ children: e }) {
  const [t, a] = A(!1), [r, o] = A("text"), [s, l] = A(null), [c, i] = A([]), [m, u] = A(0), f = ke(() => ({
    open: (_) => {
      var p, y;
      o((p = _ == null ? void 0 : _.tab) != null ? p : "text"), l((y = _ == null ? void 0 : _.seed) != null ? y : null), u((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(co.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    Qv,
    {
      key: m,
      tab: r,
      onTab: o,
      seed: s,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function iw() {
  var e;
  return (e = Ln(co)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class uw extends vr {
  constructor() {
    super(...arguments), this.rootRef = mo(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new Ar(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  J0 as $,
  rw as A,
  Nk as B,
  Qv as C,
  $p as D,
  _k as E,
  hk as F,
  ck as G,
  ik as H,
  Hk as I,
  C0 as J,
  Yo as K,
  zc as L,
  qr as M,
  A0 as N,
  mn as O,
  ra as P,
  xk as Q,
  Kk as R,
  Ck as S,
  Sk as T,
  ya as U,
  Qk as V,
  jk as W,
  Rk as X,
  Pk as Y,
  Q0 as Z,
  Xn as _,
  ys as a,
  c0 as a$,
  a_ as a0,
  Dk as a1,
  tk as a2,
  Ik as a3,
  No as a4,
  _0 as a5,
  vk as a6,
  Vk as a7,
  D0 as a8,
  y0 as a9,
  z0 as aA,
  N0 as aB,
  wk as aC,
  Dr as aD,
  nw as aE,
  aw as aF,
  G_ as aG,
  Ko as aH,
  sw as aI,
  mk as aJ,
  It as aK,
  j0 as aL,
  ek as aM,
  S0 as aN,
  Lr as aO,
  zk as aP,
  Ok as aQ,
  Fr as aR,
  r_ as aS,
  ov as aT,
  m0 as aU,
  d0 as aV,
  f0 as aW,
  u0 as aX,
  vo as aY,
  An as aZ,
  wr as a_,
  Wk as aa,
  qk as ab,
  Lk as ac,
  ab as ad,
  Bk as ae,
  tp as af,
  Mk as ag,
  ew as ah,
  uk as ai,
  x0 as aj,
  h0 as ak,
  $0 as al,
  Y_ as am,
  yv as an,
  g0 as ao,
  k0 as ap,
  v0 as aq,
  X0 as ar,
  P0 as as,
  O0 as at,
  R0 as au,
  Zk as av,
  w0 as aw,
  Ak as ax,
  Ya as ay,
  Jk as az,
  b0 as b,
  ak as b$,
  i0 as b0,
  Rr as b1,
  Vt as b2,
  uw as b3,
  Ar as b4,
  Zn as b5,
  Ea as b6,
  Z0 as b7,
  qm as b8,
  ap as b9,
  ci as bA,
  ni as bB,
  rp as bC,
  Yr as bD,
  Tp as bE,
  Yl as bF,
  Cr as bG,
  Gl as bH,
  Ps as bI,
  Cp as bJ,
  Gk as bK,
  $E as bL,
  ko as bM,
  Kt as bN,
  Vr as bO,
  Pr as bP,
  Y0 as bQ,
  Nm as bR,
  K0 as bS,
  T0 as bT,
  M0 as bU,
  Vc as bV,
  q0 as bW,
  ti as bX,
  Ir as bY,
  fk as bZ,
  iw as b_,
  oa as ba,
  zi as bb,
  Xi as bc,
  Sr as bd,
  pk as be,
  xp as bf,
  Ul as bg,
  rk as bh,
  sv as bi,
  Ql as bj,
  ly as bk,
  ps as bl,
  p0 as bm,
  Vl as bn,
  ba as bo,
  Yk as bp,
  jh as bq,
  Ih as br,
  qn as bs,
  Ft as bt,
  J_ as bu,
  tn as bv,
  Gr as bw,
  Z_ as bx,
  Ga as by,
  U0 as bz,
  n_ as c,
  o_ as c0,
  dk as c1,
  Up as c2,
  nk as c3,
  lk as c4,
  sk as c5,
  Tk as c6,
  I0 as c7,
  ok as c8,
  lw as c9,
  E0 as ca,
  ow as cb,
  L0 as cc,
  Qt as cd,
  Sb as ce,
  Xk as d,
  et as e,
  cw as f,
  V0 as g,
  Br as h,
  tw as i,
  Uk as j,
  fr as k,
  Ek as l,
  H0 as m,
  W0 as n,
  kk as o,
  F0 as p,
  yk as q,
  bk as r,
  gk as s,
  Pa as t,
  G0 as u,
  Fk as v,
  $k as w,
  B0 as x,
  Ur as y,
  Kl as z
};
